import { Component, ɵConsole } from "@angular/core";
import { ChangeDetectorRef } from '@angular/core';
import { NgZone } from '@angular/core';
import {
  NavController,
  ModalController,
  AlertController,
  Alert,
} from "ionic-angular";
import * as moment from "moment";
import { VariablesProvider } from "../../providers/variables/variables";
import { FuncionesProvider } from "../../providers/funciones/funciones";
import { PicajesPage } from "../../pages/picajes/picajes";

import { InformesPage } from "../../pages/informes/informes";
import {
  CalendarModal,
  CalendarModalOptions,
  DayConfig,
  CalendarResult,
} from "ion2-calendar";
import { CalendarComponentOptions } from "ion2-calendar";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Storage } from "@ionic/storage";
import * as XLSX from "../../xlsx";
import * as jsPDF from "../../jspdf";
//import * as html2canvas from 'html2canvas';
import { File } from "@ionic-native/file";
import { CONTENT_ATTR } from "@angular/platform-browser/src/dom/dom_renderer";
import { Console } from "@angular/core/src/console";
import { VacacionesPage } from "../../pages/vacaciones/vacaciones";
import { dibujarDetalle, fechaDetalle } from './pdf-detalle';
import { CargaLista } from './carga-lista';
import { AhoritaAprendizaje, CasoAprendizajeIA } from '../../providers/ahorita-aprendizaje';

@Component({
  selector: "page-list",
  templateUrl: "list.html",
})
export class ListPage {

  // === Helpers de tiempo (compatibles ES5, sin padStart) ===
  private twoDigits(n: number): string { return (n < 10 ? "0" : "") + n; }
  private hhmmToMin(hhmm: any): number {
    if (hhmm == null) return 0;
    const s = String(hhmm).trim();
    if (!s) return 0;
    const parts = s.split(":");
    const h = parseInt(parts[0], 10) || 0;
    const m = parseInt((parts[1] || "0"), 10) || 0;
    return h * 60 + m;
  }
  private minToHHMM(mins: number): string {
    if (!isFinite(mins)) return "00:00";
    const abs = Math.abs(mins);
    const h = Math.floor(abs / 60);
    const m = abs % 60;
    return this.twoDigits(h) + ":" + this.twoDigits(m);
  }
  private asMinutes(v: any): number {
    if (v == null || v === "") return 0;
    if (typeof v === "number") return v < 24 ? Math.round(v * 60) : Math.round(v);
    const s = String(v).trim();
    if (!s) return 0;
    if (s.indexOf(":") !== -1) {
      const [hh, mm] = s.split(":");
      const h = parseInt(hh, 10) || 0;
      const m = parseInt(mm || "0", 10) || 0;
      return h * 60 + m;
    }
    const n = Number(s.replace(",", "."));
    if (!isFinite(n)) return 0;
    return n < 24 ? Math.round(n * 60) : Math.round(n);
  }
  private formatDiffHoras(mins: number): string {
    if (!isFinite(mins)) return "00:00";
    const sign = mins < 0 ? "-" : (mins > 0 ? "+" : "");
    const abs = Math.abs(mins);
    const h = Math.floor(abs / 60);
    const m = abs % 60;
    return (sign ? sign : "") + this.twoDigits(h) + ":" + this.twoDigits(m);
  }
  private horaValida(hora: any): boolean {
    const valor = String(hora == null ? "" : hora).trim();
    const partes = valor.match(/^(\d{1,2}):(\d{2})$/);
    if (!partes) { return false; }
    const horas = Number(partes[1]);
    const minutos = Number(partes[2]);
    return horas >= 0 && horas < 24 && minutos >= 0 && minutos < 60;
  }

  obras;
  diasdefiesta;
  myForm: FormGroup;
  myForm1: FormGroup;
  misapp: Array<{
    title: string;
    descripcion: string;
    imagen: string;
    component: any;
  }>;
  formulario = {
    codigo1: "",
    nombre1: "",
    empresa1: "",
    obra1: "",
    turno1: "",
    horas1: "",
    activo1: "",
  };
  resultado;
  date: string;
  type: "string"; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  minuto = []; //= {valor: "1",color: "1"}
  color = []; //= {valor: "1",color: "1"}
  cabecera = []; //= {valor: "1",color: "1"}
  trabajadores;
  valo = "654321123456";
  formulario2 = { valor: "" };
  muestragif;
  filtrotrabajador;
  filtroobra;
  filtrofecha;
  FechaIni: any;
  FechaFin: any;
  campo_trabajador: any;
  valortrabajador;
  valorempresa;
  valorobra;
  valorturno;
  valorinforme;
  tipodeinforme;
  imagenactual;
  ORDENADO;
  ASC;
  Informe;
  cuenta;
  totalhorasextras = "00:00";
  totalhorasordinarias = "00:00";
  generandoInforme = false;
  porcentajeInforme = 0;
  mensajeInforme = "Generando informe...";
  generandoPdfDetalle = false;
  pdfDetalleConfigurado = false;
  imagenAhoritaError = false;
  private pdfDetalleConfiguracionLeida = false;
  cargandoLista = false;
  errorCargaLista = '';
  errorCargaIncidencias = '';
  private cargaLista: CargaLista;
  private cargaIncidencias: CargaLista;
  private versionLista = 0;
  private filtroLista: any;
  private listaVisitada = false;
  private cargandoNovedad = false;
  private asignacionesTurnos: { [clave: string]: any } = {};
  private asignacionesMesesCargados: { [mes: string]: boolean } = {};

  faltaPicadaFinal(trabajador: any): boolean {
    if (trabajador && trabajador._PICADA_VIRTUAL_MEDIANOCHE) { return false; }
    const valor = trabajador && trabajador.PICADA_FINAL != null ? String(trabajador.PICADA_FINAL).trim().toLowerCase() : '';
    return valor === '' || valor === 'no' || valor === '24:00';
  }

  private claveAsignacion(fecha: any, codigo: any): string {
    return String(fecha || '').substr(0, 10) + '|' + String(codigo || '').trim();
  }

  private mesDeFecha(fecha: any): string {
    const valor = String(fecha || '').substr(0, 10);
    return /^\d{4}-\d{2}-\d{2}$/.test(valor) ? valor.substr(0, 7) : '';
  }

  private async cargarAsignacionesMes(fecha: any): Promise<void> {
    const mes = this.mesDeFecha(fecha);
    if (!mes || this.asignacionesMesesCargados[mes]) { return; }
    const partes = mes.split('-');
    const usuario = this.variables.CLIENTES_RAZSOCIAL || '';
    try {
      const filas = await this.funciones.obtieneAsignacionesMesTodas(usuario, Number(partes[0]), Number(partes[1])).toPromise();
      (filas || []).forEach((fila: any) => {
        if (fila && fila.fecha && fila.trabajador && fila.turno_id !== null && fila.turno_id !== undefined && fila.turno_id !== '') {
          this.asignacionesTurnos[this.claveAsignacion(fila.fecha, fila.trabajador)] = fila;
        }
      });
    } catch (error) {
      // Las instalaciones antiguas pueden no tener todavía la ruta global.
      // La lista sigue funcionando con el turno fijo del trabajador.
      console.log('No se pudieron cargar las asignaciones de turnos', error);
    }
    this.asignacionesMesesCargados[mes] = true;
  }

  private turnoAsignado(codigo: any, fecha: any): any {
    return this.asignacionesTurnos[this.claveAsignacion(fecha, codigo)] || null;
  }

  private diaTurno(fecha: any): string {
    const dia = new Date(String(fecha).substr(0, 10) + 'T00:00:00Z').getUTCDay();
    return ['D', 'L', 'M', 'X', 'J', 'V', 'S'][dia];
  }

  private buscarTurno(asignacion: any, turnos: any[]): any {
    const id = asignacion && asignacion.turno_id;
    const nombre = String(asignacion && asignacion.turno || '').trim().toLowerCase();
    return (turnos || []).find((turno: any) =>
      (id !== null && id !== undefined && String(turno.ID) === String(id)) ||
      (nombre && String(turno.NOMBRE || turno.TURNO || '').trim().toLowerCase() === nombre)
    ) || null;
  }

  private aplicarTurnoAsignadoFila(fila: any, asignacion: any, turnos: any[], fecha: string): void {
    if (!fila || !asignacion) { return; }
    const turno = this.buscarTurno(asignacion, turnos);
    const nombre = turno ? (turno.NOMBRE || turno.TURNO) : asignacion.turno;
    if (nombre) { fila.TURNO = nombre; }
    if (!turno) { return; }
    const dia = this.diaTurno(fecha);
    if (turno[dia] !== undefined) { fila.HORAS_PREVISTAS = turno[dia]; }
    ['HORA_ENTRADA', 'HORA_SALIDA', 'CORTESIA', 'ALMUERZO', 'CENA', 'MODO'].forEach(campo => {
      if (turno[campo] !== undefined) { fila[campo] = turno[campo]; }
    });
  }

  private aplicarTurnoAsignadoTrabajador(trabajador: any, fecha: string, turnos: any[]): void {
    const asignacion = this.turnoAsignado(trabajador && trabajador.CODIGO, fecha);
    if (!asignacion) { return; }
    const turno = this.buscarTurno(asignacion, turnos);
    const nombre = turno ? (turno.NOMBRE || turno.TURNO) : asignacion.turno;
    if (nombre) { trabajador.TURNO = nombre; }
  }

  private async aplicarAsignacionesAfilas(filas: any[], turnos: any[]): Promise<any[]> {
    const lista = Array.isArray(filas) ? filas : [];
    const meses: { [mes: string]: boolean } = {};
    lista.forEach(fila => { const mes = this.mesDeFecha(fila && fila.FECHA); if (mes) { meses[mes] = true; } });
    for (const mes of Object.keys(meses)) { await this.cargarAsignacionesMes(mes + '-01'); }
    let fechaActual = '';
    let codigoActual = '';
    lista.forEach(fila => {
      if (fila && /^\d{4}-\d{2}-\d{2}$/.test(String(fila.FECHA || ''))) { fechaActual = fila.FECHA; }
      if (fila && fila.CODIGO) { codigoActual = fila.CODIGO; }
      const asignacion = this.turnoAsignado(codigoActual, fechaActual);
      if (asignacion) { this.aplicarTurnoAsignadoFila(fila, asignacion, turnos, fechaActual); }
    });
    return lista;
  }

  private detectarCambiosLista(): void {
    // Algunas instalaciones antiguas de Ionic reciben estas respuestas fuera
    // de la zona de Angular. Repintamos la vista sin lanzar otra consulta.
    try {
      const repintar = () => this.cdr.detectChanges();
      if (this.zone && this.zone.run) { this.zone.run(repintar); } else { repintar(); }
    } catch (error) { /* la vista puede cerrarse */ }
  }

  private actualizarProgresoInforme(porcentaje: number, mensaje: string): void {
    this.porcentajeInforme = Math.max(0, Math.min(100, Math.round(porcentaje)));
    this.mensajeInforme = mensaje;
    try {
      this.cdr.detectChanges();
    } catch (error) { /* la vista puede haberse cerrado */ }
  }

  private dejarPintarInterfaz(): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, 0));
  }
  meses: Array<string> = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];
  
  public mostrarerror = false;
  datosacceso;
  usuariodatos;
  id;
  subtema;
  code;
  email;
  contrasena;
  usuarioacceso;
  fileName: string;

  pages: Array<{ title: string; component: any }>;
  usuarioaccesoarray: Array<{ usuarioacceso: string }>;

  usuariodatosarray: Array<{ usuariodatos: string }>;
  informetrabajadores;
  informetrabajadorespdf;
  informetrabajadoressindetalles;
  informetrabajadoressindetallespdf;

  informetrabajadoressindetallesxls = []; 
  
  num: any;
 
  trabajadores2;
  hg;
  hp;
  mg;
  mp;
  hg1;
  hp1;
  mg1;
  mp1;
  hg2;
  hp2;
  mg2;
  mp2;
  HIni;
  HFin;
  Aleatorio;
  MIni;
  Mfin;
  SUMAEXTRAS;
  SUMAMINUTOSEXTRAS;
  SUMAEXTRASFIESTAS;
  SUMAMINUTOSFIESTAS;
  SUMAEXTRASPDF;
  SUMAMINUTOSEXTRASPDF;
  SUMAEXTRASFIESTASPDF;
  SUMAMINUTOSFIESTASPDF;
  empresas;
  sobras;
  turnos;
  incidencias;
  private incidenciasPendientesPorTrabajador: { [clave: string]: boolean } = {};

  public users;
  public trabaja;
  DIAdehoy;
  ultimomes;
  MESHOY;
  anohoy;
  dia;
  fiesta;
  doc = new jsPDF();

  totalCasosIA: number = 5;

  mostrarPanelIA: boolean = false;
  private picadasAhoritaIA: any = {};
  cargandoPicadasAhoritaIA = false;
  private fechaPicadasAhoritaIA = '';
  trabajadorAhoritaIA = '';
  preguntaAhoritaIA = '';
  respuestaAhoritaIA = '';
  analizandoAhoritaIA = false;
  errorAhoritaIA = '';
  aprendizajeRecienteIA: CasoAprendizajeIA | null = null;
  casosParecidosAprendizajeIA: any[] = [];
  buscandoParecidosAprendizajeIA = false;
  mensajeParecidosAprendizajeIA = '';

  optionsRange: CalendarModalOptions = {
    color: "dark",
    weekStart: 1,
    weekdays: ["DO", "LU", "MA", "MI", "JU", "VI", "SA"],
    canBackwardsSelected: true,
    cssClass: "my-day",
    daysConfig: this.variables._daysConfig // Se llenará dinámicamente con los días de incidencias
  };


  
  constructor(
  private cdr: ChangeDetectorRef,
  private zone: NgZone,
  private storage: Storage,
  public fb: FormBuilder,
  public modalCtrl: ModalController,
  public alertCtrl: AlertController,
  public navCtrl: NavController,
  public funciones: FuncionesProvider,
  public variables: VariablesProvider,
  public file: File
  ) {

    // Se conserva la lectura histórica de turnos; la lista antigua no
    // esperaba a esta consulta para empezar a mostrarse.
    this.obtenerturnos(this.valo);

    let fecha = new Date(this.variables.DIA);
    let mes = fecha.getMonth() + 1;

    this.obtieneincidencias();

    this.obtenerempresas(this.variables.CLIENTES_RAZSOCIAL);

    

    this.variables.VERMAPA = "no";

    this.ORDENADO = "turno";
    this.ASC = "asc";

    const diaInicial = this.variables.DIA;
    this.actualizarFechaLista(diaInicial);
    this.variables.btatras = true;
    var sum = 0;
    var horas = 0;

    this.cabecera[0] = "s";

    this.muestragif = "si";

    this.myForm = this.fb.group({
      codigo: [""],
      nombre: [""],
      empresa: [""],
      obra: [""],
      turno: [""],
      horas: [""],
      activo: [""],
    });

    this.myForm1 = this.fb.group({
      codigo1: ["", [Validators.required]],
      nombre1: ["", [Validators.required]],
      horas1: ["", [Validators.required]],
      horainicio1: ["", [Validators.required]],
      activo1: ["", [Validators.required]],
    });

    this.funciones
      .obtieneobras("654321123456")
      .then((data) => {
        this.obras = data;
      })
      .catch((error) => {
        console.log(error);
      });

     

    this.funciones.obtienefiestas().then((data) => {
        this.diasdefiesta = data;
        this.fiesta = "";
        for (var v = 0; v < this.diasdefiesta.length; v++) {
          if (
            this.diasdefiesta[v].DIA == this.dia &&
            this.diasdefiesta[v].MES == this.MESHOY
          ) {
            this.fiesta = this.diasdefiesta[v].NOMBRE;
            break;
          }
        }

        if (this.fiesta == "") {
          this.fiesta = this.diaSemanaGrande(this.variables.DIA);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    //console.log("**********************************************");
    this.funciones.obtieneusers(this.variables.CLIENTES_RAZSOCIAL).then((data) => {
        this.users = data;
      })
      .catch((error) => {
        console.log(error);
      });

    //******************
    //    aceeso user normal
    const filtroInicial = this.variables.CONTROLACCESO != 11 ? this.valo : this.variables.CLIENTES_RAZSOCIAL;
    if (/^\d{4}-\d{2}-\d{2}$/.test(diaInicial || '')) {
      this.obtenertrabajadores(filtroInicial);
    } else {
      // No sobrescribir una fecha elegida mientras se lee el almacenamiento.
      this.storage.get('DIASELECIONADO').then(dia => {
        if (this.versionLista !== 0) { return; }
        this.actualizarFechaLista(dia);
        this.obtenertrabajadores(filtroInicial);
      }).catch(() => {
        if (this.versionLista === 0) { this.obtenertrabajadores(filtroInicial); }
      });
    }
  }


  validarIncidenciaPanelIA(incidencia: any, event?: any) {

    if (event) {
      event.stopPropagation();
    }
  
    if (!incidencia) {
      return;
    }
  
    var idPicaje =
      incidencia.ID ||
      incidencia.id ||
      incidencia.IDPICAJE ||
      incidencia.idpicaje ||
      incidencia.ID_PICAJE ||
      '';
  
    if (!idPicaje) {
      window.alert('No se puede validar porque no viene el ID de la picada.');
      return;
    }
  
    this.funciones.editapicaje('Incidencia Aceptada', idPicaje)
      .then((data) => {
  
        console.log('Incidencia validada desde panel IA', data);
  
        /*
          La ocultamos inmediatamente del panel.
        */
        incidencia.IA_IGNORADA = true;
        incidencia.ESTADO = 'validada';
        incidencia.TIPO = 'Incidencia Aceptada';
  
        this.cdr.detectChanges();
  
        /*
          Recargamos desde servidor.
        */
        this.obtieneincidencias();
        this.obtenertrabajadores(this.valo);
  
      })
      .catch((error) => {
        console.log(error);
        window.alert('No se pudo validar la incidencia.');
      });
  }

  confirmarValidarIA(incidencia: any, event?: any): void {
    if (event) { event.stopPropagation(); }
    if (!incidencia) { return; }
    this.alertCtrl.create({
      title: 'Confirmar validación',
      message: 'Se marcará esta incidencia como revisada y aceptada. No se cambiará la hora de la picada. ¿Continuar?',
      buttons: [
        { text: 'Cancelar', role: 'cancel' },
        { text: 'Aceptar', handler: () => this.validarIncidenciaPanelIA(incidencia) }
      ]
    }).present();
  }


  getImagenAhoritaIA() {

    if (!this.incidenciasAnualesIA || this.incidenciasAnualesIA.length == 0) {
      return 'https://www.panel-control.com/picademo/ahorita.png';
    }
  
    /*
      Si hay muchas incidencias, cambiamos a ahorita2.png.
      Cambia el 5 por el número que quieras.
    */
    if (this.incidenciasAnualesIA.length > 0) {
      return 'https://www.panel-control.com/picademo/ahorita2.png';
    }
  
    return 'https://www.panel-control.com/picademo/ahorita.png';
  }

  imagenAhoritaNoDisponible(event: any): void {
    const imagen: any = event && event.target;
    this.imagenAhoritaError = true;
    if (imagen && imagen.src.indexOf('assets/imgs/logo.png') < 0) {
      imagen.src = 'assets/imgs/logo.png';
    }
  }


  revisarIncidenciaIA(casos: any[], indice: number) {

    if (indice >= casos.length) {
      window.alert('Revisión terminada.');
      this.obtieneincidencias();
      this.obtenertrabajadores(this.valo);
      return;
    }
  
    var inc: any = casos[indice];
  
    var codigo =
      inc.CODIGO ||
      inc.codigo ||
      inc.CODIGOTRABAJADOR ||
      inc.trabajador ||
      '';
  
    var nombre =
      inc.NOMBRE ||
      inc.nombre ||
      inc.NOMBRETRABAJADOR ||
      '';
  
    var fecha =
      inc.FECHA ||
      inc.fecha ||
      this.variables.DIA;
  
    fecha = String(fecha).substr(0, 10);
  
    var motivo =
    inc.MOTIVO ||
    inc.motivo ||
    inc.Motivo ||
    '';
  
    var idPicaje =
      inc.ID ||
      inc.id ||
      inc.IDPICAJE ||
      inc.idpicaje ||
      inc.ID_PICAJE ||
      '';
  
    /*
      Antes de mostrar la ventana,
      cargamos las picadas reales de ese trabajador y ese día.
    */
    this.funciones.obtienepicajesdesc(codigo, fecha).then((picadas: any) => {
  
      var htmlPicadas = this.crearHtmlPicadasIA(picadas, idPicaje);
  
      let aviso = this.alertCtrl.create({
        title: '🤖 Incidencia ' + (indice + 1) + ' de ' + casos.length,
        
        message:
  '<div class="ia-alert-contenido">' +

    '<div class="ia-resumen-linea">' +
      '<span><b>Trabajador:</b> ' + nombre + '</span>' +
      '<span><b>Fecha:</b> ' + fecha + '</span>' +
      '<span><b>Motivo:</b> ' + motivo + '</span>' +
    '</div>' +

    '<div class="ia-bloque">' +
      '<b>Picadas del día:</b>' +
      htmlPicadas +
    '</div>' +

    '<div class="ia-pregunta">' +
      '¿Qué quieres hacer?' +
    '</div>' +

  '</div>',

        
        cssClass: 'alertCustomCss ia-alert-picadas',
        buttons: [
          {
            text: 'Saltar',
            role: 'cancel',
            handler: () => {
              this.revisarIncidenciaIA(casos, indice + 1);
            }
          },
          {
            text: 'Corregir picadas',
            handler: () => {
              this.openPicajesIncidencia(codigo, nombre, fecha, inc);
            }
          },
          {
            text: 'Validar',
            handler: () => {
              this.validarIncidenciaDesdeIA(idPicaje, casos, indice);
            }
          }
        ]
      });
  
      aviso.present();
  
    }).catch((error) => {
  
      console.log(error);
  
      let aviso = this.alertCtrl.create({
        title: '🤖 Incidencia ' + (indice + 1) + ' de ' + casos.length,
        message:
          '<b>Trabajador:</b><br>' + nombre +
          '<br><br><b>Fecha:</b><br>' + fecha +
          '<br><br><b>Motivo:</b><br>' + motivo +
          '<br><br>No se pudieron cargar las picadas del día.',
        cssClass: 'alertCustomCss',
        buttons: [
          {
            text: 'Corregir picadas',
            handler: () => {
              this.openPicajesIncidencia(codigo, nombre, fecha, inc);
            }
          },
          {
            text: 'Cerrar',
            role: 'cancel'
          }
        ]
      });
  
      aviso.present();
  
    });
  }


  obtenerMotivoIncidenciaIA(picadas: any, idPicaje: any, motivoActual: any) {

    var motivo = motivoActual || '';
  
    if (!picadas || picadas.length == 0) {
      return motivo || 'Incidencia detectada';
    }
  
    for (var i = 0; i < picadas.length; i++) {
  
      var p: any = picadas[i];
  
      var id =
        p.ID ||
        p.id ||
        '';
  
      var motivoPicada =
        p.MOTIVO ||
        p.motivo ||
        p.Motivo ||
        '';
  
      if (String(id) == String(idPicaje) && motivoPicada != '') {
        return motivoPicada;
      }
    }
  
    for (var j = 0; j < picadas.length; j++) {
  
      var p2: any = picadas[j];
  
      var motivoPicada2 =
        p2.MOTIVO ||
        p2.motivo ||
        p2.Motivo ||
        '';
  
      var tipoPicada =
        p2.TIPO ||
        p2.tipo ||
        '';
  
      var tipoMin = String(tipoPicada).toLowerCase();
  
      if (
        motivoPicada2 != '' &&
        (
          tipoMin.indexOf('incidencia') >= 0 ||
          tipoMin.indexOf('aceptada') >= 0 ||
          tipoMin.indexOf('resuelto') >= 0
        )
      ) {
        return motivoPicada2;
      }
    }
  
    return motivo || 'Incidencia detectada';
  }


  crearHtmlPicadasIA(picadas: any, idPicaje: any) {

    if (!picadas || picadas.length == 0) {
      return '<div class="ia-sin-picadas">No hay picadas registradas este día.</div>';
    }
  
    var html = '';
  
    html += '<div class="ia-lista-picadas">';
  
    for (var i = 0; i < picadas.length; i++) {
  
      var p: any = picadas[i];
  
      var id = p.ID || p.id || '';
  
      var sentido = p.SENTIDO || p.sentido || '';
      var hora = p.HORA || p.hora || '';
      var tipo = p.TIPO || p.tipo || '';
      var obra = p.OBRA || p.obra || '';
      var localizacion = p.LOCALIZACION || p.localizacion || '';

      var motivo =
      p.MOTIVO ||
      p.motivo ||
      p.Motivo ||
      '';

        
      var sentidoTexto = '';
      var sentidoClase = '';
  
      if (sentido == 'ENT') {
        sentidoTexto = 'ENTRADA';
        sentidoClase = 'entrada';
      } else if (sentido == 'SAL') {
        sentidoTexto = 'SALIDA';
        sentidoClase = 'salida';
      } else {
        sentidoTexto = sentido;
        sentidoClase = 'otro';
      }
  
      var claseIncidencia = '';
  
      if (String(id) == String(idPicaje)) {
        claseIncidencia = ' incidencia';
      } else {
        var tipoMin = String(tipo).toLowerCase();
  
        if (
          tipoMin.indexOf('incidencia') >= 0 ||
          tipoMin.indexOf('olvid') >= 0 ||
          tipoMin.indexOf('resuelto') >= 0 ||
          tipoMin.indexOf('aceptada') >= 0
        ) {
          claseIncidencia = ' incidencia';
        }
      }
  
      html += '<div class="ia-picada-card' + claseIncidencia + '">';
  
        html += '<div class="ia-picada-linea-superior">';
  
          html += '<div class="ia-hora">';
            html += hora;
          html += '</div>';
  
          html += '<div class="ia-sentido ' + sentidoClase + '">';
            html += sentidoTexto;
          html += '</div>';
  
        html += '</div>';
  
        html += '<div class="ia-picada-detalle">';
  
          if (obra != '') {
            html += '<div><span>Lugar:</span> ' + obra + '</div>';
          }
  
          if (tipo != '') {
            html += '<div><span>Tipo:</span> ' + tipo + '</div>';
          }
  
          if (motivo != '') {
            html += '<div><span>Motivo:</span> ' + motivo + '</div>';
          }

  
        html += '</div>';
  
        if (claseIncidencia != '') {
          html += '<div class="ia-etiqueta-incidencia">⚠ Posible incidencia</div>';
        }
  
      html += '</div>';
    }
  
    html += '</div>';
  
    return html;
  }


  validarIncidenciaDesdeIA(idPicaje, casos, indice) {

    if (!idPicaje) {
      window.alert('No puedo validar directamente porque no viene el ID de la picada. Entra en "Corregir picadas".');
      return;
    }
  
    this.funciones.editapicaje('Incidencia Aceptada', idPicaje)
      .then((data) => {
  
        console.log('Incidencia aceptada desde IA', data);
  
        casos[indice].ESTADO = 'validada';
  
        this.obtieneincidencias();
        this.obtenertrabajadores(this.valo);
  
        this.revisarIncidenciaIA(casos, indice + 1);
  
      })
      .catch((error) => {
        console.log(error);
        window.alert('No se pudo validar la incidencia.');
      });
  }

  fechaHoyIA() {

    var d = new Date();
  
    var yyyy = d.getFullYear();
    var mm: any = d.getMonth() + 1;
    var dd: any = d.getDate();
  
    if (mm < 10) {
      mm = '0' + mm;
    }
  
    if (dd < 10) {
      dd = '0' + dd;
    }
  
    return yyyy + '-' + mm + '-' + dd;
  }
 
  obtenerIncidenciasDelDia() {

    var resultado = [];
  
    if (!this.incidencias || !this.variables.DIA) {
      return resultado;
    }
  
    for (var i = 0; i < this.incidencias.length; i++) {
  
      var inc: any = this.incidencias[i];
  
      var fechaInc = '';
  
      if (inc.FECHA) {
        fechaInc = String(inc.FECHA).substr(0, 10);
      }
  
      if (fechaInc == this.variables.DIA) {
  
        /*
          Si ya tienes un campo ESTADO, VALIDADA o RESUELTA,
          aquí filtramos solo las pendientes.
        */
        var estado = String(inc.ESTADO || inc.estado || '').toLowerCase();
  
        if (
          estado == '' ||
          estado == 'pendiente' ||
          estado == 'incidencia' ||
          estado == '0'
        ) {
          resultado.push(inc);
        }
      }
    }
  
    return resultado;
  }

  abrirRevisionIA() {
    this.mostrarPanelIA = !this.mostrarPanelIA;
    if (this.mostrarPanelIA) { this.cargarPicadasAhoritaIA(); }
  }

  private cargarAprendizajePendienteIA(abrirPanel: boolean): void {
    const cliente = this.variables.CLIENTES_RAZSOCIAL || '';
    const caso = AhoritaAprendizaje.pendiente(cliente);
    if (!caso) { return; }
    this.aprendizajeRecienteIA = caso;
    this.casosParecidosAprendizajeIA = [];
    this.mensajeParecidosAprendizajeIA = '';
    AhoritaAprendizaje.marcarMostrado(cliente, caso.ID);
    if (abrirPanel) {
      this.mostrarPanelIA = true;
      setTimeout(() => this.cargarPicadasAhoritaIA(), 0);
    }
  }

  textoConfianzaAprendizajeIA(): string {
    const caso: any = this.aprendizajeRecienteIA;
    if (!caso || caso.CONFIANZA == null) {
      return 'Confianza inicial baja: necesita mas correcciones confirmadas.';
    }
    const confianza = Math.round(Number(caso.CONFIANZA));
    const nivel = confianza >= 80 ? 'alta' : (confianza >= 55 ? 'media' : 'baja');
    return 'Confianza ' + nivel + ': ' + confianza + '% (' + Number(caso.CONFIRMACIONES || 1) + ' confirmaciones).';
  }

  editarReglaAprendizajeIA(event?: any): void {
    if (event) { event.stopPropagation(); }
    const caso: any = this.aprendizajeRecienteIA;
    if (!caso || !caso.REGLA) { return; }
    const t = caso.REGLA.TOLERANCIAS || {};
    const manual = caso.REGLA.CRITERIOS_MANUALES || {};
    this.alertCtrl.create({
      title: 'Escribir o ajustar mi regla',
      message: 'El texto explica tu criterio. Las horquillas numericas son las que Ahorita aplicara al buscar semejanzas.',
      cssClass: 'alertCustomCss ahorita-regla-alerta',
      inputs: [
        { name: 'NOMBRE', placeholder: 'Nombre de la regla', value: caso.REGLA.NOMBRE || '' },
        { name: 'NOTA_USUARIO', placeholder: 'Escribe como quieres que se interprete', value: caso.REGLA.NOTA_USUARIO || caso.ACCION || '' },
        { name: 'SEGURIDAD_MINIMA', type: 'number', placeholder: 'Seguridad minima %', value: String(caso.REGLA.SEGURIDAD_MINIMA || 70) },
        { name: 'INTERVALO_PORCENTAJE', type: 'number', placeholder: 'Variacion de intervalos %', value: String(t.INTERVALO_PORCENTAJE || 45) },
        { name: 'INTERVALO_MINIMO', type: 'number', placeholder: 'Horquilla minima (minutos)', value: String(t.INTERVALO_MINIMO || 30) },
        { name: 'INTERVALO_MAXIMO', type: 'number', placeholder: 'Horquilla maxima (minutos)', value: String(t.INTERVALO_MAXIMO || 180) },
        { name: 'AMPLITUD', type: 'number', placeholder: 'Margen duracion jornada (minutos)', value: String(t.AMPLITUD || 180) },
        { name: 'HORA_INICIO', type: 'number', placeholder: 'Margen inicio (minutos)', value: String(t.HORA_INICIO || 240) },
        { name: 'CONTEXTO_HORA', type: 'number', placeholder: 'Margen dias contiguos (minutos)', value: String(t.CONTEXTO_HORA || 240) }
        ,{ name: 'MIN_PICADAS', type: 'number', placeholder: 'Minimo de picadas (regla manual)', value: String(manual.MIN_PICADAS || 1) }
        ,{ name: 'MAX_PICADAS', type: 'number', placeholder: 'Maximo de picadas (regla manual)', value: String(manual.MAX_PICADAS || 20) }
        ,{ name: 'INTERVALO_ERROR_MAX', type: 'number', placeholder: 'Separacion maxima del error (minutos)', value: String(manual.INTERVALO_ERROR_MAX || 90) }
      ],
      buttons: [
        { text: 'CANCELAR', role: 'cancel' },
        { text: 'GUARDAR MI REGLA', handler: datos => {
          const actualizada = AhoritaAprendizaje.actualizarRegla(this.variables.CLIENTES_RAZSOCIAL || '', caso.ID, datos);
          if (actualizada) {
            this.aprendizajeRecienteIA = actualizada;
            if (caso.SERVIDOR_ID) {
              this.funciones.actualizarAprendizajeAhorita(caso.SERVIDOR_ID, actualizada).catch(() => {});
            }
            this.casosParecidosAprendizajeIA = [];
            this.mensajeParecidosAprendizajeIA = 'Regla actualizada. Vuelve a buscar para aplicar las nuevas horquillas.';
          }
        } }
      ]
    }).present();
  }

  crearReglaManualAprendizajeIA(event?: any): void {
    if (event) { event.stopPropagation(); }
    this.alertCtrl.create({
      title: 'Tipo de regla manual',
      message: 'Elige el error que quieres buscar. Despues podras escribir tu criterio y sus horquillas.',
      inputs: [
        { type: 'radio', label: 'Falta la salida', value: 'FALTA_SALIDA', checked: true },
        { type: 'radio', label: 'Falta la entrada', value: 'FALTA_ENTRADA' },
        { type: 'radio', label: 'Picada duplicada', value: 'DUPLICADO' },
        { type: 'radio', label: 'Sentido equivocado', value: 'CAMBIO_SENTIDO' }
      ],
      buttons: [
        { text: 'CANCELAR', role: 'cancel' },
        { text: 'SIGUIENTE', handler: patron => this.escribirReglaManualAprendizajeIA(patron) }
      ]
    }).present();
  }

  private escribirReglaManualAprendizajeIA(patron: string): void {
    this.alertCtrl.create({
      title: 'Escribir mi regla',
      message: 'Esta regla solo propondra revisiones. Nunca modificara picadas automaticamente.',
      cssClass: 'alertCustomCss ahorita-regla-alerta',
      inputs: [
        { name: 'NOMBRE', placeholder: 'Nombre de la regla' },
        { name: 'NOTA', placeholder: 'Explica con tus palabras cuando debe aplicarse' },
        { name: 'SEGURIDAD_MINIMA', type: 'number', placeholder: 'Seguridad minima %', value: '70' },
        { name: 'MIN_PICADAS', type: 'number', placeholder: 'Minimo de picadas', value: '1' },
        { name: 'MAX_PICADAS', type: 'number', placeholder: 'Maximo de picadas', value: '20' },
        { name: 'INTERVALO_ERROR_MAX', type: 'number', placeholder: 'Separacion maxima sospechosa (minutos)', value: '90' }
      ],
      buttons: [
        { text: 'CANCELAR', role: 'cancel' },
        { text: 'GUARDAR REGLA', handler: datos => {
          const caso = AhoritaAprendizaje.crearManual(this.variables.CLIENTES_RAZSOCIAL || '',
            datos.NOMBRE || 'Regla manual', patron, datos.NOTA || '', datos);
          AhoritaAprendizaje.guardarPropuesta(caso);
          AhoritaAprendizaje.marcarMostrado(this.variables.CLIENTES_RAZSOCIAL || '', caso.ID);
          this.aprendizajeRecienteIA = caso;
          this.casosParecidosAprendizajeIA = [];
          this.mensajeParecidosAprendizajeIA = 'Regla manual guardada para este cliente.';
          this.funciones.guardarAprendizajeAhorita(caso).then((respuesta: any) => {
            AhoritaAprendizaje.actualizarServidor(this.variables.CLIENTES_RAZSOCIAL || '', caso.ID, respuesta);
            if (respuesta && respuesta.ID != null) { (caso as any).SERVIDOR_ID = Number(respuesta.ID); }
          }).catch(() => {});
        } }
      ]
    }).present();
  }

  eliminarReglaAprendizajeIA(event?: any): void {
    if (event) { event.stopPropagation(); }
    const caso: any = this.aprendizajeRecienteIA;
    if (!caso) { return; }
    this.alertCtrl.create({
      title: 'Eliminar regla',
      message: '¿Quieres eliminar esta regla solo del aprendizaje de este cliente?',
      buttons: [
        { text: 'NO', role: 'cancel' },
        { text: 'SI, ELIMINAR', handler: () => {
          AhoritaAprendizaje.eliminarRegla(this.variables.CLIENTES_RAZSOCIAL || '', caso.ID);
          if (caso.SERVIDOR_ID) {
            this.funciones.eliminarAprendizajeAhorita(caso.SERVIDOR_ID).catch(() => {});
          }
          this.aprendizajeRecienteIA = null;
          this.casosParecidosAprendizajeIA = [];
          this.mensajeParecidosAprendizajeIA = '';
        } }
      ]
    }).present();
  }

  async buscarCasosParecidosAprendizajeIA(event?: any): Promise<void> {
    if (event) { event.stopPropagation(); }
    const caso = this.aprendizajeRecienteIA;
    if (!caso || this.buscandoParecidosAprendizajeIA) { return; }
    this.buscandoParecidosAprendizajeIA = true;
    this.casosParecidosAprendizajeIA = [];
    this.mensajeParecidosAprendizajeIA = 'Buscando incidencias parecidas del mes seleccionado...';
    const mes = String(this.variables.DIA || '').substr(0, 7);
    const unicas: any = {};
    const candidatas = (Array.isArray(this.incidencias) ? this.incidencias : []).filter((inc: any) => {
      const fecha = String(inc && (inc.FECHA || inc.fecha) || '').substr(0, 10);
      const codigo = String(inc && (inc.CODIGO || inc.codigo || inc.TRABAJADOR || inc.trabajador) || '');
      if (!codigo || fecha.substr(0, 7) !== mes) { return false; }
      if (codigo === caso.CODIGO && fecha === caso.FECHA) { return false; }
      const estado = String(inc.ESTADO || inc.estado || inc.TIPO || inc.tipo || '').toLowerCase();
      if (estado.indexOf('aceptada') >= 0 || estado.indexOf('resuelt') >= 0 || estado.indexOf('ignorada') >= 0) { return false; }
      const clave = codigo + '|' + fecha;
      if (unicas[clave]) { return false; }
      unicas[clave] = true;
      inc._CODIGO_IA = codigo;
      inc._FECHA_IA = fecha;
      return true;
    }).slice(0, 80);

    const encontrados: any[] = [];
    try {
      for (let i = 0; i < candidatas.length; i += 6) {
        const lote = await Promise.all(candidatas.slice(i, i + 6).map(async (inc: any) => {
          try {
            const fechaAnterior = this.fechaAhoritaIA(inc._FECHA_IA, -1);
            const fechaSiguiente = this.fechaAhoritaIA(inc._FECHA_IA, 1);
            const dias: any[] = await Promise.all([
              this.funciones.obtienepicajesdesc(inc._CODIGO_IA, inc._FECHA_IA),
              this.funciones.obtienepicajesdesc(inc._CODIGO_IA, fechaAnterior).catch(() => []),
              this.funciones.obtienepicajesdesc(inc._CODIGO_IA, fechaSiguiente).catch(() => [])
            ]);
            const comparacion = AhoritaAprendizaje.comparar(caso, dias[0], {
              ANTERIOR: AhoritaAprendizaje.normalizar(dias[1]),
              SIGUIENTE: AhoritaAprendizaje.normalizar(dias[2])
            });
            inc._COMPARACION_IA = comparacion;
            return comparacion.COINCIDE ? inc : null;
          } catch (error) { return null; }
        }));
        lote.filter(item => !!item).forEach(item => encontrados.push(item));
      }
      this.casosParecidosAprendizajeIA = encontrados.sort((a, b) =>
        Number(b._COMPARACION_IA && b._COMPARACION_IA.SEGURIDAD || 0) -
        Number(a._COMPARACION_IA && a._COMPARACION_IA.SEGURIDAD || 0));
      this.mensajeParecidosAprendizajeIA = encontrados.length > 0 ?
        ('He encontrado ' + encontrados.length + ' caso(s) parecido(s). Revisalos antes de corregir.') :
        'No he encontrado otras incidencias pendientes con el mismo patron en este mes.';
      const servidorId = (caso as any).SERVIDOR_ID;
      if (servidorId && encontrados.length > 0) {
        this.funciones.registrarResultadoAprendizajeAhorita(servidorId, 'SUGERIDA').catch(() => {});
      }
    } finally {
      this.buscandoParecidosAprendizajeIA = false;
      this.cdr.detectChanges();
    }
  }

  revisarCasoParecidoAprendizajeIA(caso: any, event?: any): void {
    if (event) { event.stopPropagation(); }
    const aprendizaje: any = this.aprendizajeRecienteIA;
    if (aprendizaje) {
      caso._APRENDIZAJE_ORIGEN_LOCAL_ID = aprendizaje.ID;
      caso._APRENDIZAJE_ORIGEN_SERVIDOR_ID = aprendizaje.SERVIDOR_ID;
    }
    this.openPicajesIncidencia(
      caso._CODIGO_IA || caso.CODIGO,
      caso.NOMBRE || caso.nombre || caso._CODIGO_IA,
      caso._FECHA_IA || caso.FECHA,
      caso
    );
  }

  descartarCasoParecidoAprendizajeIA(caso: any, event?: any): void {
    if (event) { event.stopPropagation(); }
    this.casosParecidosAprendizajeIA = this.casosParecidosAprendizajeIA.filter(item => item !== caso);
    const aprendizaje: any = this.aprendizajeRecienteIA;
    if (aprendizaje && aprendizaje.ID) {
      AhoritaAprendizaje.registrarResultado(this.variables.CLIENTES_RAZSOCIAL || '', aprendizaje.ID, false);
    }
    if (aprendizaje && aprendizaje.SERVIDOR_ID) {
      this.funciones.registrarResultadoAprendizajeAhorita(aprendizaje.SERVIDOR_ID, 'FALLO').catch(() => {});
    }
    this.mensajeParecidosAprendizajeIA = this.casosParecidosAprendizajeIA.length > 0 ?
      ('Quedan ' + this.casosParecidosAprendizajeIA.length + ' caso(s) por revisar.') :
      'No quedan casos parecidos pendientes de revision.';
  }

  private fechaAhoritaIA(fecha: string, dias: number): string {
    const base = Date.parse(String(fecha || '').substr(0, 10) + 'T00:00:00Z');
    return isFinite(base) ? fechaDetalle(base + dias * 86400000) : '';
  }

  private clavePicadasAhoritaIA(codigo: string, fecha: string): string {
    return String(codigo || '') + '|' + String(fecha || '');
  }

  private minutosPicadaAhoritaIA(valor: any): number | null {
    const m = /^(\d{1,2}):(\d{2})/.exec(String(valor || '').trim());
    if (!m || Number(m[1]) > 24 || Number(m[2]) > 59 ||
      (Number(m[1]) === 24 && Number(m[2]) !== 0)) { return null; }
    return Number(m[1]) * 60 + Number(m[2]);
  }

  private normalizarPicadasAhoritaIA(picadas: any[]): any[] {
    const ids: any = {};
    const resultado: any[] = [];
    (Array.isArray(picadas) ? picadas : []).forEach((p: any, indice: number) => {
      const sentido = String(p && (p.SENTIDO || p.sentido) || '').trim().toUpperCase();
      const normalizado = sentido === 'ENT' || sentido === 'ENTRADA' || sentido === 'ENTRA' ? 'ENT' :
        (sentido === 'SAL' || sentido === 'SALIDA' || sentido === 'SALE' ? 'SAL' : '');
      const fecha = String(p && (p.FECHA || p.fecha) || '').substr(0, 10);
      const hora = p && (p.HORA || p.hora || p.PICADA);
      const minutos = this.minutosPicadaAhoritaIA(hora);
      const id = p && (p.ID || p.id);
      if (!normalizado || !/^\d{4}-\d{2}-\d{2}$/.test(fecha) || minutos === null ||
        (id != null && id !== '' && ids[id])) { return; }
      if (id != null && id !== '') { ids[id] = true; }
      resultado.push({ fecha, hora: String(hora), minutos, sentido: normalizado, picada: p, indice });
    });
    resultado.sort((a, b) => {
      const ta = Date.parse(a.fecha + 'T00:00:00Z') + a.minutos * 60000;
      const tb = Date.parse(b.fecha + 'T00:00:00Z') + b.minutos * 60000;
      return ta - tb || a.indice - b.indice;
    });
    return resultado;
  }

  private async cargarPicadasAhoritaIA(): Promise<void> {
    const fecha = String(this.variables.DIA || '').substr(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(fecha) || this.cargandoPicadasAhoritaIA) { return; }
    const trabajadoresActuales = (this.trabajadores || []).filter((t: any) => Number(t && t.HOYPICO) > 0);
    const todosCargados = trabajadoresActuales.length > 0 && trabajadoresActuales.every((t: any) =>
      Object.prototype.hasOwnProperty.call(this.picadasAhoritaIA, this.clavePicadasAhoritaIA(String(t.CODIGO || ''), fecha)));
    if (this.fechaPicadasAhoritaIA === fecha && todosCargados) { return; }
    this.cargandoPicadasAhoritaIA = true;
    this.fechaPicadasAhoritaIA = fecha;
    const trabajadores = trabajadoresActuales;
    const cargar = async (tareas: any[]) => {
      for (let i = 0; i < tareas.length; i += 6) {
        await Promise.all(tareas.slice(i, i + 6).map(async (tarea: any) => {
          try {
            const picadas = await this.funciones.obtienepicajesdesc(tarea.codigo, tarea.fecha);
            this.picadasAhoritaIA[this.clavePicadasAhoritaIA(tarea.codigo, tarea.fecha)] =
              Array.isArray(picadas) ? picadas : [];
          } catch (error) {
            // Si una consulta puntual falla, el detector conserva el respaldo
            // del contador de la lista y no bloquea Ahorita.
            this.picadasAhoritaIA[this.clavePicadasAhoritaIA(tarea.codigo, tarea.fecha)] = [];
          }
        }));
      }
    };
    const tareas = trabajadores.map((t: any) => ({ codigo: String(t.CODIGO || ''), fecha }));
    await cargar(tareas);

    // Solo se pide contexto adicional a los trabajadores cuya jornada queda
    // incompleta. Es lo que permite reconocer correctamente los turnos noche.
    const contexto: any[] = [];
    trabajadores.forEach((t: any) => {
      const codigo = String(t.CODIGO || '');
      const actual = this.normalizarPicadasAhoritaIA(this.picadasAhoritaIA[this.clavePicadasAhoritaIA(codigo, fecha)]);
      if (actual.length % 2 === 1) {
        contexto.push({ codigo, fecha: this.fechaAhoritaIA(fecha, -1) });
        contexto.push({ codigo, fecha: this.fechaAhoritaIA(fecha, 1) });
      }
    });
    await cargar(contexto.filter(t => t.fecha));
    this.cargandoPicadasAhoritaIA = false;
    this.cdr.detectChanges();
  }

  async analizarMesDesdeAhorita(): Promise<void> {
    if (this.analizandoAhoritaIA) { return; }

    const codigo = String(this.trabajadorAhoritaIA || '').trim();
    const trabajador = (this.trabajadores || []).find(t => String(t.CODIGO) === codigo);
    if (!codigo || !trabajador) {
      this.errorAhoritaIA = 'Selecciona primero un trabajador de la lista.';
      return;
    }

    const mes = String(this.variables.DIA || '').substr(0, 7);
    if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(mes)) {
      this.errorAhoritaIA = 'Selecciona primero un día válido en el calendario.';
      return;
    }

    const inicio = Date.parse(mes + '-01T00:00:00Z');
    const fecha = new Date(inicio);
    const fin = Date.UTC(fecha.getUTCFullYear(), fecha.getUTCMonth() + 1, 1);
    const pregunta = (this.preguntaAhoritaIA || '').trim() ||
      ('Examina el mes de ' + (trabajador.NOMBRE || codigo) +
        ' y guíame con todos los fallos que encuentres. Indica la fecha, la evidencia y una solución propuesta sin modificar nada.');

    this.analizandoAhoritaIA = true;
    this.errorAhoritaIA = '';
    this.respuestaAhoritaIA = '';
    try {
      const datos = await Promise.all([
        this.leerDatosPdfDetalle(['informe', this.variables.CLIENTES_RAZSOCIAL, codigo, this.valo, this.valo,
          this.valo, fechaDetalle(inicio), fechaDetalle(fin - 86400000), 'real']),
        this.cargarPicajesMesPdfDetalle(codigo, mes)
      ]);
      const estudio = this.prepararEstudioAhorita(trabajador, {
        mes, inicio: fechaDetalle(inicio), fin: fechaDetalle(fin - 86400000)
      }, datos[0], datos[1]);
      const data: any = await this.funciones.preguntaAgenteIA(pregunta, [], estudio);
      const respuesta: any = Array.isArray(data) ? (data[0] || {}) : data;
      this.respuestaAhoritaIA = (respuesta && (respuesta.respuesta || respuesta.answer || respuesta.output_text || respuesta.mensaje)) ||
        'No he podido preparar el estudio. Puedes intentarlo de nuevo.';
    } catch (error) {
      this.respuestaAhoritaIA = 'No he podido cargar todos los datos del mes. Revisa la conexión e inténtalo de nuevo.';
    } finally {
      this.analizandoAhoritaIA = false;
      this.cdr.detectChanges();
    }
  }

  private prepararEstudioAhorita(trabajador: any, periodo: any, informe: any, picajes: any[]): any {
    const campos = ['FECHA', 'DIA', 'NOMBRE', 'PICADA_INICIAL', 'PICADA_FINAL', 'HORA_ENTRADA', 'HORA_SALIDA',
      'HORAS_PREVISTAS', 'HORAS_TRABAJADAS', 'HORAS_EXTRAS', 'HORAS_PARADAS', 'HORAS_SIN_TRABAJAR',
      'HORAS_ALMORZANDO', 'PICO', 'INCIDENCIA', 'TIPO'];
    const filas = (Array.isArray(informe) ? informe : []).map(fila => {
      const salida: any = {};
      campos.forEach(campo => { if (fila && fila[campo] !== undefined) { salida[campo] = fila[campo]; } });
      return salida;
    });
    const registros = (Array.isArray(picajes) ? picajes : []).map(p => ({
      FECHA: p && p.FECHA,
      HORA: p && (p.HORA || p.PICADA),
      SENTIDO: p && p.SENTIDO,
      OBRA: p && p.OBRA
    }));
    return {
      tipo: 'estudio_mensual_picadas_solo_lectura',
      trabajador: {
        CODIGO: trabajador.CODIGO,
        NOMBRE: trabajador.NOMBRE,
        TURNO: trabajador.TURNO,
        HORAS_CONTRATO: trabajador.HORAS_CONTRATO
      },
      periodo,
      resumenDiario: filas,
      picadas: registros
    };
  }

  get totalIncidenciasDiaIA() {
    if (!this.incidenciasFiltradas) {
      return 0;
    }
  
    return this.incidenciasFiltradas.length;
  }
  
  getMotivoIncidencia(incidencia) {
    if (!incidencia) {
      return '';
    }
  
    return incidencia.MOTIVO || incidencia.motivo || incidencia.Motivo || '';
  }
  

  cerrarPanelIA(event?: any) {
    if (event) {
      event.stopPropagation();
    }
  
    this.mostrarPanelIA = false;
  }

  actualizarVista() {
    this.cdr.detectChanges(); // Forzar actualización sin refrescar la página
  }

  salir() {
    this.navCtrl.pop();
  }

  informeobra() {
    this.variables.CODIGOTRABAJADOR = "654321123456";
    this.variables.NOMBRETRABAJADOR = "";
    this.navCtrl.push(InformesPage);
  }

  informe(codigotrabajador, nombretrabajador) {
    this.variables.CODIGOTRABAJADOR = codigotrabajador;
    this.variables.NOMBRETRABAJADOR = nombretrabajador;
    this.variables.OBRA = "654321123456";
    //console.log( this.variables.CODIGOTRABAJADOR +  "  " +   this.variables.NOMBRETRABAJADOR);

    this.navCtrl.push(InformesPage);
  }

  async obtieneincidencias(){
    if (this.cargaIncidencias) { this.cargaIncidencias.cancelar(); }
    const carga = this.cargaIncidencias = new CargaLista(this.funciones.http);
    this.errorCargaIncidencias = '';
    try {
      const mesVisualizado = /^\d{4}-\d{2}/.test(String(this.variables.DIA || '')) ?
        String(this.variables.DIA).substr(0, 7) : 'mes';
      const data = await carga.leer(['incidencias', this.variables.CLIENTES_RAZSOCIAL, mesVisualizado]);
      if (carga !== this.cargaIncidencias) { return; }
      this.incidencias = data;
      this.reconstruirMapaIncidenciasPendientes();
      this.actualizarMarcasCalendario();
      this.detectarCambiosLista();
    } catch (error) {
      if (carga === this.cargaIncidencias) {
        // Las incidencias del servidor son un complemento de Ahorita. Algunas
        // instalaciones antiguas no tienen esta ruta y devuelven 404; eso no
        // debe impedir que se muestre ni se utilice la lista principal.
        if (!Array.isArray(this.incidencias)) { this.incidencias = []; }
        this.reconstruirMapaIncidenciasPendientes();
        this.errorCargaIncidencias = '';
        this.detectarCambiosLista();
        console.log('Incidencias del servidor no disponibles; se continúa con la lista normal.', error);
      }
    }
  }

  /**
   * Prepara una consulta O(1) para que la plantilla pueda distinguir las filas
   * con incidencias sin recorrer todo el mes en cada ciclo de Angular.
   */
  private reconstruirMapaIncidenciasPendientes(): void {
    const mapa: { [clave: string]: boolean } = {};
    (Array.isArray(this.incidencias) ? this.incidencias : []).forEach((incidencia: any) => {
      if (!incidencia || incidencia.IA_IGNORADA === true) { return; }

      const estado = String(incidencia.ESTADO || incidencia.estado || '').toLowerCase();
      const tipo = String(incidencia.TIPO || incidencia.tipo || '').toLowerCase();
      if (
        estado.indexOf('ignorada') >= 0 ||
        estado.indexOf('resuelt') >= 0 ||
        estado.indexOf('validada') >= 0 ||
        tipo.indexOf('ignorada') >= 0 ||
        tipo.indexOf('resuelt') >= 0 ||
        tipo.indexOf('aceptada') >= 0
      ) { return; }

      const fecha = String(incidencia.FECHA || incidencia.fecha || '').substr(0, 10);
      const codigo = String(
        incidencia.CODIGO || incidencia.codigo || incidencia.CODIGOTRABAJADOR ||
        incidencia.codigotrabajador || incidencia.TRABAJADOR || incidencia.trabajador || ''
      ).trim().toLowerCase();
      if (/^\d{4}-\d{2}-\d{2}$/.test(fecha) && codigo) {
        mapa[fecha + '|' + codigo] = true;
      }
    });
    this.incidenciasPendientesPorTrabajador = mapa;
    this.aplicarMarcasIncidenciasTrabajadores();
  }

  /**
   * Guarda la marca en la propia fila. Asi no depende del orden en el que
   * terminen las dos consultas independientes (trabajadores e incidencias).
   */
  private aplicarMarcasIncidenciasTrabajadores(): void {
    const fecha = String(this.variables.DIA || '').substr(0, 10);
    (Array.isArray(this.trabajadores) ? this.trabajadores : []).forEach((trabajador: any) => {
      const codigo = String(trabajador && trabajador.CODIGO || '').trim().toLowerCase();
      trabajador._INCIDENCIA_PENDIENTE = !!(
        codigo && this.incidenciasPendientesPorTrabajador[fecha + '|' + codigo]
      );
    });
  }

  tieneIncidenciaPendiente(trabajador: any): boolean {
    if (!trabajador) { return false; }
    if (trabajador._INCIDENCIA_PENDIENTE === true) { return true; }
    // Conserva la marca que devolvia el listado antiguo.
    if (String(trabajador.INCIDENCIA || '').trim().toLowerCase() === 'con') { return true; }
    const fecha = String(this.variables.DIA || '').substr(0, 10);
    const codigo = String(trabajador.CODIGO || '').trim().toLowerCase();
    return !!this.incidenciasPendientesPorTrabajador[fecha + '|' + codigo];
  }

  private actualizarMarcasCalendario(): void {
    const dias: any = {};
    (this.incidencias || []).forEach(incidencia => {
      const dia = String(incidencia.FECHA || '').substr(0, 10);
      if (/^\d{4}-\d{2}-\d{2}$/.test(dia)) { dias[dia] = true; }
    });
    const marcas: any[] = Object.keys(dias).map(dia => ({
      date: new Date(dia + 'T12:00:00'), subTitle: '⚠️', cssClass: 'incidencia-day'
    }));
    if (this.variables.DIA && !dias[this.variables.DIA]) {
      marcas.push({ date: new Date(this.variables.DIA + 'T12:00:00'), cssClass: 'my-day' });
    }
    this.variables._daysConfig = marcas;
    // Una sola actualización por respuesta, no una por cada incidencia.
    this.optionsRange = { ...this.optionsRange, daysConfig: marcas };
  }


  get incidenciasAnualesIA() {

    if (!this.variables.DIA) {
      return [];
    }
  
    var fechaSeleccionada = new Date(String(this.variables.DIA).substr(0, 10) + 'T00:00:00');
    var anioSeleccionado = fechaSeleccionada.getFullYear();
    var mesSeleccionado = fechaSeleccionada.getMonth();
    var hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
  
    var resultado = (Array.isArray(this.incidencias) ? this.incidencias : []).filter((incidencia) => {
  
      if (!incidencia || !incidencia.FECHA) {
        return false;
      }
  
      /*
        Si se ha ignorado en pantalla, no sale.
      */
      if (incidencia.IA_IGNORADA === true) {
        return false;
      }
  
      var fecha = new Date(String(incidencia.FECHA).substr(0, 10) + 'T00:00:00');

      // Ahorita no revisa el día actual: la jornada todavía puede completarse.
      // Una incidencia creada expresamente por el trabajador debe mostrarse
      // tambiÃ©n en el dÃ­a actual. Las propuestas automÃ¡ticas conservan su
      // exclusiÃ³n del dÃ­a actual dentro de obtenerOlvidosClarosIA().
      if (fecha > hoy) {
        return false;
      }
  
      if (fecha.getFullYear() !== anioSeleccionado || fecha.getMonth() !== mesSeleccionado) {
        return false;
      }
  
      var estado = String(incidencia.ESTADO || incidencia.estado || '').toLowerCase();
      var tipo = String(incidencia.TIPO || incidencia.tipo || '').toLowerCase();
  
      /*
        No mostrar las que ya no deben aparecer.
      */
      if (
        estado.indexOf('ignorada') >= 0 ||
        estado.indexOf('resuelto') >= 0 ||
        estado.indexOf('validada') >= 0 ||
        tipo.indexOf('ignorada') >= 0 ||
        tipo.indexOf('resuelto') >= 0 ||
        tipo.indexOf('aceptada') >= 0
      ) {
        return false;
      }
  
      return true;
    });
  
    /*
      Más recientes primero.
    */
    resultado.sort((a, b) => {
  
      var fa = String(a.FECHA || '').substr(0, 10) + ' ' + String(a.HORA || '00:00');
      var fb = String(b.FECHA || '').substr(0, 10) + ' ' + String(b.HORA || '00:00');
  
      if (fa < fb) {
        return 1;
      }
  
      if (fa > fb) {
        return -1;
      }
  
      return 0;
    });
  
    return resultado.concat(this.obtenerOlvidosClarosIA(resultado));
  }

  /**
   * Avisos locales de alta confianza: hay un numero impar de picadas en la
   * jornada mostrada. No se marca como error confirmado porque un turno
   * nocturno puede continuar en el dia siguiente; al abrirlo se revisan las
   * picadas reales y desaparece al corregirlas.
   */
  private horasPrevistasAhoritaIA(trabajador: any, fecha: string): number | null {
    const resumen = Array.isArray(trabajador && trabajador._resumenIA) ? trabajador._resumenIA : [];
    const fila = resumen.find(r => String(r && r.FECHA || '').substr(0, 10) === fecha && r.NOMBRE !== 'SAL') || resumen[0] || trabajador;
    const valor = fila && (fila.HORAS_PREVISTAS != null ? fila.HORAS_PREVISTAS : fila.HORAS_CONTRATO);
    if (valor == null || String(valor).trim() === '') { return null; }
    const texto = String(valor).replace(',', '.').trim();
    if (/^-?\d+:\d{2}$/.test(texto)) {
      const partes = texto.replace('-', '').split(':').map(Number);
      return partes[0] * 60 + partes[1];
    }
    const numero = Math.abs(Number(texto));
    return isFinite(numero) ? Math.round(numero < 24 ? numero * 60 : numero) : null;
  }

  private obtenerOlvidosClarosIA(incidenciasServidor: any[]): any[] {
    const fecha = String(this.variables.DIA || '').substr(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(fecha) || !Array.isArray(this.trabajadores)) { return []; }
    const hoy = new Date(); hoy.setHours(0, 0, 0, 0);
    const seleccionada = new Date(fecha + 'T00:00:00');
    // No proponer olvidos ni sentidos repetidos durante el día actual.
    // Todavía pueden registrarse las picadas que faltan.
    if (seleccionada >= hoy) { return []; }
    const avisos: any[] = [];
    (this.trabajadores || []).forEach((trabajador: any) => {
      const cantidad = Number(trabajador && trabajador.HOYPICO);
      const codigo = String(trabajador && trabajador.CODIGO || '');
      const actualBruto = this.picadasAhoritaIA[this.clavePicadasAhoritaIA(codigo, fecha)];
      const actual = this.normalizarPicadasAhoritaIA(actualBruto);
      const cantidadReal = actual.length > 0 ? actual.length : cantidad;
      if (!isFinite(cantidadReal) || cantidadReal <= 0) { return; }
      if (this.mostrarDiaEspecial(trabajador.DIA)) { return; }
      const yaExiste = (incidenciasServidor || []).some(i => String(i.CODIGO || '') === codigo && String(i.FECHA || '').substr(0, 10) === fecha);
      if (yaExiste) { return; }
      const anterior = this.normalizarPicadasAhoritaIA(this.picadasAhoritaIA[
        this.clavePicadasAhoritaIA(codigo, this.fechaAhoritaIA(fecha, -1))]);
      const siguiente = this.normalizarPicadasAhoritaIA(this.picadasAhoritaIA[
        this.clavePicadasAhoritaIA(codigo, this.fechaAhoritaIA(fecha, 1))]);
      const contexto = anterior.concat(actual, siguiente).sort((a, b) => {
        const ta = Date.parse(a.fecha + 'T00:00:00Z') + a.minutos * 60000;
        const tb = Date.parse(b.fecha + 'T00:00:00Z') + b.minutos * 60000;
        return ta - tb || a.indice - b.indice;
      });
      for (let i = 1; i < contexto.length; i++) {
        const primera = contexto[i - 1];
        const segunda = contexto[i];
        if (primera.sentido === segunda.sentido && primera.fecha === fecha && segunda.fecha === fecha) {
          const claveSentido = 'ahorita:sentido:' + (this.variables.CLIENTES_RAZSOCIAL || '') + ':' + codigo + ':' + fecha;
          if (!(typeof localStorage !== 'undefined' && localStorage.getItem(claveSentido) === '1')) {
            avisos.push({
              IA_LOCAL: true, IA_CLAVE: claveSentido, CODIGO: trabajador.CODIGO, NOMBRE: trabajador.NOMBRE,
              FECHA: fecha, HORA: segunda.hora, SENTIDO: 'REVISAR', TIPO: 'Sentidos consecutivos',
              MOTIVO: 'Hay dos picadas seguidas con el mismo sentido (' + segunda.sentido + ').',
              EXPLICACION: 'La secuencia normal debe alternar Entrada y Salida. Revisa cuál de las dos picadas está duplicada o cuál falta.'
            });
          }
          break;
        }
      }
      if (cantidadReal % 2 === 0) { return; }
      const ultima = actual[actual.length - 1];
      const prevista = this.horasPrevistasAhoritaIA(trabajador, fecha);
      if (actual.length > 0 && ultima && ultima.sentido === 'ENT' &&
        (siguiente.some(p => p.sentido === 'SAL') || (prevista != null && ultima.minutos + prevista >= 1440))) {
        return;
      }
      if (actual.length > 0 && actual[0].sentido === 'SAL' && anterior.some(p => p.sentido === 'ENT')) {
        return;
      }
      const clave = 'ahorita:olvido:' + (this.variables.CLIENTES_RAZSOCIAL || '') + ':' + codigo + ':' + fecha;
      if (typeof localStorage !== 'undefined' && localStorage.getItem(clave) === '1') { return; }
      avisos.push({
        IA_LOCAL: true, IA_CLAVE: clave, CODIGO: trabajador.CODIGO, NOMBRE: trabajador.NOMBRE,
        FECHA: fecha, HORA: trabajador.PICADA_FINAL || trabajador.PICADA_INICIAL || '--', SENTIDO: 'REVISAR',
        TIPO: 'Olvido de picada',
        MOTIVO: cantidadReal === 1 ? 'Solo hay una picada: falta revisar la entrada o la salida.' :
          'Hay ' + cantidad + ' picadas (número impar): puede faltar una entrada o una salida.',
        EXPLICACION: 'Revisar las picadas reales. Si es un turno nocturno, puede estar correctamente enlazado con el día anterior o siguiente.'
      });
    });
    return avisos;
  }


  ignorarIncidenciaIA(incidencia: any, event?: any) {

    if (event) {
      event.stopPropagation();
    }
  
    if (!incidencia) {
      return;
    }
  
    var idPicaje =
      incidencia.ID ||
      incidencia.id ||
      incidencia.IDPICAJE ||
      incidencia.idpicaje ||
      incidencia.ID_PICAJE ||
      '';

    if (!idPicaje) {

      if (incidencia.IA_LOCAL && incidencia.IA_CLAVE) {
        if (typeof localStorage !== 'undefined') { localStorage.setItem(incidencia.IA_CLAVE, '1'); }
        incidencia.IA_IGNORADA = true;
        incidencia.ESTADO = 'ignorada';
        this.cdr.detectChanges();
        return;
      }
  
      /*
        Si no viene ID, al menos la ocultamos de la vista actual.
        Pero no quedará guardado en base de datos.
      */
      incidencia.IA_IGNORADA = true;
      incidencia.ESTADO = 'ignorada';
      this.cdr.detectChanges();
  
      window.alert('Incidencia ignorada en pantalla, pero no se pudo guardar porque no viene ID.');
      return;
    }
  
    this.funciones.editapicaje('Ignorada', idPicaje)
      .then((data) => {
  
        console.log('Incidencia ignorada', data);
  
        /*
          La quitamos al momento del panel.
        */
        incidencia.IA_IGNORADA = true;
        incidencia.ESTADO = 'ignorada';
        incidencia.TIPO = 'Ignorada';
  
        this.cdr.detectChanges();
  
        /*
          Refrescamos del servidor.
        */
        this.obtieneincidencias();
        this.obtenertrabajadores(this.valo);
  
      })
      .catch((error) => {
        console.log(error);
        window.alert('No se pudo ignorar la incidencia.');
      });
  }


  verIncidenciaIA(incidencia: any, event?: any) {

    if (event) {
      event.stopPropagation();
    }
  
    if (!incidencia) {
      return;
    }
  
    this.mostrarPanelIA = false;
  
    this.openPicajesIncidencia(
      incidencia.CODIGO,
      incidencia.NOMBRE,
      incidencia.FECHA,
      incidencia
    );
  }


  get incidenciasFiltradas() {
    if (!this.incidencias || !Array.isArray(this.incidencias) || !this.variables.DIA) {
      return [];
    }
  
    const fechaSeleccionada = new Date(this.variables.DIA);
    const mesSeleccionado = fechaSeleccionada.getMonth(); // 0-11
    const anioSeleccionado = fechaSeleccionada.getFullYear();
  
    return this.incidencias.filter(incidencia => {
      const fecha = new Date(incidencia.FECHA);
      return (
        fecha.getMonth() === mesSeleccionado &&
        fecha.getFullYear() === anioSeleccionado
      );
    });
  }

  esEmailOriginalNumerico(): boolean {

    const valor = this.variables.emailoriginal;
  
    if (!valor) return false;
  
    // Exactamente 20 dígitos numéricos
    return /^[0-9]{14}$/.test(valor);
  }


  async obtenertrabajadores(filtro) {
    if (filtro === 'formulario') { filtro = this.formulario2.valor; }
    filtro = filtro || this.valo;
    this.filtroLista = filtro;
    if (!this.variables.OBRA || this.variables.OBRA === this.valo) { this.variables.OBRA = 'Todas'; }
    const version = ++this.versionLista;
    if (this.cargaLista) { this.cargaLista.cancelar(); }
    const carga = this.cargaLista = new CargaLista(this.funciones.http);
    // Cada respuesta pertenece a esta fecha/modo, aunque el usuario siga navegando.
    const variables: any = Object.assign(Object.create(this.variables), {
      DIA: this.variables.DIA, MODO: this.variables.MODO,
      CLIENTES_RAZSOCIAL: this.variables.CLIENTES_RAZSOCIAL,
      muestraerror: 'no'
    });
    this.cargandoLista = true;
    this.errorCargaLista = '';
    this.muestragif = this.trabajadores && this.trabajadores.length ? 'no' : 'si';
    this.informetrabajadoressindetallesxls = [];
    try {
      // La lista no debe esperar a los turnos para empezar a dibujarse. En
      // servidores antiguos la consulta de turnos puede tardar bastante.
      // Esta es la misma llamada que utilizaba la versión estable. El gestor
      // nuevo se mantiene para las consultas de detalle, donde sí limita la
      // carga y cancela trabajos obsoletos.
      const trabajadoresPromise: Promise<any[]> = this.funciones.obtienetrabajadoresparainforme ?
        this.funciones.obtienetrabajadoresparainforme(filtro, variables.DIA, this.variables.OBRA, this.ORDENADO, this.ASC) as Promise<any[]> :
        carga.leer(['trabajadoresparainforme', variables.CLIENTES_RAZSOCIAL, filtro,
          variables.DIA, this.variables.OBRA, this.ORDENADO, this.ASC]) as Promise<any[]>;
      const turnosPromise = carga.leer(['turnos', variables.CLIENTES_RAZSOCIAL, this.valo])
        .catch(() => this.turnos || []);
      const trabajadoresRecibidos = await trabajadoresPromise;
      if (version !== this.versionLista) { return; }
      this.trabajadores = trabajadoresRecibidos.map(t => Object.assign({}, t, { _cargando: true, _errorCarga: false }));
      this.aplicarMarcasIncidenciasTrabajadores();
      // El asistente solo recibe esta lista mínima para permitir seleccionar un trabajador.
      this.variables.TRABAJADORES_IA = this.trabajadores.map(t => ({
        CODIGO: t.CODIGO, NOMBRE: t.NOMBRE, TURNO: t.TURNO, OBRA: t.OBRA,
        HORAS_CONTRATO: t.HORAS_CONTRATO
      }));
      this.muestragif = 'no';
      this.detectarCambiosLista();
      // Las filas ya son visibles; los cálculos detallados continúan después.
      const turnosRecibidos = await turnosPromise;
      if (version !== this.versionLista) { return; }
      this.turnos = turnosRecibidos;
      await this.cargarAsignacionesMes(variables.DIA);
      this.trabajadores.forEach(trabajador => this.aplicarTurnoAsignadoTrabajador(trabajador, variables.DIA, turnosRecibidos));
      this.variables.TRABAJADORES_IA = this.trabajadores.map(t => ({
        CODIGO: t.CODIGO, NOMBRE: t.NOMBRE, TURNO: t.TURNO, OBRA: t.OBRA,
        HORAS_CONTRATO: t.HORAS_CONTRATO
      }));
      const exportaciones: any[][] = new Array(this.trabajadores.length);
      await Promise.all(this.trabajadores.map(async (trabajador, indice) => {
        try {
          if (trabajador.HOYPICO === '0' || trabajador.HOYPICO === 0) {
            // El motor antiguo no usaba el informe en estos casos: sólo las ausencias.
            const ausencias = await carga.leer(['obtenervacacionestipos', trabajador.CODIGO]);
            if (version !== this.versionLista) { return; }
            ausencias.forEach(a => {
              if (a.DIA === variables.DIA) {
                trabajador.DIA = '(' + this.conceptoAusencia(a, trabajador.NOMBRE) + ')';
              }
            });
          } else {
            let resumen = await carga.leer(['informe', variables.CLIENTES_RAZSOCIAL,
              trabajador.CODIGO, trabajador.OBRA, this.valo, this.valo,
              variables.DIA, variables.DIA, variables.MODO]);
            if (version !== this.versionLista) { return; }
            resumen = await this.funciones.normalizarJornadasMedianoche(
              resumen, trabajador.CODIGO, variables.DIA, variables.DIA, true);
            // Se conserva una copia mínima del resumen del día para que
            // Ahorita pueda conocer las horas previstas del turno sin volver
            // a consultar el informe al revisar una secuencia incompleta.
            await this.aplicarAsignacionesAfilas(resumen, turnosRecibidos);
            trabajador._resumenIA = (resumen || []).map(r => Object.assign({}, r));
            // Reutilizamos las fórmulas existentes sin compartir sus acumuladores.
            const calculador: any = Object.create(this);
            calculador.variables = Object.create(variables);
            calculador.trabajadores = [Object.assign({}, trabajador)];
            calculador.turnos = turnosRecibidos;
            calculador.informetrabajadoressindetallesxls = [];
            calculador.funciones = { obtieneinforme: () => Promise.resolve(resumen) };
            await calculador.creaelinforme(0);
            if (version !== this.versionLista) { return; }
            if (calculador.variables.muestraerror === 'si') { throw new Error('No se pudo calcular la jornada'); }
            Object.assign(trabajador, calculador.trabajadores[0]);
            exportaciones[indice] = calculador.informetrabajadoressindetallesxls;
            this.detectarCambiosLista();
          }
        } catch (error) {
          if (version !== this.versionLista) { return; }
          trabajador._errorCarga = true;
          this.errorCargaLista = 'No se han podido actualizar todos los trabajadores. Pulsa Reintentar.';
        } finally {
          if (version === this.versionLista) { trabajador._cargando = false; }
          if (version === this.versionLista) { this.detectarCambiosLista(); }
        }
      }));
      if (version !== this.versionLista) { return; }
      this.informetrabajadoressindetallesxls = [].concat(...exportaciones.filter(f => !!f));
    } catch (error) {
      if (version === this.versionLista) {
        // No presentar como actuales las filas de la consulta anterior.
        this.trabajadores = [];
        this.errorCargaLista = 'No se pudo actualizar la lista. Comprueba la conexión y pulsa Reintentar.';
        this.detectarCambiosLista();
      }
    } finally {
      if (version === this.versionLista) {
        this.cargandoLista = false;
        this.muestragif = 'no';
        this.detectarCambiosLista();
      }
    }
  }


  
  
  onChange($event, valo1) {
    if ($event === this.DIAdehoy) { return; }
    this.actualizarFechaLista($event);
    this.storage.set('DIASELECIONADO', this.variables.DIA);
    // No reconstruir la página, sus formularios ni todos los catálogos.
    this.trabajadores = [];
    this.refrescarFiestasLista();
    this.obtieneincidencias();
    this.obtenertrabajadores(this.filtroLista || this.valo);
  }

  private actualizarFechaLista(dia: string): void {
    const fecha = /^\d{4}-\d{2}-\d{2}$/.test(dia || '') ? new Date(dia + 'T12:00:00') : new Date();
    this.variables.DIA = fecha.getFullYear() + '-' + this.twoDigits(fecha.getMonth() + 1) + '-' + this.twoDigits(fecha.getDate());
    this.DIAdehoy = this.variables.DIA;
    this.dia = this.DIAdehoy.substr(8, 2);
    this.MESHOY = fecha.getMonth() + 1;
    this.anohoy = fecha.getFullYear();
    this.ultimomes = new Date(this.anohoy, this.MESHOY, 0).getDate();
    this.FechaIni = this.DIAdehoy.substr(0, 8) + '01';
    this.FechaFin = this.DIAdehoy.substr(0, 8) + this.ultimomes;
    this.actualizarFiestaLista();
    this.actualizarMarcasCalendario();
  }

  private actualizarFiestaLista(): void {
    const fiesta = (this.diasdefiesta || []).find(f => f.DIA == this.dia && f.MES == this.MESHOY);
    this.fiesta = fiesta ? fiesta.NOMBRE : this.diaSemanaGrande(this.variables.DIA);
  }

  private refrescarFiestasLista(): void {
    this.funciones.obtienefiestas().then(data => {
      this.diasdefiesta = data;
      this.actualizarFiestaLista();
    }).catch(error => console.log(error));
  }

  ionViewWillEnter(): void {
    setTimeout(() => this.mostrarNovedadPendiente(), 450);
    if (!this.listaVisitada) { this.listaVisitada = true; return; }
    if (this.DIAdehoy !== this.variables.DIA) { this.trabajadores = []; }
    this.actualizarFechaLista(this.variables.DIA);
    this.refrescarFiestasLista();
    this.obtieneincidencias();
    this.obtenertrabajadores(this.filtroLista || this.valo);
  }

  private async mostrarNovedadPendiente(): Promise<void> {
    const cliente = this.variables.CLIENTES_RAZSOCIAL || '';
    if (!cliente) { return; }
    if (typeof localStorage === 'undefined') { return; }
    const clave = 'novedad:pdf-detalle-explicativo:v1:' + cliente;
    if (localStorage.getItem(clave) === '1') { return; }

    // Evita dos avisos si la pantalla entra dos veces mientras responde la API.
    if (this.cargandoNovedad) { return; }
    this.cargandoNovedad = true;

    const claveServidor = 'pdf-detalle-explicativo-v1';
    try {
      const estado: any = await this.funciones.obtieneEstadoNovedad(claveServidor);
      const fila: any = Array.isArray(estado) ? (estado[0] || {}) : (estado || {});
      if (String(fila.VISTA || fila.vista || '').toLowerCase() === '1' || fila.VISTA === true) {
        localStorage.setItem(clave, '1');
        return;
      }
    } catch (error) {
      // Las versiones antiguas del servidor no tienen aún estas rutas.
      // En ese caso se mantiene el comportamiento local sin bloquear la pantalla.
      console.log('No se pudo consultar el estado de la novedad', error);
    } finally {
      this.cargandoNovedad = false;
    }

    const aviso = this.alertCtrl.create({
      cssClass: 'novedad-alert',
      title: 'Nueva funcionalidad',
      message: '<b>Detalle explicativo del informe mensual</b><br><br>' +
        'Activa en Configuracion la opcion <b>Incluir detalle explicativo en el PDF mensual</b> ' +
        'para anadir una segunda pagina con las picadas, los tramos y la linea de tiempo de cada dia.<br><br>' +
        'La primera pagina y sus textos legales no cambian.',
      buttons: [
        { text: 'Ver mas tarde', role: 'cancel' },
        { text: 'Marcar como visto', handler: () => {
          localStorage.setItem(clave, '1');
          this.funciones.marcaNovedadVista(claveServidor).catch(error =>
            console.log('No se pudo guardar el estado de la novedad', error));
        } }
      ]
    });
    aviso.present();
  }

  ionViewWillLeave(): void {
    ++this.versionLista;
    if (this.cargaLista) { this.cargaLista.cancelar(); }
    if (this.cargaIncidencias) { this.cargaIncidencias.cancelar(); this.cargaIncidencias = null; }
  }

  reintentarCargaLista(): void {
    this.obtieneincidencias();
    this.obtenertrabajadores(this.filtroLista || this.valo);
  }

  identificarTrabajador(indice: number, trabajador: any): any {
    return trabajador.CODIGO;
  }


  minutosAHoras(minutos) {
    const h = Math.floor(minutos / 60);
    const m = minutos % 60;
    // Devuelve con dos dígitos siempre
    return h.toString().padStart(2, "0") + ":" + m.toString().padStart(2, "0");
  }

  private aplicarAlmuerzoConfigurado(fila: any): void {
    if (!fila) { return; }

    const valor = String(fila.ALMUERZO == null ? '' : fila.ALMUERZO).trim();
    if (!valor) { return; }

    let minutos = 0;
    if (valor.indexOf(':') >= 0) {
      const partes = valor.split(':');
      minutos = (Number(partes[0]) || 0) * 60 + (Number(partes[1]) || 0);
    } else {
      const numero = Number(valor);
      if (!isFinite(numero) || numero <= 0) { return; }
      minutos = numero < 24 ? Math.round(numero * 60) : Math.round(numero);
    }

    const almuerzoActual = String(
      fila.HORAS_ALMORZANDO == null ? '' : fila.HORAS_ALMORZANDO
    ).trim();
    if (minutos > 0 && (!almuerzoActual || almuerzoActual === '00:00')) {
      fila.HORAS_ALMORZANDO = this.minutosAHoras(minutos);
    }
  }
  
  
  getFechaCaducidad(): Date {
    const hoy = new Date();
  
    const dias = parseInt(this.variables.licenciadiasrestantes, 10) || 0;
  
    const fechaCad = new Date();
    fechaCad.setDate(hoy.getDate() + dias);
  
    return fechaCad;
  }
  
  puedeMostrarTrabajadores(): boolean {
    try {
      if (!this.variables.DIA) {
        return false;
      }
  
      const fechaSeleccionada = new Date(this.variables.DIA + 'T00:00:00');
  
      // Si la licencia sigue activa, mostrar siempre
      if ((parseInt(this.variables.licenciadiasrestantes, 10) || 0) >= 0) {
        return true;
      }
  
      // Si está caducada, calcular hasta qué fecha se puede consultar
      const fechaCaducidad = this.getFechaCaducidad();
      fechaCaducidad.setHours(23, 59, 59, 999);
  
      return fechaSeleccionada <= fechaCaducidad;
  
    } catch (e) {
      return false;
    }
  }
  
  getFechaCaducidadTexto(): string {
    try {
      const fecha = this.getFechaCaducidad();
      const dia = ('0' + fecha.getDate()).slice(-2);
      const mes = ('0' + (fecha.getMonth() + 1)).slice(-2);
      const ano = fecha.getFullYear();
      return dia + '/' + mes + '/' + ano;
    } catch (e) {
      return '';
    }
  }
  
  async creaelinforme(i) {
    this.informetrabajadores = [];
    var obj = await this.funciones.obtieneinforme(
      this.trabajadores[i].CODIGO,
      this.trabajadores[i].OBRA,
      "654321123456",
      "654321123456",
      this.variables.DIA,
      this.variables.DIA,
      this.variables.MODO
    ).then(async (data: any[]) => {
      this.informetrabajadores = this.funciones.normalizarJornadasMedianoche ?
        await this.funciones.normalizarJornadasMedianoche(
          data as any[], this.trabajadores[i].CODIGO, this.variables.DIA, this.variables.DIA, true) : data;
  
      var sumahorasparadas;
      var sumaminutosparadas;
      var sumahorasalmuerzo;
      var sumaminutosalmuerzos;
      var sumahorassintrabajar;
      var sumaminutossintrabajar;
      var horas;
      var minutos;
      var lug;
  
      this.imagenactual = "";
      this.cuenta = 0;
      this.informetrabajadoressindetalles = [];
  
      for (var _i = 0; _i < this.informetrabajadores.length; _i++) {

        if (this.trabajadores[i].HOYPICO != "0") {

          if (this.informetrabajadores[_i].PICADA_INICIAL != "no") {

            if (this.informetrabajadores[_i].NOMBRE != "SAL") {
              /*   CAMBIO LAS PICADAS PARA EL INFORME DE PRUEBAS             */


              if (this.variables.MODO != "real") {
                 

                /*---------------------------------------------------*/
                /*  modo de pruebas /* 
                /*---------------------------------------------------*/

                this.HIni = Number(
                  this.informetrabajadores[_i].HORA_ENTRADA.substr(0, 2)
                );
                this.MIni = Number(
                  this.informetrabajadores[_i].HORA_ENTRADA.substr(3, 2)
                );
  
                //BUSCO UN ICAJE ALEATORIO
                this.Aleatorio = this.variables.numeroAleatorio(-7, 7);
                //console.log("ale1:" + this.Aleatorio);
  
                if (Number(this.Aleatorio) > 0) {
                  if (Number(this.MIni) + Number(this.Aleatorio) > 59) {
                    this.HIni = Number(this.HIni) + 1;
                    this.MIni =
                      Number(this.Aleatorio) + Number(this.MIni) - 59;
                  } else {
                    this.MIni = Number(this.Aleatorio) + Number(this.MIni);
                  }
                } else {
                  if (Number(this.MIni) + Number(this.Aleatorio) < 0) {
                    this.HIni = Number(this.HIni) - 1;
                    this.MIni =
                      Number(this.MIni) + Number(this.Aleatorio) + 59;
                  } else {
                    this.MIni = Number(this.MIni) + Number(this.Aleatorio);
                  }
                }
       

                this.informetrabajadores[_i].PICADA_INICIAL =
                (this.HIni < 10 ? "0" + this.HIni : this.HIni) +
                ":" +
                (this.MIni < 10 ? "0" + this.MIni : this.MIni);

                
                
            
             

                if ( Number(this.informetrabajadores[_i].HORAS_PREVISTAS) < 0 ) {
                  
                  this.informetrabajadores[_i].HORAS_PREVISTAS =
                    this.informetrabajadores[_i].HORAS_PREVISTAS.substr(1);
                

                    this.HIni = Number(this.informetrabajadores[_i].PICADA_INICIAL.substr(0, 2));
                    this.MIni = Number(this.informetrabajadores[_i].PICADA_INICIAL.substr(3, 2));
                    
                    // Convertir horas y minutos de PICADA_INICIAL a minutos totales
                    let totalMinutosInicial = this.HIni * 60 + this.MIni;
                    
                    // Convertir HORAS_PREVISTAS a minutos totales
                    
                    let minutosPrevistos=0;

                    if (Number(this.informetrabajadores[_i].HORAS_PREVISTAS)<24){
                      minutosPrevistos = Math.round(Number(this.informetrabajadores[_i].HORAS_PREVISTAS) * 60);
                    }else{
                      minutosPrevistos = Number(this.informetrabajadores[_i].HORAS_PREVISTAS);
                    }
                    
                    // Sumar los minutos de PICADA_INICIAL y los minutos de HORAS_PREVISTAS
                    let totalMinutosFinal = totalMinutosInicial + minutosPrevistos;
                    
                    // Calcular las horas y los minutos del resultado
                    this.HIni = Math.floor(totalMinutosFinal / 60);
                    this.MIni = totalMinutosFinal % 60;
                    
                    this.Aleatorio = this.variables.numeroAleatorio(-7, 7);
                    // ... (código para ajustar this.HIni y this.MIni con el valor aleatorio)
                    
                    this.informetrabajadores[_i].PICADA_FINAL =
                        (this.HIni < 10 ? "0" + this.HIni : this.HIni) +
                        ":" +
                        (this.MIni < 10 ? "0" + this.MIni : this.MIni);

                    
                  } else {
                
                    

                  this.HIni = Number(
                    this.informetrabajadores[_i].HORA_SALIDA.substr(0, 2)
                  );
                  this.MIni = Number(
                    this.informetrabajadores[_i].HORA_SALIDA.substr(3, 2)
                  );
                  //BUSCO UN ICAJE ALEATORIO
                  this.Aleatorio = this.variables.numeroAleatorio(-7, 7);
                  

                  if (Number(this.Aleatorio) > 0) {
                    if (Number(this.MIni) + Number(this.Aleatorio) > 59) {
                      this.HIni = Number(this.HIni) + 1;
                      this.MIni =
                        Number(this.Aleatorio) + Number(this.MIni) - 59;
                    } else {
                      this.MIni =
                        Number(this.Aleatorio) + Number(this.MIni);
                    }
                  } else {
                    if (Number(this.MIni) + Number(this.Aleatorio) < 0) {
                      this.HIni = Number(this.HIni) - 1;
                      this.MIni =
                        Number(this.MIni) + Number(this.Aleatorio) + 59;
                    } else {
                      this.MIni =
                        Number(this.MIni) + Number(this.Aleatorio);
                    }
                  }

                  /*mODIFICA LA PICADA FINAL*/
                  this.informetrabajadores[_i].PICADA_FINAL =
                    (this.HIni < 10 ? "0" + this.HIni : this.HIni) +
                    ":" +
                    (this.MIni < 10 ? "0" + this.MIni : this.MIni);
                }
            }  //ACABA MODO NO REAL

            // Si falta la salida, se mantiene "no" para mostrarla vacía y
            // sombreada, pero se calcula provisionalmente como las 24:00.
            const picadaFinalParaCalculo = this.horaValida(this.informetrabajadores[_i].PICADA_FINAL) ?
              this.informetrabajadores[_i].PICADA_FINAL : "24:00";

            var MM1 = 0;

                  var start_actual_time = +new Date(
                    Date.UTC(
                      this.informetrabajadores[_i].FECHA.substr(0, 4),
                      this.informetrabajadores[_i].FECHA.substr(5, 2),
                      this.informetrabajadores[_i].FECHA.substr(8, 2),
                      this.informetrabajadores[_i].PICADA_INICIAL.substr(0, 2) -
                        2,
                      this.informetrabajadores[_i].PICADA_INICIAL.substr(3, 2),
                      0
                    )
                  );


                  var end_actual_time = +new Date(
                    Date.UTC(
                      this.informetrabajadores[_i].FECHA.substr(0, 4),
                      this.informetrabajadores[_i].FECHA.substr(5, 2),
                      this.informetrabajadores[_i].FECHA.substr(8, 2),
                      picadaFinalParaCalculo.substr(0, 2) -
                        2,
                      picadaFinalParaCalculo.substr(3, 2),
                      0
                    )
                  );

                  

                  var diff = end_actual_time - start_actual_time;

                  var diffSeconds = diff / 1000;
                  var HH = Math.floor(diffSeconds / 3600);
                  var MM = Math.floor(diffSeconds % 3600) / 60;
                  var formatted =
                    (HH < 10 ? "0" + HH : HH) + ":" + (MM < 10 ? "0" + MM : MM);
                  
                  
                  this.informetrabajadores[_i].HORAS_TRANSCURRIDAS =
                    (HH < 10 ? "0" + HH : HH) +
                    ":" +
                    (MM < 10 ? "0" + MM : MM) +
                    "";
                    
                  this.informetrabajadores[_i].COLOR = "#FFFFFF";

                  lug = _i;

                  this.informetrabajadores[lug].ALMUERZO = this.informetrabajadores[_i].ALMUERZO;

                  this.informetrabajadores[lug].HORAS_AJUSTE = this.informetrabajadores[_i].HORAS_AJUSTE;

                  

                  sumahorasparadas = 0;
                  sumaminutosparadas = 0;
                  sumahorasalmuerzo = 0;
                  sumaminutosalmuerzos = 0;
                  sumahorassintrabajar = 0;
                  sumaminutossintrabajar = 0;
                  horas = 0;
                  minutos = 0;

            } else {
                  /*  suma las paradas */

                  start_actual_time = +new Date(
                    Date.UTC(
                      this.informetrabajadores[_i].FECHA.substr(0, 4),
                      this.informetrabajadores[_i].FECHA.substr(5, 2),
                      this.informetrabajadores[_i].FECHA.substr(8, 2),
                      this.informetrabajadores[_i].PICADA_INICIAL.substr(0, 2) -
                        2,
                      this.informetrabajadores[_i].PICADA_INICIAL.substr(3, 2),
                      0
                    )
                  );
                  end_actual_time = +new Date(
                    Date.UTC(
                      this.informetrabajadores[_i].FECHA.substr(0, 4),
                      this.informetrabajadores[_i].FECHA.substr(5, 2),
                      this.informetrabajadores[_i].FECHA.substr(8, 2),
                      (this.horaValida(this.informetrabajadores[_i].PICADA_FINAL) ?
                        this.informetrabajadores[_i].PICADA_FINAL : "24:00").substr(0, 2) - 2,
                      (this.horaValida(this.informetrabajadores[_i].PICADA_FINAL) ?
                        this.informetrabajadores[_i].PICADA_FINAL : "24:00").substr(3, 2), 0
                    )
                  );

                  diff = end_actual_time - start_actual_time;

                  diffSeconds = diff / 1000;
                  HH = Math.floor(diffSeconds / 3600);
                  MM = Math.floor(diffSeconds % 3600) / 60;

                  
                  
                  if (this.variables.MODO == "real") {

                    switch (this.informetrabajadores[_i].TIPO) {
                      case "Almorzando":
                        sumahorasalmuerzo = sumahorasalmuerzo + HH;
                        sumaminutosalmuerzos = sumaminutosalmuerzos + MM;
                        //SI EXISTE ALMUERZO COMO MIN UNA HORA
                        if (HH < 1) {
                          this.informetrabajadores[lug].HORAS_ALMORZANDO =
                            "01:00";
                        } else {
                          this.informetrabajadores[lug].HORAS_ALMORZANDO =
                            sumahorasalmuerzo + ":" + sumaminutosalmuerzos + "";
                          this.informetrabajadores[lug].HORAS_ALMORZANDO =
                            (sumahorasalmuerzo < 10
                              ? "0" + sumahorasalmuerzo
                              : sumahorasalmuerzo) +
                            ":" +
                            (sumaminutosalmuerzos < 10
                              ? "0" + sumaminutosalmuerzos
                              : sumaminutosalmuerzos) +
                            "";
                        }

                        

                        break;

                      case "Desayunando":
                      case "Comprando":
                      case "Descansando":
                      case "Viajando":
                      case "Otros":
                        // console.log("Entra en horas parasdas");
                        sumahorasparadas = sumahorasparadas + HH;
                        sumaminutosparadas = sumaminutosparadas + MM;
                        if (sumaminutosparadas >= 60) {
                          sumaminutosparadas = sumaminutosparadas - 60;
                          sumahorasparadas = sumahorasparadas + 1;
                        }
                        this.informetrabajadores[lug].HORAS_PARADAS =
                          (sumahorasparadas < 10
                            ? "0" + sumahorasparadas
                            : sumahorasparadas) +
                          ":" +
                          (sumaminutosparadas < 10
                            ? "0" + sumaminutosparadas
                            : sumaminutosparadas) +
                          "";

                        break;

                      default:
                        this.informetrabajadores[_i].TIPO = "";
                        sumahorassintrabajar = sumahorassintrabajar + HH;
                        sumaminutossintrabajar = sumaminutossintrabajar + MM;
                        if (sumaminutossintrabajar >= 60) {
                          sumaminutossintrabajar = sumaminutossintrabajar - 60;
                          sumahorassintrabajar = sumahorassintrabajar + 1;
                        }

                        this.informetrabajadores[lug].HORAS_SIN_TRABAJAR =
                          (sumahorassintrabajar < 10
                            ? "0" + sumahorassintrabajar
                            : sumahorassintrabajar) +
                          ":" +
                          (sumaminutossintrabajar < 10
                            ? "0" + sumaminutossintrabajar
                            : sumaminutossintrabajar) +
                          "";

                      

                        break;
                    }

                  }else{


                    sumahorassintrabajar = sumahorassintrabajar + HH;
                    sumaminutossintrabajar = sumaminutossintrabajar + MM;
                    if (sumaminutossintrabajar >= 60) {
                      sumaminutossintrabajar = sumaminutossintrabajar - 60;
                      sumahorassintrabajar = sumahorassintrabajar + 1;
                    }

                    this.informetrabajadores[lug].HORAS_SIN_TRABAJAR =
                      (sumahorassintrabajar < 10
                        ? "0" + sumahorassintrabajar
                        : sumahorassintrabajar) +
                      ":" +
                      (sumaminutossintrabajar < 10
                        ? "0" + sumaminutossintrabajar
                        : sumaminutossintrabajar) +
                      "";



                  }
                }

                if (this.informetrabajadores[_i].NOMBRE != "SAL") {

                  this.aplicarAlmuerzoConfigurado(this.informetrabajadores[lug]);



                  this.informetrabajadoressindetalles.push({
                    FECHA: "" + this.informetrabajadores[lug].FECHA,
                    CODIGO: "" + this.informetrabajadores[lug].CODIGO,
                    NOMBRE: "" + this.informetrabajadores[lug].NOMBRE,
                    EMPRESA: "" + this.informetrabajadores[lug].EMPRESA,
                    OBRA: "" + this.informetrabajadores[lug].OBRA,
                    PICADA_INICIAL: "" + this.informetrabajadores[lug].PICADA_INICIAL,
                    PICADA_FINAL: "" + this.informetrabajadores[lug].PICADA_FINAL,
                    _PICADA_VIRTUAL_MEDIANOCHE: !!this.informetrabajadores[lug]._PICADA_VIRTUAL_MEDIANOCHE,
                    HORAS_TRANSCURRIDAS:
                      "" + this.informetrabajadores[lug].HORAS_TRANSCURRIDAS,
                    HORAS_TRABAJADAS:
                      "" + this.informetrabajadores[lug].HORAS_TRABAJADAS,
                    HORAS_PARADAS:
                      "" + this.informetrabajadores[lug].HORAS_PARADAS,
                    HORAS_SIN_TRABAJAR:
                      "" + this.informetrabajadores[lug].HORAS_SIN_TRABAJAR,
                    HORAS_ALMORZANDO:
                      "" + this.informetrabajadores[lug].HORAS_ALMORZANDO,
                    HORAS_AJUSTE:
                      "" + this.informetrabajadores[lug].HORAS_AJUSTE,
                    HORAS_EXTRAS:
                      "" + this.informetrabajadores[lug].HORAS_EXTRAS,
                  });

                  this.informetrabajadoressindetallesxls.push({
                    FECHA: "" + this.informetrabajadores[lug].FECHA,
                    CODIGO: "" + this.informetrabajadores[lug].CODIGO,
                    NOMBRE: "" + this.informetrabajadores[lug].NOMBRE,
                    EMPRESA: "" + this.informetrabajadores[lug].EMPRESA,
                    OBRA: "" + this.informetrabajadores[lug].OBRA,
                    PICADA_INICIAL:
                      "" + this.informetrabajadores[lug].PICADA_INICIAL,
                    PICADA_FINAL:
                      "" + this.informetrabajadores[lug].PICADA_FINAL,
                    _PICADA_VIRTUAL_MEDIANOCHE: !!this.informetrabajadores[lug]._PICADA_VIRTUAL_MEDIANOCHE,
                    HORAS_TRANSCURRIDAS:
                      "" + this.informetrabajadores[lug].HORAS_TRANSCURRIDAS,
                    HORAS_TRABAJADAS:
                      "" + this.informetrabajadores[lug].HORAS_TRABAJADAS,
                    HORAS_PARADAS:
                      "" + this.informetrabajadores[lug].HORAS_PARADAS,
                    HORAS_SIN_TRABAJAR:
                      "" + this.informetrabajadores[lug].HORAS_SIN_TRABAJAR,
                    HORAS_ALMORZANDO:
                      "" + this.informetrabajadores[lug].HORAS_ALMORZANDO,
                    HORAS_AJUSTE:
                      "" + this.informetrabajadores[lug].HORAS_AJUSTE,
                    HORAS_EXTRAS:
                      "" + this.informetrabajadores[lug].HORAS_EXTRAS,
                  });

                  this.cuenta = this.cuenta + 1;
                }

                this.totalizatrabajadorinforme(lug);

                //this.trabajadores[i].NOMBRE = this.informetrabajadores[lug].NOMBRE;
                this.trabajadores[i].INCIDENCIA =  this.informetrabajadores[lug].INCIDENCIA;
                this.trabajadores[i].EMPRESA =  this.informetrabajadores[lug].EMPRESA;
                this.trabajadores[i].PICADA_INICIAL = this.informetrabajadores[lug].PICADA_INICIAL;
                this.trabajadores[i].PICADA_FINAL = this.informetrabajadores[lug].PICADA_FINAL;
                this.trabajadores[i]._PICADA_VIRTUAL_MEDIANOCHE = !!this.informetrabajadores[lug]._PICADA_VIRTUAL_MEDIANOCHE;

                this.trabajadores[i].HORAS_TRABAJADAS =  this.informetrabajadores[lug].HORAS_TRABAJADAS;
                this.trabajadores[i].HORAS_PARADAS =  this.informetrabajadores[lug].HORAS_PARADAS;
                this.trabajadores[i].HORAS_SIN_TRABAJAR = this.informetrabajadores[lug].HORAS_SIN_TRABAJAR;
                this.trabajadores[i].HORAS_ALMORZANDO = this.informetrabajadores[lug].HORAS_ALMORZANDO;
                this.trabajadores[i].HORAS_EXTRAS = this.informetrabajadores[lug].HORAS_EXTRAS;
                this.trabajadores[i].HORAS_EXTRAS_CON_AJUSTE = this.informetrabajadores[lug].HORAS_EXTRAS_CON_AJUSTE;
                this.trabajadores[i].HORAS_AJUSTE = this.informetrabajadores[lug].HORAS_AJUSTE;
                this.trabajadores[i].CORTESIA = this.informetrabajadores[lug].CORTESIA;
                this.trabajadores[i].COLOR =  this.informetrabajadores[lug].COLOR;

                if (this.informetrabajadores[lug] && this.informetrabajadores[lug].DIA) {
                  this.trabajadores[i].DIA = "(" +  this.informetrabajadores[lug].DIA + ")";
                } else {
                  this.trabajadores[i].DIA = "";
                }
                
              } 

            }else{
              
              // NO EXISTEN PICADAS, CONFIRMAR SI EXISTE OTRO MOTIVO 

              //if (this.informetrabajadores[0].DIA=="Vacaciones"){
              
                this.variables.obtenerVacaciones(this.trabajadores[i].CODIGO).then((data) => {
                  this.variables.diasOcupados = data;

                  for (var _i = 0; _i < this.variables.diasOcupados.length; _i++) {
                    
                  
                    if (this.variables.diasOcupados[_i].DIA == this.variables.DIA) {

                      this.trabajadores[i].DIA = "(" + this.conceptoAusencia(this.variables.diasOcupados[_i], this.trabajadores[i].NOMBRE) + ")";

                    }
                  }

                });
                 
              //}else{

              //  this.trabajadores[i].DIA = "";

             // }

            }
          }
        //}
        //this.variables.muestragif="no";
        //this.totalizatrabajadorinforme(lug);

    }
      )
      .catch((error) => {
        this.variables.muestragif = "no";
        this.variables.muestraerror = "si";
        console.log(error);
      });
  }


  private minToHHMM24(mins: number): string {
    if (!isFinite(mins)) return "00:00";
  
    // Normalizar al rango 0–1439 minutos (un día)
    mins = ((mins % (24 * 60)) + (24 * 60)) % (24 * 60);
  
    const h = Math.floor(mins / 60);
    const m = mins % 60;
  
    return (h < 10 ? "0" + h : h) + ":" + (m < 10 ? "0" + m : m);
  }

  async totalizatrabajadorinforme(lug) {
    var horascompletas = 0;
    var horascomida;
    var horasPrevistas =0;
    var minutosPrevistos=0;
    var diferenciaMinutos =0;
    var minutosFinal=0;
    var minutosInicial=0;

    const filaInforme = this.informetrabajadores[lug];
    const transcurridasVirtualesValidas = !!filaInforme &&
      !!filaInforme._PICADA_VIRTUAL_MEDIANOCHE &&
      String(filaInforme.HORAS_TRANSCURRIDAS || '').trim() === '24:00';
    if (!filaInforme ||
        !this.horaValida(filaInforme.PICADA_INICIAL) ||
        (!this.horaValida(filaInforme.HORAS_TRANSCURRIDAS) && !transcurridasVirtualesValidas)) {
      if (this.informetrabajadores[lug]) {
        this.informetrabajadores[lug].HORAS_TRABAJADAS = "";
        this.informetrabajadores[lug].HORAS_EXTRAS = "";
        this.informetrabajadores[lug].HORAS_EXTRAS_CON_AJUSTE = "";
      }
      return;
    }

    const minutosSinTrabajarReales = Number(this.informetrabajadores[lug]._MINUTOS_SIN_TRABAJAR_REAL);
    const tienePausaRealMedianoche = !!this.informetrabajadores[lug]._PICADA_VIRTUAL_MEDIANOCHE &&
      isFinite(minutosSinTrabajarReales) && minutosSinTrabajarReales >= 0;
    if (tienePausaRealMedianoche && this.variables.MODO == "real") {
      this.informetrabajadores[lug].HORAS_SIN_TRABAJAR = this.minToHHMM24(minutosSinTrabajarReales);
    }

    if (this.variables.MODO == "real") {
      /*RESTAMOS LAS HORAS TRANSCURRIDAS MENOS LAS DE SIN TRABAJAR - HORAS ALMORZANDO */

      this.hg = this.informetrabajadores[lug].HORAS_TRANSCURRIDAS.substr(0, 2);
      this.mg = this.informetrabajadores[lug].HORAS_TRANSCURRIDAS.substr(3, 2);
      /* si no existen horas sin trabajar*/

      if (this.informetrabajadores[lug].HORAS_SIN_TRABAJAR) {
        this.hp = this.informetrabajadores[lug].HORAS_SIN_TRABAJAR.substr(0, 2);
        this.mp = this.informetrabajadores[lug].HORAS_SIN_TRABAJAR.substr(3, 2);
        this.hg1 = Number(this.hg) - Number(this.hp);
        this.mg1 = Number(this.mg) - Number(this.mp);
        if (this.mg1 < 0) {
          this.mg1 = 60 + Number(this.mg1);
          this.hg1 = Number(this.hg1) - 1;
        }
        this.informetrabajadores[lug].HORAS_TRABAJADAS =
          (this.hg1 < 10 ? "0" + this.hg1 : this.hg1) +
          ":" +
          (this.mg1 < 10 ? "0" + this.mg1 : this.mg1);
      } else {

        this.informetrabajadores[lug].HORAS_TRABAJADAS =
          this.informetrabajadores[lug].HORAS_TRANSCURRIDAS;
      }

      /*RESTAMOS LAS HORAS TRABAJADAS MENOS LAS HORAS DE COMER      */
      this.hg = this.informetrabajadores[lug].HORAS_TRABAJADAS.substr(0, 2);
      horascompletas = this.hg;
      this.mg = this.informetrabajadores[lug].HORAS_TRABAJADAS.substr(3, 2);

            
      

      if (this.informetrabajadores[lug].HORAS_ALMORZANDO) {
        // Obtener horas y minutos de HORAS_ALMORZANDO
        this.hp = this.informetrabajadores[lug].HORAS_ALMORZANDO.substr(0, 2);
        this.mp = this.informetrabajadores[lug].HORAS_ALMORZANDO.substr(3, 2);
    
        // Convertir horas a minutos y sumar los minutos
        let totalMinutosAlmuerzo = Number(this.hp) * 60 + Number(this.mp); 
        let totalMinutosTrabajados = Number(this.hg) * 60 + Number(this.mg);
    
        let totalMinutosResultantes = totalMinutosTrabajados - totalMinutosAlmuerzo;
        
        
        // Calcular horas y minutos a partir de la diferencia
        this.hg1 = Math.floor(Math.abs(totalMinutosResultantes) / 60);
        this.mg1 = Math.abs(totalMinutosResultantes) % 60;
    
        // Determinar si la diferencia es negativa (menos horas trabajadas)
        let signo = totalMinutosResultantes < 0 ? "-" : "";


        this.informetrabajadores[lug].HORAS_TRABAJADAS = 
        signo +
        (this.hg1 < 10 ? "0" + this.hg1 : this.hg1) +
        ":" +
        (this.mg1 < 10 ? "0" + this.mg1 : this.mg1);
        
    }
    

      //console.log("dia:" + this.informetrabajadores[lug].DIA   + " -> " + this.informetrabajadores[lug].HORAS_PREVISTAS  + "--" + this.informetrabajadores[lug].HORAS_TRABAJADAS);

      if (this.informetrabajadores[lug].DIA == "Fiesta") {
        this.informetrabajadores[lug].HORAS_PREVISTAS = "0";
      }

        this.informetrabajadores[lug].COLOR = "NORMAL";
    
        
    
        
        // Convertir HORAS_PREVISTAS a minutos
        if (Number(this.informetrabajadores[lug].HORAS_PREVISTAS)<0){

          this.informetrabajadores[lug].HORAS_PREVISTAS = this.informetrabajadores[lug].HORAS_PREVISTAS.substr(1);

        }
      
      
        horasPrevistas = Number(this.informetrabajadores[lug].HORAS_PREVISTAS);

        if (horasPrevistas < 24){
          minutosPrevistos = Math.round(horasPrevistas * 60); // Redondear a minutos
        }else{
          minutosPrevistos = horasPrevistas ; // Redondear a minutos
        }
    
        


        // Extraer horas y minutos trabajados, considerando el signo
let signoHorasTrabajadas = 1; 
if (this.informetrabajadores[lug].HORAS_TRABAJADAS.startsWith("-")) {
  signoHorasTrabajadas = -1;
  this.informetrabajadores[lug].HORAS_TRABAJADAS = this.informetrabajadores[lug].HORAS_TRABAJADAS.substring(1); // Eliminar el signo "-"

  this.hg = Number(this.informetrabajadores[lug].HORAS_TRABAJADAS.substr(0, 2)) * signoHorasTrabajadas;
  this.mg = Number(this.informetrabajadores[lug].HORAS_TRABAJADAS.substr(3, 2));
  
  this.informetrabajadores[lug].HORAS_TRABAJADAS = "-" + this.informetrabajadores[lug].HORAS_TRABAJADAS;

  
}else{

  this.hg = Number(this.informetrabajadores[lug].HORAS_TRABAJADAS.substr(0, 2)) * signoHorasTrabajadas;
  this.mg = Number(this.informetrabajadores[lug].HORAS_TRABAJADAS.substr(3, 2));

}




// Calcular total de minutos trabajados
let minutosTrabajados = this.hg * 60 + this.mg;

// Calcular la diferencia en minutos


diferenciaMinutos = minutosTrabajados - minutosPrevistos;


// Calcular horas y minutos a partir de la diferencia
this.hg1 = Math.floor(Math.abs(diferenciaMinutos) / 60);
this.mg1 = Math.abs(diferenciaMinutos) % 60;

// Determinar si la diferencia es negativa (menos horas trabajadas)
let signo = diferenciaMinutos < 0 ? "-" : "";

// Formatear el resultado
this.informetrabajadores[lug].HORAS_EXTRAS = 
    signo +
    (this.hg1 < 10 ? "0" + this.hg1 : this.hg1) +
    ":" +
    (this.mg1 < 10 ? "0" + this.mg1 : this.mg1);

        this.informetrabajadores[lug].HORAS_EXTRAS_CON_AJUSTE =
          this.informetrabajadores[lug].HORAS_EXTRAS;

// Asegúrate de que `CORTESIA` sea el valor en minutos que defines como el umbral de cortesía
// por ejemplo: this.informetrabajadores[lug].CORTESIA

// Obtenemos el valor de la cortesía en minutos
const cortesíaMinutos = Number(this.informetrabajadores[lug].CORTESIA);

// Verificamos si las HORAS_EXTRAS_CON_AJUSTE son negativas
if (this.informetrabajadores[lug].HORAS_EXTRAS_CON_AJUSTE.substr(0, 1) === "-") {
  // Si es negativo, procesamos de la siguiente forma
  
  // Extraemos las horas y los minutos de HORAS_EXTRAS_CON_AJUSTE (el valor es negativo, pero lo tomamos en positivo)
  this.hg1 = Number(this.informetrabajadores[lug].HORAS_EXTRAS_CON_AJUSTE.substr(1, 2)); // horas (sin el signo negativo)
  this.mg1 = Number(this.informetrabajadores[lug].HORAS_EXTRAS_CON_AJUSTE.substr(4, 2)); // minutos

  // Calculamos el total de minutos de las horas extras (en valor absoluto)
  const totalMinutos = this.hg1 * 60 + this.mg1;

  // Comprobamos si el total de minutos es menor o igual a la cortesía
  if (totalMinutos <= cortesíaMinutos) {
    // Si los minutos están dentro del valor de cortesía, redondeamos a :00
    this.informetrabajadores[lug].HORAS_EXTRAS_CON_AJUSTE = 
      "-" + this.hg1.toString().padStart(2, '0') + ":00"; // Redondeamos a la hora exacta con el signo negativo
  } else {
    // Si no están dentro del valor de cortesía, mantenemos el valor original
    this.informetrabajadores[lug].HORAS_EXTRAS_CON_AJUSTE = 
      "-" + this.hg1.toString().padStart(2, '0') + ":" + this.mg1.toString().padStart(2, '0');
  }

} else {
  // Si es positivo o igual a cero, no hacemos nada
  // Extraemos las horas y los minutos de HORAS_EXTRAS_CON_AJUSTE
  this.hg1 = Number(this.informetrabajadores[lug].HORAS_EXTRAS_CON_AJUSTE.substr(0, 2)); // horas
  this.mg1 = Number(this.informetrabajadores[lug].HORAS_EXTRAS_CON_AJUSTE.substr(3, 2)); // minutos

  // Calculamos el total de minutos de las horas extras
  const totalMinutos = this.hg1 * 60 + this.mg1;

  // Comprobamos si el total de minutos es menor o igual a la cortesía
  if (totalMinutos <= cortesíaMinutos) {
    // Si los minutos están dentro del valor de cortesía, redondeamos a :00
    this.informetrabajadores[lug].HORAS_EXTRAS_CON_AJUSTE = 
      this.hg1.toString().padStart(2, '0') + ":00"; // Redondeamos a la hora exacta
  }
  // Si no están dentro del valor de cortesía, mantenemos el valor original (no hay más lógica aquí)
}



// Nombre del turno del trabajador
const nombreTurno = (this.informetrabajadores[lug].TURNO || "").toLowerCase();
// Buscar el objeto turno dentro de this.turnos
let turnoObj: any = null;
if (this.turnos && this.turnos.length) {
  turnoObj = this.turnos.find(
    (t: any) => ((t.NOMBRE || t.TURNO || "").toLowerCase() === nombreTurno)
  );
}
if (turnoObj) {
  const modo = turnoObj.MODO;  // ← aquí tienes el MODO del turno
  // Ejemplo: si es guardia y cierto modo, ajustar horas
  if (modo === "guardia") {
    //console.log("Turno:", nombreTurno, " - MODO:", modo);
    this.informetrabajadores[lug].HORAS_EXTRAS_CON_AJUSTE = "00:00";
  }
} else {
}


this.informetrabajadores[lug].HORAS_EXTRAS = this.informetrabajadores[lug].HORAS_EXTRAS_CON_AJUSTE;


this.informetrabajadores[lug].HORAS_EXTRAS = this.informetrabajadores[lug].HORAS_EXTRAS_CON_AJUSTE;


        if (this.hg1 == 0) {
          if (this.mg1 >= -10 && this.mg1 <= 10) {
            this.informetrabajadores[lug].COLOR = "NEGRO";
          } else {
            this.informetrabajadores[lug].COLOR = "ROJO";
          }
        } else {
          this.informetrabajadores[lug].COLOR = "ROJO";
        }

      
    } else {


      //***************************************************************************
      //            modo pruebas
      //***************************************************************************

      // Extraer horas y minutos de PICADA_FINAL y PICADA_INICIAL
      const picadaFinalParaCalculo = this.horaValida(this.informetrabajadores[lug].PICADA_FINAL) ?
        this.informetrabajadores[lug].PICADA_FINAL : "24:00";
      this.hg = picadaFinalParaCalculo.substr(0, 2);
      this.mg = picadaFinalParaCalculo.substr(3, 2);

      this.hp = this.informetrabajadores[lug].PICADA_INICIAL.substr(0, 2);
      this.mp = this.informetrabajadores[lug].PICADA_INICIAL.substr(3, 2);

      // Calcular la diferencia en minutos entre PICADA_FINAL y PICADA_INICIAL
      minutosFinal = Number(this.hg) * 60 + Number(this.mg);
      minutosInicial = Number(this.hp) * 60 + Number(this.mp);

      var diferenciaMinutos2 = minutosFinal - minutosInicial;

      // Calcular horas y minutos a partir de la diferencia
      this.hg1 = Math.floor(diferenciaMinutos2 / 60);
      this.mg1 = diferenciaMinutos2 % 60;

      // Formatear HORAS_TRANSCURRIDAS
      this.informetrabajadores[lug].HORAS_TRANSCURRIDAS =
        (this.hg1 < 10 ? "0" + this.hg1 : this.hg1) +
        ":" +
        (this.mg1 < 10 ? "0" + this.mg1 : this.mg1);

        if (this.informetrabajadores[lug].DIA == "Fiesta") {
          this.informetrabajadores[lug].HORAS_PREVISTAS = "0";
        }
    
      // Convertir HORAS_PREVISTAS a minutos
    let horasPrevistas2 = Number(this.informetrabajadores[lug].HORAS_PREVISTAS);
    let minutosPrevistos2 = 0;

    if (horasPrevistas2 < 24){
      minutosPrevistos2 = Math.round(horasPrevistas2 * 60); // Redondear a minutos
    }else{
      minutosPrevistos2 = horasPrevistas2 ; // Redondear a minutos
    }

    
    this.hg = this.informetrabajadores[lug].HORAS_TRANSCURRIDAS.substr(0, 2);
    this.mg = this.informetrabajadores[lug].HORAS_TRANSCURRIDAS.substr(3, 2);
    
    let totalminutostrabajados = Number(this.hg) * 60 + Number(this.mg); 

    // Calcular la diferencia en minutos entre HORAS_TRANSCURRIDAS y HORAS_PREVISTAS
    let diferenciaMinutos3 = totalminutostrabajados - minutosPrevistos2;



    // Calcular horas y minutos a partir de la diferencia
    this.hg1 = Math.floor(Math.abs(diferenciaMinutos3) / 60);
    this.mg1 = Math.abs(diferenciaMinutos3) % 60;

    this.informetrabajadores[lug].HORAS_SIN_TRABAJAR =
    (this.hg1 < 10 ? "0" + this.hg1 : this.hg1) +
    ":" +
    (this.mg1 < 10 ? "0" + this.mg1 : this.mg1);

  

    if (diferenciaMinutos3 < Number(10)){
      this.informetrabajadores[lug].HORAS_SIN_TRABAJAR = "00:00";
    }else{

      //BUSCO UN ICAJE ALEATORIO

      this.HIni = this.informetrabajadores[lug].HORAS_SIN_TRABAJAR.substr(0, 2);
      this.MIni = this.informetrabajadores[lug].HORAS_SIN_TRABAJAR.substr(3, 2);

      var minutosale = Number(this.HIni) * 60 + Number(this.MIni); 
      
      
      
      this.Aleatorio = this.variables.numeroAleatorio(-7, 7);

      if (Number(this.Aleatorio) > 0) {
        minutosale = Number(this.Aleatorio) + minutosale;
      }
      
      // Calcular horas y minutos a partir de la diferencia
      this.HIni = Math.floor(Math.abs(minutosale) / 60);
      this.MIni = Math.abs(minutosale) % 60;

      this.informetrabajadores[lug].HORAS_SIN_TRABAJAR =
      (Math.abs(this.HIni) < 10 ? "0" + Number(this.HIni) : Number(this.HIni)) +
      ":" +
      (Math.abs((this.MIni)) < 10 ? "0" + this.MIni : this.MIni);
    
    }

    // En modo pruebas, el descanso total incluye el almuerzo configurado.
    // Se muestra el almuerzo por separado y se deja en "sin trabajar"
    // únicamente el descanso adicional, evitando contar el almuerzo dos veces.
    const minutosAlmuerzoPrueba = this.hhmmToMin(this.informetrabajadores[lug].HORAS_ALMORZANDO);
    if (minutosAlmuerzoPrueba > 0) {
      const minutosSinTrabajarTotal = this.hhmmToMin(this.informetrabajadores[lug].HORAS_SIN_TRABAJAR);
      const minutosSinTrabajarAdicional = Math.max(0, minutosSinTrabajarTotal - minutosAlmuerzoPrueba);
      this.informetrabajadores[lug].HORAS_SIN_TRABAJAR = this.minToHHMM24(minutosSinTrabajarAdicional);
    }
    if (tienePausaRealMedianoche) {
      this.informetrabajadores[lug].HORAS_SIN_TRABAJAR = this.minToHHMM24(minutosSinTrabajarReales);
    }

    this.hg = Number(this.informetrabajadores[lug].HORAS_TRANSCURRIDAS.substr(0, 2));
    this.mg = Number(this.informetrabajadores[lug].HORAS_TRANSCURRIDAS.substr(3, 2));
    
    this.hp = Number(this.informetrabajadores[lug].HORAS_SIN_TRABAJAR.substr(0, 2));
    this.mp = Number(this.informetrabajadores[lug].HORAS_SIN_TRABAJAR.substr(3, 2));




    
    // Calcular la diferencia en minutos
    minutosFinal = this.hg * 60 + this.mg;
    minutosInicial = this.hp * 60 + this.mp ;
    
    let diferenciaMinutos4 = (minutosFinal - minutosInicial - minutosAlmuerzoPrueba);

    // Calcular horas y minutos a partir de la diferencia
    this.hg1 = Math.floor(diferenciaMinutos4 / 60);
    this.mg1 = diferenciaMinutos4 % 60;


    // Formatear HORAS_TRABAJADAS
    this.informetrabajadores[lug].HORAS_TRABAJADAS =
      (this.hg1 < 10 ? "0" + this.hg1 : this.hg1) +
      ":" +
      (this.mg1 < 10 ? "0" + this.mg1 : this.mg1);

    this.informetrabajadores[lug].COLOR = "NORMAL";
        
      // Convertir HORAS_PREVISTAS a minutos
      let horasPrevistas = Number(this.informetrabajadores[lug].HORAS_PREVISTAS);
  
      let minutosPrevistos=0;

      if (horasPrevistas < 24){
        minutosPrevistos = Math.round(horasPrevistas * 60); // Redondear a minutos
      }else{
        minutosPrevistos = horasPrevistas ; // Redondear a minutos
      }
      
      
      // Calcular total de minutos trabajados (asumiendo que hg1 y mg1 ya contienen las horas y minutos trabajados)
      let minutosTrabajados = this.hg1 * 60 + this.mg1;
      
      // Calcular la diferencia en minutos
      let diferenciaMinutos = minutosTrabajados - minutosPrevistos;
      



      // Calcular horas y minutos a partir de la diferencia
      this.hg1 = Math.floor(Math.abs(diferenciaMinutos) / 60);
      this.mg1 = Math.abs(diferenciaMinutos) % 60;
      

      
      // Determinar si la diferencia es negativa (menos horas trabajadas)
      let signo = diferenciaMinutos < 0 ? "-" : "";
      
      // Asignar color según la diferencia de horas
      if (this.hg1 > 0) {
        this.informetrabajadores[lug].COLOR = "ROJO";
      } else {
        if (this.mg1 > 30) {
          this.informetrabajadores[lug].COLOR = "ROJO";
        }
      }



      
      // Formatear el resultado de HORAS_EXTRAS
      this.informetrabajadores[lug].HORAS_EXTRAS =
        signo +
        (this.hg1 < 10 ? this.hg1 : this.hg1) +
        ":" +
        (this.mg1 < 10 ? "0" + this.mg1 : this.mg1);

        if (Number(this.informetrabajadores[lug].CORTESIA!=0)){
          if (Math.abs(this.hg1)==0){
              if (Math.abs(this.mg1)<=Number(this.informetrabajadores[lug].CORTESIA)){
              this.informetrabajadores[lug].HORAS_EXTRAS = "0:00";
              }
          }
        } 

        this.informetrabajadores[lug].HORAS_EXTRAS_CON_AJUSTE =
        this.informetrabajadores[lug].HORAS_EXTRAS;

        const minFinal = this.hhmmToMin(this.informetrabajadores[lug].PICADA_FINAL); 
        if(minFinal >= 1440){
           this.informetrabajadores[lug].PICADA_FINAL = this.minToHHMM24(minFinal); 
        }


      }
  }

// --- helpers: sumar minutos a "HH:mm" y jitter aleatorio ±7 ---
 addMinutesToHHmm(hhmm: string, deltaMin: number): string {
  var m = String(hhmm || '').trim().match(/^(\d{1,2}):(\d{1,2})$/);
  if (!m) return "07:00";
  var h = Number(m[1]) % 24;
  var mi = Number(m[2]) % 60;

  var total = h * 60 + mi + deltaMin;
  // normaliza a 0..1439
  total = ((total % 1440) + 1440) % 1440;

  var nh = Math.floor(total / 60);
  var nmi = total % 60;
  return ('0' + nh).slice(-2) + ':' + ('0' + nmi).slice(-2);
}

 randomOffset7(): number {
  // -7 .. +7 (evita 0)
  var off = Math.floor(Math.random() * 15) - 7;
  if (off === 0) off = 1; // nunca exactamente igual
  return off;
}

picaentradafalsa(codigotrabajador: any, nombretrabajador: any, nombre_turno: string) {
  let horaInicio = "07:00";

  this.variables.CODIGOTRABAJADOR = codigotrabajador;
  this.variables.NOMBRETRABAJADOR = nombretrabajador;

  const buscado = (nombre_turno || '').trim().toLowerCase();

  // Buscar turno por NOMBRE (según tu JSON de turnos)
  let turnoEncontrado: any = null;
  const lista = this.turnos || [];
  for (let i = 0; i < lista.length; i++) {
    const t = lista[i];
    const nombreT = String(t.NOMBRE != null ? t.NOMBRE : '').trim().toLowerCase();
    if (nombreT === buscado) { turnoEncontrado = t; break; }
  }

  // (opcional) fallback por ID igual a nombre_turno
  if (!turnoEncontrado) {
    for (let i = 0; i < lista.length; i++) {
      if (String(lista[i].ID) === String(nombre_turno)) { turnoEncontrado = lista[i]; break; }
    }
  }


  if (turnoEncontrado) {
    var base = String(turnoEncontrado.HORA_ENTRADA != null ? turnoEncontrado.HORA_ENTRADA : '').trim();
    if (base) {
      // aplica jitter aleatorio ±7 min
      var offset = this.randomOffset7();
      horaInicio = this.addMinutesToHHmm(base, offset);
    }
  }

  this.funciones.grabapicada(
    this.variables.CODIGOTRABAJADOR,
    this.variables.DIA,
    "ENT",
    horaInicio,
    this.variables.CLIENTES_RAZSOCIAL,
    "MANUAL"
  )
  .then((data: any) => {
    this.resultado = data;
    this.obtenertrabajadores(this.valo);
  })
  .catch(err => console.log("Error al grabar picada:", err));
}


openPicajes(codigotrabajador, nombretrabajador) {
  this.variables.CODIGOTRABAJADOR = codigotrabajador;
  this.variables.NOMBRETRABAJADOR = nombretrabajador;
  this.navCtrl.push(PicajesPage);
}


mostrarDiaEspecial(valor) {

  if (!valor) {
    return false;
  }

  let dia = String(valor).trim().toLowerCase();

  if (dia == '') {
    return false;
  }

  if (dia == 'lunes') {
    return false;
  }

  if (dia == 'martes') {
    return false;
  }

  if (dia == 'miercoles' || dia == 'miércoles') {
    return false;
  }

  if (dia == 'jueves') {
    return false;
  }

  if (dia == 'viernes') {
    return false;
  }

  if (dia == 'sabado' || dia == 'sábado') {
    return false;
  }

  if (dia == 'domingo') {
    return false;
  }

  return true;

}

openVacacionesTrabajador(id, nombre, diasvacaciones) {

  var f = new Date();

  this.variables.selectedDay =
    f.getFullYear() +
    "-" +
    ("0" + (f.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + f.getDate()).slice(-2);

  this.variables.DIA = this.variables.selectedDay;

  this.variables.volverDespuesVacaciones = ListPage;

  this.variables.IDtrabajador = id;
  this.variables.NOMBREtrabajador = nombre;
  this.variables.diasVacaciones = diasvacaciones;
  this.variables.primeravez = "si";

  this.navCtrl.setRoot(VacacionesPage);

}

openPicajesIncidencia(codigotrabajador, nombretrabajador, dia, incidenciaIA: any = null) {

  this.variables.DIA = dia;
  this.variables.CODIGOTRABAJADOR = codigotrabajador;
  this.variables.NOMBRETRABAJADOR = nombretrabajador;

  this.navCtrl.push(PicajesPage, {
    codigotrabajador: codigotrabajador,
    nombretrabajador: nombretrabajador,
    DIA: dia,
    aprendizajeIA: true,
    incidenciaIA: incidenciaIA,
    // La vuelta (incluido el botón atrás) refresca una sola vez en ionViewWillEnter.
    callback: () => Promise.resolve(true)
  });
}

  ponorden(campo: string, value: string): void {
    switch (campo) {
      case "CODIGO":
        this.ORDENADO = "codigo";
        if (this.ASC == "asc") {
          this.ASC = "desc";
        } else {
          this.ASC = "asc";
        }
        this.obtenertrabajadores("formulario");
        break;
      case "NOMBRE":
        this.ORDENADO = "nombre";
        if (this.ASC == "asc") {
          this.ASC = "desc";
        } else {
          this.ASC = "asc";
        }
        this.obtenertrabajadores("formulario");
        break;
      case "TURNO":
        this.ORDENADO = "turno";
        if (this.ASC == "asc") {
          this.ASC = "desc";
        } else {
          this.ASC = "asc";
        }
        this.obtenertrabajadores("formulario");
        break;

      default:
        // code...
        break;
    }
  }

  ponencampo(campo: string, value: string): void {
    switch (campo) {
      case "OBRA":
        this.variables.OBRA = value;
        this.obtenertrabajadores(this.valo);
        break;

      default:
        // code...
        break;
    }
  }

  read(bstr: string) {}

  write(): XLSX.WorkBook {
    var informe_xls = JSON.parse(
      '[{"CODIGO": "","NOMBRE": "","TURNO": "","OBRA": "","FECHA": "","HORAS_PARADAS": "","HORAS_SIN_TRABAJAR": "","HORAS_ALMORZANDO": "","HORAS_TRABAJADAS": "","HORAS_EXTRAS": ""}]'
    );

    informe_xls = [];

    for (var lug = 0; lug < this.trabajadores.length; lug++) {


      informe_xls.push({
        FECHA: "" + this.variables.DIA,
        CODIGO: "" + this.trabajadores[lug].CODIGO,
        NOMBRE: "" + this.trabajadores[lug].NOMBRE,
        EMPRESA: "" + this.trabajadores[lug].EMPRESA,
        TURNO: "" + this.trabajadores[lug].TURNO,
        OBRA: "" + this.trabajadores[lug].OBRA,
        HORAS_PARADAS: "" + this.trabajadores[lug].HORAS_PARADAS,
        HORAS_SIN_TRABAJAR: "" + this.trabajadores[lug].HORAS_SIN_TRABAJAR,
        HORAS_ALMORZANDO: "" + this.trabajadores[lug].HORAS_ALMORZANDO,
        HORAS_TRABAJADAS: "" + this.trabajadores[lug].HORAS_TRABAJADAS,
        HORAS_EXTRAS: "" + this.trabajadores[lug].HORAS_EXTRAS,
        HORAS_AJUSTE: "" + this.trabajadores[lug].HORAS_AJUSTE,
        HORAS_EXTRAS_CON_AJUSTE:
          "" + this.trabajadores[lug].HORAS_EXTRAS_CON_AJUSTE,
      });
    }

    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(informe_xls);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Hoja1");

    return wb;
  }

  async import() {}

  /* Export button */
  async export() {
    if (this.cargandoLista || this.errorCargaLista) { return; }
    const wb: XLSX.WorkBook = this.write();
    const filename: string = "informe_picajes.xlsx";
    try {
      /* generate Blob */
      const wbout: ArrayBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const blob: Blob = new Blob([wbout], {
        type: "application/octet-stream",
      });

      /* find appropriate path for mobile */
      const target: string =
        this.file.documentsDirectory ||
        this.file.externalDataDirectory ||
        this.file.dataDirectory ||
        "";
      const dentry = await this.file.resolveDirectoryUrl(target);
      const url: string = dentry.nativeURL || "";

      /* attempt to save blob to file */
      await this.file.writeFile(url, filename, blob, { replace: true });
    } catch (e) {
      XLSX.writeFile(wb, filename);
    }
  }

  private async cargarConfiguracionPdfDetalleLista(): Promise<boolean> {
    if (this.pdfDetalleConfiguracionLeida) { return this.pdfDetalleConfigurado; }
    this.pdfDetalleConfiguracionLeida = true;
    try {
      let data: any = await this.funciones.obtieneConfiguracionPdfDetalle();
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (e) { data = []; }
      }
      const fila = Array.isArray(data) ? (data[0] || {}) : (data || {});
      const valor = fila.PDF_DETALLE_EXPLICATIVO != null ? fila.PDF_DETALLE_EXPLICATIVO :
        (fila.pdf_detalle_explicativo != null ? fila.pdf_detalle_explicativo : fila.activo);
      this.pdfDetalleConfigurado = String(valor) === '1' || valor === true || valor === 1;
      this.variables.PDF_DETALLE_EXPLICATIVO = this.pdfDetalleConfigurado;
    } catch (error) {
      // Si la API antigua no conoce la preferencia, el informe normal sigue igual.
      this.pdfDetalleConfigurado = false;
      console.log('No se pudo leer la configuración del PDF detallado', error);
    }
    return this.pdfDetalleConfigurado;
  }

  private async cargarPicajesMesPdfDetalle(codigo: string, mes: string): Promise<any[]> {
    const inicio = Date.parse(mes + '-01T00:00:00Z');
    const fecha = new Date(inicio);
    const fin = Date.UTC(fecha.getUTCFullYear(), fecha.getUTCMonth() + 1, 1);
    const fechas: string[] = [];
    for (let t = inicio - 2 * 86400000; t < fin + 2 * 86400000; t += 86400000) {
      fechas.push(fechaDetalle(t));
    }
    const picajes: any[] = [];
    for (let i = 0; i < fechas.length; i += 6) {
      const lote = await Promise.all(fechas.slice(i, i + 6).map(f =>
        this.leerDatosPdfDetalle(['picajesdesc', codigo, f])));
      lote.forEach(filas => filas.forEach(p => picajes.push(p)));
    }
    return picajes;
  }

  private picajesPruebasDesdeCalculo(calculo: any[]): any[] {
    const resultado: any[] = [];
    let numero = 0;
    const minutos = (valor: any): number | null => {
      const m = /^(\d{1,2}):(\d{2})/.exec(String(valor || '').trim());
      if (!m || Number(m[1]) > 24 || Number(m[2]) > 59 ||
        (Number(m[1]) === 24 && Number(m[2]) !== 0)) { return null; }
      return Number(m[1]) * 60 + Number(m[2]);
    };
    (calculo || []).forEach((fila: any) => {
      const fecha = String(fila && fila.FECHA || '').substr(0, 10);
      const entrada = minutos(fila && fila.PICADA_INICIAL);
      const salida = minutos(fila && fila.PICADA_FINAL);
      if (!/^\d{4}-\d{2}-\d{2}$/.test(fecha) || entrada === null || salida === null ||
        fila.NOMBRE === 'SAL' || fila.PICADA_INICIAL === 'no') { return; }
      const codigo = fila.CODIGO || '';
      const obra = fila.OBRA || '';
      const dia = Date.parse(fecha + 'T00:00:00Z');
      const fechaSalida = salida < entrada ? fechaDetalle(dia + 86400000) : fecha;
      const horaSalida = salida === 1440 ? '24:00' : this.minToHHMM24(salida);
      resultado.push({ ID: 'PRUEBA-' + (++numero) + '-E', CODIGO: codigo,
        FECHA: fecha, HORA: this.minToHHMM24(entrada), SENTIDO: 'ENT', OBRA: obra });
      resultado.push({ ID: 'PRUEBA-' + (++numero) + '-S', CODIGO: codigo,
        FECHA: fechaSalida, HORA: horaSalida, SENTIDO: 'SAL', OBRA: obra });
    });
    return resultado;
  }

  private minutosHoraPdfPrincipal(valor: any): number | null {
    const m = /^(\d{1,2}):(\d{2})(?::\d{2})?$/.exec(String(valor || '').trim());
    if (!m || Number(m[1]) > 24 || Number(m[2]) > 59 ||
      (Number(m[1]) === 24 && Number(m[2]) !== 0)) { return null; }
    return Number(m[1]) * 60 + Number(m[2]);
  }

  private tramosLineaPdfPrincipal(fecha: string, fila: any, picajes: any[]): any[] {
    const diaInicio = Date.parse(fecha + 'T00:00:00Z');
    const diaFin = diaInicio + 24 * 60 * 60000;
    const eventos: any[] = [];
    (picajes || []).forEach((p: any, indice: number) => {
      const f = String(p && p.FECHA || '').substr(0, 10);
      const minutos = this.minutosHoraPdfPrincipal(p && (p.HORA || p.PICADA));
      if (!/^\d{4}-\d{2}-\d{2}$/.test(f) || minutos === null) { return; }
      const sentido = String(p.SENTIDO || '').trim().toLowerCase();
      if (['ent', 'entra', 'entrada'].indexOf(sentido) < 0 &&
        ['sal', 'sale', 'salida'].indexOf(sentido) < 0) { return; }
      eventos.push({
        tiempo: Date.parse(f + 'T00:00:00Z') + minutos * 60000,
        entrada: ['ent', 'entra', 'entrada'].indexOf(sentido) >= 0,
        indice
      });
    });
    eventos.sort((a, b) => a.tiempo - b.tiempo || a.indice - b.indice);
    const tramos: any[] = [];
    let entrada: any = null;
    eventos.forEach(e => {
      if (e.entrada) {
        entrada = e;
      } else if (entrada && e.tiempo > entrada.tiempo) {
        const a = Math.max(diaInicio, entrada.tiempo);
        const b = Math.min(diaFin, e.tiempo);
        if (b > a) { tramos.push({ inicio: a, fin: b }); }
        entrada = null;
      }
    });

    // Si el día ya contiene el final de una jornada iniciada el día anterior
    // y después comienza otra jornada que sigue abierta, la representación del
    // listado/informe se completa virtualmente hasta las 24:00. No se modifica
    // ninguna picada real ni se aplica esta regla a una jornada abierta normal.
    if (entrada && entrada.tiempo >= diaInicio && entrada.tiempo < diaFin) {
      const vieneDelDiaAnterior = tramos.some((tramo: any) =>
        tramo.inicio === diaInicio && tramo.fin <= entrada.tiempo);
      if (vieneDelDiaAnterior) {
        tramos.push({ inicio: entrada.tiempo, fin: diaFin });
      }
    }

    // Si no se han podido recuperar las picadas detalladas, se conserva una
    // representación útil basada en la entrada/salida del informe oficial.
    if (!tramos.length) {
      const ini = this.minutosHoraPdfPrincipal(fila && fila.PICADA_INICIAL);
      const fin = this.minutosHoraPdfPrincipal(fila && fila.PICADA_FINAL);
      if (ini !== null && fin !== null) {
        let a = ini;
        let b = fin;
        if (b < a) { b += 1440; }
        a = Math.max(0, Math.min(1440, a));
        b = Math.max(0, Math.min(1440, b));
        if (b > a) { tramos.push({ inicio: diaInicio + a * 60000, fin: diaInicio + b * 60000 }); }
      }
    }
    return tramos;
  }

  private picadasLineaPdfPrincipal(fecha: string, picajes: any[]): number[] {
    const resultado: number[] = [];
    (picajes || []).forEach((p: any) => {
      if (String(p && p.FECHA || '').substr(0, 10) !== fecha) { return; }
      const minutos = this.minutosHoraPdfPrincipal(p && (p.HORA || p.PICADA));
      if (minutos !== null) { resultado.push(minutos); }
    });
    return resultado;
  }

  private dibujarLineaTiempoPdfPrincipal(fila: any, picajes: any[], x: number, y: number): void {
    const ancho = 200;
    const alto = 0.65;
    const tramos = this.tramosLineaPdfPrincipal(String(fila && fila.FECHA || ''), fila, picajes);
    const inicioDia = Date.parse(String(fila && fila.FECHA || '') + 'T00:00:00Z');

    // La franja ocupa solo la parte inferior de la fila existente: no aumenta
    // la altura mensual ni desplaza las firmas y el texto legal.
    this.doc.setFillColor(224, 132, 132);
    this.doc.rect(x, y, ancho, alto, 'F');
    this.doc.setDrawColor(120, 70, 70);
    this.doc.setLineWidth(0.16);
    for (let h = x - alto; h < x + ancho; h += 1.8) {
      this.doc.line(h, y + alto, h + alto, y);
    }
    tramos.forEach((tramo: any) => {
      const a = Math.max(inicioDia, tramo.inicio);
      const b = Math.min(inicioDia + 24 * 60 * 60000, tramo.fin);
      if (b <= a) { return; }
      this.doc.setFillColor(105, 180, 116);
      this.doc.rect(x + ((a - inicioDia) / 86400000) * ancho, y,
        ((b - a) / 86400000) * ancho, alto, 'F');
    });
    this.doc.setDrawColor(70, 70, 70);
    this.doc.setLineWidth(0.16);
    this.doc.rect(x, y, ancho, alto);
    this.picadasLineaPdfPrincipal(String(fila && fila.FECHA || ''), picajes).forEach(minutos => {
      const px = x + (minutos / 1440) * ancho;
      this.doc.setDrawColor(0, 0, 0);
      this.doc.setLineWidth(0.3);
      this.doc.line(px, y - 0.6, px, y + alto + 0.6);
    });
  }

  private async anadirAnexoDetalleAlInforme(codigo: string, trabajador: any): Promise<void> {
    const mes = String(this.variables.DIA || '').substr(0, 7);
    const resumen = (this.informetrabajadorespdf || []).filter(r =>
      /^\d{4}-\d{2}-\d{2}$/.test(String(r.FECHA || '')));
    const calculo = (this.informetrabajadoressindetallespdf || []).filter(r =>
      /^\d{4}-\d{2}-\d{2}$/.test(String(r.FECHA || '')));
    const modo = this.variables.MODO || 'real';
    const [picajes, ausencias] = await Promise.all([
      modo === 'real' ? this.cargarPicajesMesPdfDetalle(codigo, mes) :
        Promise.resolve(this.picajesPruebasDesdeCalculo(calculo)),
      this.leerDatosPdfDetalle(['obtenervacaciones', codigo])
    ]);
    let turnos = this.turnos;
    if (!turnos || !turnos.length) { turnos = await this.funciones.obtieneturnos(this.valo); }
    let fiestas = this.diasdefiesta;
    if (!fiestas || !fiestas.length) { fiestas = await this.funciones.obtienefiestas(); }
    let usuarios = this.users;
    if (!usuarios || !usuarios.length) { usuarios = await this.funciones.obtieneusers(this.variables.CLIENTES_RAZSOCIAL); }
    let empresas = this.empresas;
    if (!empresas || !empresas.length) { empresas = await this.obtenerEmpresasParaCifInforme(); }
    const principal = (usuarios && usuarios[0]) || {};
    const nombreEmpresa = ((resumen.find(r => r.EMPRESA && r.NOMBRE !== 'SAL') || {}).EMPRESA ||
      trabajador.EMPRESA || principal.RAZSOCIAL || '').trim();
    const coincide = (a, b) => String(a || '').trim().toUpperCase() === String(b || '').trim().toUpperCase();
    const encontrada = (empresas || []).find(e => nombreEmpresa && coincide(e.NOMBRE, nombreEmpresa));
    const empresa = Object.assign({}, principal, encontrada ||
      (coincide(principal.RAZSOCIAL, nombreEmpresa) || !nombreEmpresa ? {} : { NOMBRE: nombreEmpresa, CIF: '' }));
    dibujarDetalle(this.doc, { mes, trabajador: Object.assign({}, trabajador), empresa,
      picajes, resumen, calculo, turnos: turnos || [], fiestas: fiestas || [], ausencias: ausencias || [] }, true);
  }

  // Segundo informe: consultas de lectura y estado local, independiente del PDF actual.
  async informePdfDetalle(codigo: string) {
    if (this.generandoPdfDetalle) { return; }
    this.generandoPdfDetalle = true;
    try {
      const trabajador = Object.assign({}, (this.trabajadores || []).find(t => String(t.CODIGO) === String(codigo)));
      if (!trabajador.CODIGO) { throw new Error('No se encuentra el trabajador seleccionado.'); }
      const mes = String(this.variables.DIA || '').substr(0, 7);
      if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(mes)) { throw new Error('Selecciona una fecha válida en el calendario.'); }
      const inicio = Date.parse(mes + '-01T00:00:00Z');
      const fecha = new Date(inicio);
      const fin = Date.UTC(fecha.getUTCFullYear(), fecha.getUTCMonth() + 1, 1);
      const padre = this.variables.CLIENTES_RAZSOCIAL;
      const modo = this.variables.MODO || 'real';
      const datos = await Promise.all([
        this.leerDatosPdfDetalle(['informe', padre, codigo, this.valo, this.valo, this.valo, fechaDetalle(inicio), fechaDetalle(fin - 86400000), modo]),
        this.leerDatosPdfDetalle(['turnos', padre, this.valo]),
        this.leerDatosPdfDetalle(['fiestas', padre]),
        this.leerDatosPdfDetalle(['obtenervacaciones', codigo]),
        this.leerDatosPdfDetalle(['todoslosusers', padre]),
        this.leerDatosPdfDetalle(['empresas', padre, this.valo])
      ]);
      const resumen = datos[0];
      await this.aplicarAsignacionesAfilas(resumen, datos[1]);
      const nombreEmpresa = ((resumen.find(r => r.EMPRESA && r.NOMBRE !== 'SAL') || {}).EMPRESA || trabajador.EMPRESA || '').trim();
      const empresas = datos[5];
      const principal = datos[4][0] || {};
      const coincide = (a, b) => String(a || '').trim().toUpperCase() === String(b || '').trim().toUpperCase();
      const empresaEncontrada = empresas.find(e => nombreEmpresa && coincide(e.NOMBRE, nombreEmpresa));
      // Conserva también DIRECCION y el resto de datos del usuario principal,
      // que utiliza el PDF antiguo en su texto legal RGPD.
      const empresa = Object.assign({}, principal, empresaEncontrada ||
        (coincide(principal.RAZSOCIAL, nombreEmpresa) || !nombreEmpresa ? {} : { NOMBRE: nombreEmpresa, CIF: '' }));
      if (!empresa.NOMBRE && !empresa.RAZSOCIAL) { throw new Error('No se han podido identificar los datos de la empresa.'); }
      // Dos días de contexto por cada extremo: se enlazan fechas completas y se
      // computa exclusivamente el mes. Una pareja incompleta se señala, no se inventa.
      const doc = new jsPDF('p', 'mm', 'a4');
      const calculo = await this.calcularDatosPdfDetalle(codigo, resumen, datos[1]);
      // En pruebas no se consultan ni se imprimen picadas reales. El informe
      // antiguo inventa las horas en el mismo motor de calculo; generamos los
      // dos eventos equivalentes para que el anexo dibuje exactamente esas
      // horas, incluso cuando la salida cae al dÃ­a siguiente.
      const picajes = modo === 'real' ? await this.cargarPicajesMesPdfDetalle(codigo, mes) :
        this.picajesPruebasDesdeCalculo(calculo);
      dibujarDetalle(doc, { mes, trabajador, empresa, picajes, resumen, calculo,
        turnos: datos[1], fiestas: datos[2], ausencias: datos[3] });
      const nombre = String(trabajador.NOMBRE || codigo).replace(/[\\/:*?"<>|]/g, '-');
      doc.save('PDF con detalle explicativo - ' + nombre + ' - ' + mes + '.pdf');
    } catch (error) {
      this.alertCtrl.create({ title: 'PDF con detalle explicativo',
        message: error && error.message ? error.message : 'No se ha podido generar el informe. Inténtalo de nuevo.',
        buttons: ['Aceptar'] }).present();
    } finally {
      this.generandoPdfDetalle = false;
      this.cdr.detectChanges();
    }
  }

  private async calcularDatosPdfDetalle(codigo: string, resumen: any[], turnos: any[]): Promise<any[]> {
    if (!resumen.some(r => r.NOMBRE !== 'SAL' && r.PICADA_INICIAL !== 'no')) { return []; }
    // Reutilizar exactamente el cálculo real del PDF existente sobre copias.
    // No se instancia otra página, no se cambia el trabajador activo ni se
    // repiten consultas. Todas las escrituras del cálculo quedan en este objeto.
    const calculador: any = Object.create(this);
    calculador.variables = Object.create(this.variables);
    calculador.variables.MODO = this.variables.MODO || 'real';
    calculador.variables.CODIGOTRABAJADOR = codigo;
    calculador.turnos = turnos.map(t => Object.assign({}, t));
    calculador.obtenerobras = () => {};
    calculador.obtenerturnos = () => {};
    calculador.funciones = {
      obtieneinforme: () => Promise.resolve(resumen.map(r => Object.assign({}, r)))
    };
    const filas = await calculador.creaelinformepdf(codigo);
    return filas.filter(r => /^\d{4}-\d{2}-\d{2}$/.test(r.FECHA));
  }

  private leerDatosPdfDetalle(partes: any[]): Promise<any[]> {
    const url = 'https://www.panel-control.com/picademo/recursos/sublogin.php/' +
      partes.map(p => encodeURIComponent(String(p))).join('/');
    return new Promise<any[]>((resolve, reject) => {
      let peticion: any;
      const timer = setTimeout(() => {
        if (peticion) { peticion.unsubscribe(); }
        reject(new Error('La consulta de ' + partes[0] + ' ha tardado demasiado. No se ha generado un PDF con datos incompletos.'));
      }, 30000);
      peticion = this.funciones.http.get(url).subscribe(res => {
        clearTimeout(timer);
        try {
          const filas = res.json();
          if (!Array.isArray(filas) || filas.some(f => !f || f.error || f.RESULTADO === 'ERROR')) {
            throw new Error('La consulta de ' + partes[0] + ' no ha devuelto datos válidos.');
          }
          resolve(filas);
        } catch (error) { reject(new Error('No se pudo leer ' + partes[0] + '. Comprueba los datos del informe.')); }
      }, () => {
        clearTimeout(timer);
        reject(new Error('No se pudo consultar ' + partes[0] + '. Comprueba la conexión e inténtalo de nuevo.'));
      });
    });
  }

  async informe_en_pdf(filtro) {
    if (this.generandoInforme) { return; }

    this.generandoInforme = true;
    this.actualizarProgresoInforme(3, "Preparando informe...");
    // Permite que el círculo se pinte antes de comenzar los cálculos del PDF.
    await this.dejarPintarInterfaz();

    try {
      await this.generarInformePdf(filtro);
    } catch (error) {
      console.error("No se pudo generar el informe", error);
      this.alertCtrl.create({
        title: "Informe",
        message: "No se ha podido generar el informe. Inténtalo de nuevo.",
        buttons: ["Aceptar"]
      }).present();
    } finally {
      this.actualizarProgresoInforme(100, "Informe preparado");
      await this.dejarPintarInterfaz();
      this.generandoInforme = false;
      this.detectarCambiosLista();
    }
  }

  private async generarInformePdf(filtro) {
    this.muestragif = "si";
    this.actualizarProgresoInforme(8, "Preparando datos...");
    await this.dejarPintarInterfaz();
    await this.cargarConfiguracionPdfDetalleLista();
    this.actualizarProgresoInforme(12, "Datos preparados");
    await this.dejarPintarInterfaz();

    var i: number;
    var eltop;
    var eltopfiestas;
    var trabajadorr;
    var hacer;
    var x;
    var valor1;
    var valor2;
    var fechanueva;
    var texto;
    var findemes;
    //this.doc = [];
    this.doc = new jsPDF();
    hacer = "no";

    const trabajadoresInforme = (this.trabajadores || []).filter((trabajador) => {
      return filtro === "todos" || trabajador.CODIGO == filtro;
    });
    const totalTrabajadoresInforme = Math.max(trabajadoresInforme.length, 1);
    let trabajadoresProcesados = 0;

    for (var rec = 0; rec < this.trabajadores.length; rec++) {
      if (filtro != "todos") {
        hacer = "no";
        if (this.trabajadores[rec].CODIGO == filtro) {
          hacer = "si";
        }
      } else {
        hacer = "si";
      }

      if (hacer == "si") {

        this.actualizarProgresoInforme(
          15 + Math.round((trabajadoresProcesados / totalTrabajadoresInforme) * 70),
          "Calculando trabajador " + (trabajadoresProcesados + 1) + " de " + trabajadoresInforme.length + "..."
        );
        await this.dejarPintarInterfaz();


        // Esperamos la consulta: el PDF se dibuja inmediatamente después.
        const vacacionesInforme: any = await this.variables.obtenerVacaciones(this.trabajadores[rec].CODIGO);
        this.variables.diasOcupados = Array.isArray(vacacionesInforme) ? vacacionesInforme : [];



        this.variables.CODIGOTRABAJADOR = this.trabajadores[rec].CODIGO;
  
        var obj = await this.creaelinformepdf(this.variables.CODIGOTRABAJADOR);

        this.doc.setFontSize(15);
        this.doc.setFontType("bold");
        this.doc.text("Registro Diario de Horas", 70, 9);
        this.doc.setFontSize(7);
        this.doc.text(
          "En cumplimiento de lo establecido en art. 10.dos del RD-ley 8/2019, que modifica el art. 34 del ET, añadiendo el apart. 9",
          40,
          13
        ); //  left,top

        //this.doc.rect(5, 5, 200, 234); // empty square
        //this.doc.rect(5, 5, 200, 6); // empty square
        this.doc.rect(5, 15, 200, 6); // empty square

        this.doc.setFontSize(11);

        this.doc.text("EMPRESA", 40, 20); //  left,top
        //this.doc.rect(95, 15, 110, 6); // empty square
        this.doc.text("TRABAJADOR", 130, 20); //  left,top

        this.doc.setFontSize(9);
        //this.doc.rect(5, 19, 200, 22); // left, top , width, height
        this.doc.text("Nombre:", 8, 27); //  left,top
        this.doc.text("Nombre:", 110, 27); //  left,top
        this.doc.text("Cif:", 16, 33); //  left,top
        this.doc.text("Nif:", 118, 33);
        //this.doc.text( 'C.C.C:', 8, 37);  //  left,top
        //this.doc.text( 'N.A.F:', 97, 37);  //  left,top

        this.doc.setFontSize(9);

        this.doc.text(this.trabajadores[rec].NOMBRE, 125, 27);
        this.doc.text(this.trabajadores[rec].CODIGO, 125, 33);

        this.variables.NOMBRETRABAJADOR = this.trabajadores[rec].NOMBRE;

        this.doc.setFontSize(9);
        
        if (!this.users || !this.users[0]) {
          this.users = await this.funciones.obtieneusers(this.variables.CLIENTES_RAZSOCIAL);
        }
        
        if (!this.users || !this.users[0]) {
          this.users = await this.funciones.obtieneusers(this.variables.CLIENTES_RAZSOCIAL);
        }
        
       
        if (!this.users || !this.users[0]) {
          this.users = await this.funciones.obtieneusers(this.variables.CLIENTES_RAZSOCIAL);
        }
        
        /*
          Empresa real del trabajador.
        */
        let empresaDelTrabajador = "";
        
        if (
          this.informetrabajadorespdf &&
          this.informetrabajadorespdf.length > 0 &&
          this.informetrabajadorespdf[0].EMPRESA
        ) {
          empresaDelTrabajador = this.informetrabajadorespdf[0].EMPRESA;
        } else if (this.trabajadores && this.trabajadores[rec]) {
          empresaDelTrabajador = this.trabajadores[rec].EMPRESA || "";
        }
        
        //console.log("Empresa del trabajador para buscar CIF:", empresaDelTrabajador);
        
        let empresas = await this.obtenerEmpresasParaCifInforme();
        
        //console.log("Empresas disponibles para CIF:", empresas);
        
        let razsocialInforme = this.users[0].RAZSOCIAL || "";
        let cifInforme = this.users[0].CIF || "";
        
        let empresaEncontrada = false;
        
        const empresaTrabajadorNormalizada = this.normalizaEmpresa(empresaDelTrabajador);
        
        for (let empresa of empresas) {
        
          const nombreEmpresaNormalizada = this.normalizaEmpresa(empresa.NOMBRE);
        
          //console.log(nombreEmpresaNormalizada + " === " + empresaTrabajadorNormalizada);
        
          if (nombreEmpresaNormalizada === empresaTrabajadorNormalizada) {
        
            razsocialInforme = empresa.NOMBRE || "";
            cifInforme = empresa.CIF || "";
        
            empresaEncontrada = true;
        
            
            break;
          }
        }
        
        if (!empresaEncontrada) {
          //console.log("No se encontró la empresa dada de alta. Se usa la empresa principal.");
        }
        
        this.users[0].RAZSOCIAL = razsocialInforme;
        this.users[0].CIF = cifInforme;
        
        this.doc.text(razsocialInforme || "", 25, 27);
        this.doc.text(cifInforme || "", 25, 33);


        this.doc.setFontSize(9);

        this.doc.rect(5, 41, 200, 6); // left, top , width, height
        this.doc.text("Periodo:", 8, 45); //  left,top
        this.doc.text("" + this.FechaIni + " al " + this.FechaFin, 30, 45); //  left,top

        //this.doc.rect(95, 41, 110, 6); // left, top , width, height
        //  this.doc.text( 'Fecha:',97, 45);  //  left,top
        //  this.doc.text( this.DIAdehoy, 115, 45);  //  left,top

        this.doc.setFontSize(8);

        this.doc.rect(5, 50, 25, 7); // left, top , width, height
        this.doc.text("Fechas", 7, 54); //  left,top
        this.doc.rect(30, 50, 25, 7); // left, top , width, height
        this.doc.text("Entrada", 33, 54); //  left,top
        this.doc.rect(55, 50, 25, 7); // left, top , width, height
        this.doc.text("Salida", 58, 54); //  left,top
        this.doc.rect(80, 50, 25, 7); // left, top , width, height
        this.doc.text("Almorzando", 83, 54); //  left,top
        this.doc.rect(105, 50, 25, 7); // left, top , width, height
        this.doc.text("Descanso", 108, 54); //  left,top
        this.doc.rect(130, 50, 25, 7); // left, top , width, height
        this.doc.text("Sin trabajar", 133, 54); //  left,top
        this.doc.rect(155, 50, 25, 7); // left, top , width, height
        this.doc.text("Ordinarias", 158, 54); //  left,top
        this.doc.rect(180, 50, 25, 7); // left, top , width, height
        this.doc.text("Horas Extras", 183, 54); //  left,top
        this.doc.text("Fiestas de " + this.meses[this.MESHOY - 1] + " trabajadas", 10, 238); //  left,top

        this.doc.rect(80, 240, 50, 28); // left, top , width, height
        this.doc.text("Firma o sello de la empresa", 90, 238); //  left,top
        this.doc.rect(150, 240, 52, 28); // left, top , width, height
        this.doc.text("Firma del trabajador", 160, 238); //  left,top

        this.doc.setFontSize(9);

        //this.doc.rect(5, 230, 200, 10); // empty square
        //this.doc.text( 'Totales:',60, 235);  //  left,top

        this.doc.setFontSize(6);

        texto =         "RGPD y Ley Orgánica 3/2018 de Protección de Datos: los datos  de carácter personal que nos  proporciona serán tratados por " +         this.users[0].RAZSOCIAL +          "como \n";
        texto =          texto +          "Responsable de Tratamiento. La finalidad de la recogida y tratamiento de los datos es la adecuada gestión interna de las relaciones entre la empresa y sus empleados y que no\n";
        texto =          texto +          "serán cedidos, sin perjuicio de su tratamiento por aquellas personas o entidades con las que " +       this.users[0].RAZSOCIAL +         " en el ejercicio de sus facultades legítimas mantenga \n";
        texto =          texto +          "relaciones para el adecuado cumplimiento de sus obligaciones legales derivadas de la Normativa Laboral, de Seguridad Social, y Tributaria. " +          this.users[0].RAZSOCIAL +          " \n";
        texto =          texto +          "informa de que el trabajador puede ejercer sus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad en " +          this.users[0].DIRECCION +          " \n";
        texto =          texto +          "Si considera que el tratamiento no se ajusta a la normativa vigente, podrá presentar una reclamación ante la autoridad de control en www.aepd. Mayor información en nuestras dependencias. \n";

        this.doc.text(texto, 105, 275, "center"); //  left,top

        this.doc.text("Informe realizado por la aplicación Control Horario ver.101  -- nº " + (rec + 1) + "--", 105,  289,   "center"        ); //  left,top

        eltop = 57;
        eltopfiestas = 244;

        x = 0;

        findemes = this.FechaFin.substr(-2);
        findemes = Number(findemes);

        // El API puede devolver solo los días con picadas. Para el informe
        // mensual necesitamos dibujar siempre todas las fechas del periodo.
        // Se prepara una copia solo para pintar la tabla y se conserva intacta
        // la colección original para cálculos y para el anexo explicativo.
        const filasPdfOriginales = this.informetrabajadoressindetallespdf;
        const filasPdfPorFecha: any = {};
        (filasPdfOriginales || []).forEach((fila: any) => {
          const fechaFila = String(fila && fila.FECHA || '');
          if (!/^\d{4}-\d{2}-\d{2}$/.test(fechaFila)) { return; }
          const actual = filasPdfPorFecha[fechaFila];
          const filaUtil = !!(fila && (fila._PICADA_VIRTUAL_MEDIANOCHE ||
            String(fila.PICO || '').toUpperCase() !== 'NO'));
          const actualUtil = !!(actual && (actual._PICADA_VIRTUAL_MEDIANOCHE ||
            String(actual.PICO || '').toUpperCase() !== 'NO'));
          if (!actual || (!actualUtil && filaUtil) ||
            (fila && fila._PICADA_VIRTUAL_MEDIANOCHE && !actual._PICADA_VIRTUAL_MEDIANOCHE)) {
            filasPdfPorFecha[fechaFila] = fila;
          }
        });
        const filaPdfReferencia: any = (filasPdfOriginales || []).find((fila: any) =>
          /^\d{4}-\d{2}-\d{2}$/.test(String(fila && fila.FECHA || ''))) || {};
        const filasPdfMes: any[] = [];
        for (let diaPdf = 1; diaPdf <= findemes; diaPdf++) {
          const diaTexto = (diaPdf < 10 ? '0' : '') + diaPdf;
          const fechaPdf = this.FechaIni.substr(0, 8) + diaTexto;
          if (filasPdfPorFecha[fechaPdf]) {
            filasPdfMes.push(filasPdfPorFecha[fechaPdf]);
          } else {
            filasPdfMes.push(Object.assign({}, filaPdfReferencia, {
              FECHA: fechaPdf,
              PICO: "NO",
              DIA: "",
              PICADA_INICIAL: "",
              PICADA_FINAL: "",
              HORAS_ALMORZANDO: "",
              HORAS_PARADAS: "",
              HORAS_SIN_TRABAJAR: "",
              HORAS_TRABAJADAS: "",
              HORAS_EXTRAS: ""
            }));
          }
        }
        this.informetrabajadoressindetallespdf = filasPdfMes;

        




        for (var _i = 0; _i <= findemes; _i++) {

              valor1 = "00" + _i;
              valor1 = valor1.substr(-2);



              if (valor1 != "00") {

                
                if (valor1 == this.informetrabajadoressindetallespdf[x].FECHA.substr(8, 2) ) {

                  //console.log(this.informetrabajadoressindetallespdf[x].FECHA + " HORAS--> " + this.informetrabajadoressindetallespdf[x].PICO);
                  
                
                  if (this.informetrabajadoressindetallespdf[x].PICO!="NO"){ 
                    this.doc.setTextColor("#000000");
                    fechanueva = this.variables.DIA.substr(0, 8) + valor1;
                    texto = "";

                    if (this.informetrabajadoressindetallespdf[x].DIA == "Fiesta") {
                      for (var v = 0; v < this.diasdefiesta.length; v++){
                        if (this.diasdefiesta[v].DIA == fechanueva.substr(8, 2) && this.diasdefiesta[v].MES == fechanueva.substr(5, 2)) {
                          texto = this.diaSemana(this.informetrabajadoressindetallespdf[x].FECHA) + " " + this.informetrabajadoressindetallespdf[x].FECHA.substr(8, 2) + "/" + this.informetrabajadoressindetallespdf[x].FECHA.substr(5, 2) + "/" + this.informetrabajadoressindetallespdf[x].FECHA.substr(0, 4);
                          texto = texto + " " + this.diasdefiesta[v].NOMBRE;
                          if (this.informetrabajadoressindetallespdf[x].OBRA == this.diasdefiesta[v].LUGAR || this.diasdefiesta[v].LUGAR == "Todos") {
                            this.doc.setTextColor("#AA0000");
                            this.doc.setFontSize(8.5);
                            this.doc.text(texto, 10, eltopfiestas); 
                            eltopfiestas = eltopfiestas + 5;
                          }
                          break;
                        } else {
                          texto = "";
                        }
                      }
                    }

                    this.doc.setFontSize(8.5);
                    this.doc.rect(5, eltop, 25, 5.5); 
                    if (this.informetrabajadoressindetallespdf[x].FECHA.length == 10) {
                      this.doc.text(this.diaSemana(this.informetrabajadoressindetallespdf[x].FECHA) + " " + this.informetrabajadoressindetallespdf[x].FECHA.substr(8,2) + "/" + this.informetrabajadoressindetallespdf[x].FECHA.substr(5, 2) + "/" + this.informetrabajadoressindetallespdf[x].FECHA.substr( 0, 4), 25, eltop + 4, "right" ); //  left,top
                    }
                    this.doc.rect(30, eltop, 25, 5.5);
                    this.doc.text(this.informetrabajadoressindetallespdf[x].PICADA_INICIAL,  50,  eltop + 4,   "right"); //  left,top
                    this.doc.rect(55, eltop, 25, 5.5);
                    const picadaFinalPdf = this.informetrabajadoressindetallespdf[x]._PICADA_VIRTUAL_MEDIANOCHE &&
                      this.informetrabajadoressindetallespdf[x].PICADA_FINAL === '24:00' ? '24:00' :
                      (this.horaValida(this.informetrabajadoressindetallespdf[x].PICADA_FINAL) ?
                        this.informetrabajadoressindetallespdf[x].PICADA_FINAL : "");
                    this.doc.text(picadaFinalPdf,75,eltop + 4, "right" ); //  left,top
                    this.doc.rect(80, eltop, 25, 5.5); // left, top , width, height
                    
                    
                    
                    
                    this.doc.text(this.informetrabajadoressindetallespdf[x].HORAS_ALMORZANDO, 100, eltop + 4, "right"); //  left,top
                    this.doc.rect(105, eltop, 25, 5.5); // left, top , width, height
                    this.doc.text(this.informetrabajadoressindetallespdf[x].HORAS_PARADAS, 125, eltop + 4, "right"); //  left,top
                    this.doc.rect(130, eltop, 25, 5.5); // left, top , width, height
                    this.doc.text(this.informetrabajadoressindetallespdf[x].HORAS_SIN_TRABAJAR,  150,  eltop + 4, "right"); //  left,top

                    this.doc.rect(155, eltop, 25, 5.5); // left, top , width, height
                    this.doc.text(this.informetrabajadoressindetallespdf[x].HORAS_TRABAJADAS, 175, eltop + 4, "right"); //  left,top

                    if (this.informetrabajadoressindetallespdf[x].HORAS_TRABAJADAS != "" &&  this.informetrabajadoressindetallespdf[x].HORAS_TRABAJADAS != "00:00") {
                      this.totalhorasordinarias = this.variables.SumaRestaFechaMin(this.totalhorasordinarias, this.informetrabajadoressindetallespdf[x].HORAS_TRABAJADAS );
                    }

                    this.doc.rect(180, eltop, 25, 5.5); // left, top , width, height
                    this.doc.text( this.informetrabajadoressindetallespdf[x].HORAS_EXTRAS,  200, eltop + 4, "right" ); //  left,top

                    if (this.informetrabajadoressindetallespdf[x].HORAS_EXTRAS != "" && this.informetrabajadoressindetallespdf[x].HORAS_EXTRAS != "00:00" ) {
                      if (this.totalhorasextras.substr(0, 1) != "-") {
                        if (this.informetrabajadoressindetallespdf[x].HORAS_EXTRAS.substr(0, 1) == "-") {
                          this.totalhorasextras =  this.variables.SumaRestaFechaMin(this.totalhorasextras, this.informetrabajadoressindetallespdf[x].HORAS_EXTRAS );
                        } else {
                          this.totalhorasextras =  this.variables.SumaRestaFechaMin(this.totalhorasextras, this.informetrabajadoressindetallespdf[x].HORAS_EXTRAS );
                        }
                      } else {
                        if ( this.informetrabajadoressindetallespdf[x].HORAS_EXTRAS.substr(0, 1) == "-") {
                          this.totalhorasextras =  this.variables.SumaRestaFechaMin(this.totalhorasextras,this.informetrabajadoressindetallespdf[x].HORAS_EXTRAS );
                        } else {
                          this.totalhorasextras =  this.variables.SumaRestaFechaMin(this.totalhorasextras, this.informetrabajadoressindetallespdf[x].HORAS_EXTRAS );
                        }
                      }
                    }

                    this.doc.setTextColor("#000000");

                    eltop = eltop + 5.5;
                    x = x + 1;
                  
                } else {
                  
                  //alert("josn:" + JSON.stringify(this.informetrabajadoressindetallespdf[x]));

                  
                  fechanueva = this.variables.DIA.substr(0, 8) + valor1;

                   texto = "";

                   //console.log(this.variables.diasOcupados[v].DIA + " == " + fechanueva)
                   //console.log("no ENCONTRADO:" + fechanueva + "-->" + this.informetrabajadoressindetallespdf[x].FECHA.substr(8, 2));


                  for (var v = 0; v < this.diasdefiesta.length; v++) {
                    if (this.diasdefiesta[v].DIA == fechanueva.substr(8, 2) && this.diasdefiesta[v].MES == fechanueva.substr(5, 2)) {
                      texto = this.diasdefiesta[v].NOMBRE;
                      break;
                    } else {
                      texto = "";
                    }
                  }

  
                  for (var v = 0; v < (this.variables.diasOcupados || []).length; v++) {

                    if (this.variables.diasOcupados[v].DIA == fechanueva) {

                      //console.log(this.variables.diasOcupados[v].DIA +  " igual a " +  fechanueva);

                      texto = this.conceptoAusencia(this.variables.diasOcupados[v], this.trabajadores[rec].NOMBRE);
                      break;
                    } else {
                      //texto = "";
                    }
                  }
  
                  if (texto == "") {
                    valor1 = "00" + _i;
                    valor1 = valor1.substr(-2);
                    texto = this.diaSemanaGrande(
                      this.variables.DIA.substr(0, 8) + valor1
                    );
                  }

                  this.doc.setFontSize(8.5);
                  this.doc.setDrawColor(0);
                  this.doc.setTextColor(0, 0, 0);
                  this.doc.setFillColor(240, 240, 240);
                  this.doc.rect(5, eltop, 200, 5, "FD"); // F // FD para bordes
                  this.doc.text(
                  this.diaSemana(this.variables.DIA.substr(0, 8) + valor1) +  " " + valor1 + "/" +  this.variables.DIA.substr(5, 2) + "/" + this.variables.DIA.substr(0, 4), 25,  eltop + 3.8,  "right" );
                  this.doc.text(texto, 35, eltop + 3.8, "left"); //  left,top

                  eltop = eltop + 5;
                  x = x + 1;
              
                
              }
           }             
         }
            
         
        }

        // El resto del informe sigue trabajando con los datos calculados
        // originalmente, sin las filas vacías usadas solo para dibujar.
        this.informetrabajadoressindetallespdf = filasPdfOriginales;

        this.doc.setFontSize(8.5);
        this.doc.rect(155, eltop, 25, 5.5); // left, top , width, height
        if (this.totalhorasordinarias.includes("NaN")) {
          this.doc.text("--", 175, eltop + 4, "right"); //  left,top
        
        }else{
          this.doc.text(this.totalhorasordinarias, 175, eltop + 4, "right"); //  left,top
        
        }
        this.doc.rect(180, eltop, 25, 5.5); // left, top , width, height
        


        
        
        const filasTurnoPdf = Array.isArray(this.informetrabajadoressindetallespdf) ?
          this.informetrabajadoressindetallespdf : [];
        const nombresTurnoPdf: any = {};
        filasTurnoPdf.forEach((fila: any) => {
          const nombre = String(fila && fila.TURNO || '').trim().toLowerCase();
          if (nombre) { nombresTurnoPdf[nombre] = true; }
        });
        const turnoTrabajadorPdf = String(this.trabajadores[rec].TURNO || '').trim().toLowerCase();
        if (turnoTrabajadorPdf) { nombresTurnoPdf[turnoTrabajadorPdf] = true; }

        // Una asignación diaria puede hacer que la primera fila no represente
        // el modo real del mes. Se revisan todos los turnos usados en el PDF.
        const esTurnoGuardiaPdf = filasTurnoPdf.some((fila: any) =>
          String(fila && fila.MODO || '').trim().toLowerCase() === 'guardia'
        ) || (this.turnos || []).some((turno: any) => {
          const nombre = String(turno && (turno.NOMBRE || turno.TURNO) || '').trim().toLowerCase();
          return !!nombresTurnoPdf[nombre] &&
            String(turno && turno.MODO || '').trim().toLowerCase() === 'guardia';
        });

            if (esTurnoGuardiaPdf) {
            
          
                const fechaSel = new Date(this.variables.DIA);
                const anio = fechaSel.getFullYear();      // año del día señalado
                const mes  = fechaSel.getMonth() + 1;     // mes 1-12
          

                const horasContratoStr = this.trabajadores[rec].HORAS_CONTRATO || "0";

                const horasContratoNum = Number(horasContratoStr);  
          
                this.totalhorasextras = this.calcularHorasMes(horasContratoNum, anio, mes).toString();


                this.doc.text("Horas ordinarias esperadas:"  + this.totalhorasextras + "h"  + " (Contrato " + horasContratoStr + "h semanales)", 150, eltop + 4, "right"); 

              
                const minutosExtras = this.horasAMinutos(this.totalhorasextras);      // "85:43"
                const minutosOrdinarias = this.horasAMinutos(this.totalhorasordinarias); // "24:57"
                
                var minutosFinal;                
                // si quieres evitar negativos:
                // const minutosFinal = Math.max(minutosExtras - minutosOrdinarias, 0);
                
                if(minutosExtras >= minutosOrdinarias)
                {
                  minutosFinal = minutosExtras - minutosOrdinarias;
                  const total = this.minutosAHoras(minutosFinal); // → "60:46" en este ejemplo

                  this.doc.text("-" + total, 200, eltop + 4, "right"); 
  
              
                }else{
                  minutosFinal = minutosOrdinarias - minutosExtras;
                  const total = this.minutosAHoras(minutosFinal); // → "60:46" en este ejemplo

                  this.doc.text(total, 200, eltop + 4, "right"); 

                }

              
              
            }else{

              this.doc.text(this.totalhorasextras, 200, eltop + 4, "right"); //  left,top

            }

        eltop = eltop + 5.5;

        if (this.pdfDetalleConfigurado) {
          try {
            await this.anadirAnexoDetalleAlInforme(this.trabajadores[rec].CODIGO, this.trabajadores[rec]);
          } catch (error) {
            // No se pierde el informe oficial si el anexo no puede consultarse.
            console.log('No se pudo añadir el anexo explicativo', error);
          }
        }

        trabajadoresProcesados++;
        this.actualizarProgresoInforme(
          15 + Math.round((trabajadoresProcesados / totalTrabajadoresInforme) * 70),
          "Trabajador " + trabajadoresProcesados + " de " + trabajadoresInforme.length + " preparado"
        );
        await this.dejarPintarInterfaz();

        if (rec + 1 < this.trabajadores.length) {
          if (filtro == "todos") {
            this.doc.addPage();
          }
        }

        this.muestragif == "no";

      }
    }

    this.actualizarProgresoInforme(92, "Generando archivo PDF...");
    await this.dejarPintarInterfaz();
    this.muestragif = "NO";

    if (filtro == "todos") {
      var nombrefichero = "Informe Control Laboral.pdf";
    } else {
      var nombrefichero =
        "Informe " +
        this.variables.NOMBRETRABAJADOR +
        " de " +
        this.meses[this.MESHOY - 1] +
        " del " +
        this.anohoy +
        ".pdf";
    }
    
    this.cdr.detectChanges();

    this.doc.save(nombrefichero);
  }

  horasAMinutos(horasStr: string): number {
    if (!horasStr) {
      return 0;
    }
  
    const partes = horasStr.split(":");
  
    const h = parseInt(partes[0], 10) || 0;
    const m = parseInt(partes[1], 10) || 0;
  
    return h * 60 + m;
  }

  private conceptoAusencia(ausencia: any, nombreTrabajador: string = ''): string {
    if (!ausencia) { return 'Vacaciones'; }

    const nombre = String(ausencia.NOMBRE || ausencia.nombre || '').trim();
    const trabajador = String(nombreTrabajador || ausencia.TRABAJADOR_NOMBRE || '').trim();
    if (nombre && (!trabajador || nombre.toLowerCase() !== trabajador.toLowerCase())) {
      return nombre;
    }

    const tipo = String(ausencia.TIPO_NOMBRE || ausencia.tipo_nombre || '').trim();
    return tipo || 'Vacaciones';
  }
  

  diaSemana(fecha) {
    var dia = fecha.substr(8, 2);
    var mes = fecha.substr(5, 2);
    var anio = fecha.substr(0, 4);

    var dias = ["D", "L", "M", "X", "J", "V", "S"];
    var dt = new Date(mes + " " + dia + ", " + anio + " 12:00:00");

    //console.log(dia + "/" + mes + "/" + anio + "");

    return dias[dt.getUTCDay()];
  }

  diaSemanaGrande(fecha) {
    var dia = fecha.substr(8, 2);
    var mes = fecha.substr(5, 2);
    var anio = fecha.substr(0, 4);

    var dias = [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sabado",
    ];
    var dt = new Date(mes + " " + dia + ", " + anio + " 12:00:00");

    //console.log(dia + "/" + mes + "/" + anio + "");

    return dias[dt.getUTCDay()];
  }



  obtenerobras(filtro) {
    this.funciones
      .obtieneobras(filtro)
      .then((data) => {
        this.sobras = data;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  obtenerturnos(filtro) {
    this.funciones
      .obtieneturnos(filtro)
      .then((data) => {
        this.turnos = data;
      })
      .catch((error) => {
        console.log(error);
      });
  }


  obtenerempresas(user): Promise<any[]> {

    return this.funciones.obtieneempresas(user).then((respuesta: any) => {
  
      if (respuesta && Array.isArray(respuesta)) {
        this.empresas = respuesta;
      } else {
        this.empresas = [];
      }
  
  //    console.log("Empresas cargadas dentro de obtenerempresas:", this.empresas);
  
      return this.empresas;
    }).catch(error => {
  
  //    console.log("Error cargando empresas:", error);
  
      this.empresas = [];
  
      return [];
    });
  }


  normalizaEmpresa(valor: any): string {
    return String(valor || "")
      .replace(/\s+/g, " ")
      .replace(/Á/g, "A")
      .replace(/É/g, "E")
      .replace(/Í/g, "I")
      .replace(/Ó/g, "O")
      .replace(/Ú/g, "U")
      .replace(/Ü/g, "U")
      .replace(/Ñ/g, "N")
      .trim()
      .toUpperCase();
  }
  
  
  async obtenerEmpresasParaCifInforme(): Promise<any[]> {
  
    let candidatos: string[] = [];
  
    const add = (valor: any) => {
      valor = String(valor || "").trim();
  
      if (
        valor !== "" &&
        valor !== "654321123456" &&
        candidatos.indexOf(valor) === -1
      ) {
        candidatos.push(valor);
      }
    };
  
    /*
      Posibles usuarios donde pueden estar dadas de alta las empresas.
    */
    add(this.variables.CLIENTES_RAZSOCIAL);
    add(this.variables.emailoriginal);
  
    if (this.users && this.users[0]) {
      add(this.users[0].ESTADO);
      add(this.users[0].estado);
      add(this.users[0].USER_PADRE);
      add(this.users[0].PADRE);
      add(this.users[0].user);
      add(this.users[0].name);
    }
  
    //console.log("Usuarios candidatos para cargar empresas:", candidatos);
  
    for (let usuario of candidatos) {
  
  //    console.log("Probando empresas con usuario:", usuario);
  
      let empresas = await this.obtenerempresas(usuario);
  
    //  console.log("Resultado empresas de " + usuario + ":", empresas);
  
      if (empresas && empresas.length > 0) {
      //  console.log("Empresas encontradas usando usuario:", usuario);
        return empresas;
      }
    }
  
    //console.log("No se encontraron empresas en ningún usuario candidato.");
    return [];
  }


  async creaelinformepdf(codigo_trabajador) {
    var trabajadorr;
    var i: number;
    var eltop;
    var trabajadorr;

    this.muestragif == "si";

    this.variables.muestragif = "si";
    this.variables.muestraerror = "no";

    if (this.variables.CODIGOTRABAJADOR != "") {
      // console.log( this.valortrabajador);
      this.valortrabajador = this.variables.CODIGOTRABAJADOR;
    }

    

    this.totalhorasextras = "00:00";
    this.totalhorasordinarias = "00:00";

    this.informetrabajadorespdf = [];
    this.informetrabajadoressindetallespdf = [];

    var obj = await this.funciones
      .obtieneinforme(
        codigo_trabajador,
        "654321123456",
        "654321123456",
        "654321123456",
        this.FechaIni,
        this.FechaFin,
        this.variables.MODO
      )
      .then(async (data: any[]) => {

        this.informetrabajadorespdf = this.funciones.normalizarJornadasMedianoche ?
          await this.funciones.normalizarJornadasMedianoche(
            data as any[], codigo_trabajador, this.FechaIni, this.FechaFin, false) : data;
        if (!this.turnos || !this.turnos.length) {
          try { this.turnos = await this.funciones.obtieneturnos(this.valo); } catch (error) { this.turnos = []; }
        }
        await this.aplicarAsignacionesAfilas(this.informetrabajadorespdf, this.turnos || []);


        //if (this.informetrabajadorespdf[0].PICADA_FINAL != "-00:00") {
          
          this.SUMAEXTRASPDF = 0;
          this.SUMAMINUTOSEXTRASPDF = 0;
          this.SUMAEXTRASFIESTASPDF = 0;
          this.SUMAMINUTOSFIESTASPDF = 0;

          this.obtenerobras(this.valo);
          //this.obtenerempresas(this.valo);
          this.obtenerturnos(this.valo);
          //this.obtenertrabajadores(this.valo);

          var sumahorasparadas;
          var sumaminutosparadas;
          var sumahorasalmuerzo;
          var sumaminutosalmuerzos;
          var sumahorassintrabajar;
          var sumaminutossintrabajar;

          var horas;
          var minutos;
          var lug;

          this.imagenactual = "";
          this.cuenta = 0;

          this.informetrabajadoressindetallespdf = [];

          for (var _i = 0; _i < this.informetrabajadorespdf.length; _i++) {

            
            if (this.informetrabajadorespdf[_i].PICADA_INICIAL != "no") {
              /*REDONDEA PICADA IICIAL Y PICADA FINAL PARA EL INFORME*/

              if (this.informetrabajadorespdf[_i].NOMBRE != "SAL") {
                /*  CAMBIO LAS PICADAS PARA EL INFORME DE PRUEBAS             */

                if (this.variables.MODO != "real") {

                  this.HIni = Number(
                    this.informetrabajadorespdf[_i].HORA_ENTRADA.substr(0, 2)
                  );
                  this.MIni = Number(
                    this.informetrabajadorespdf[_i].HORA_ENTRADA.substr(3, 2)
                  );

                  //BUSCO UN ICAJE ALEATORIO
                  this.Aleatorio = this.variables.numeroAleatorio(-7, 7);
                  //console.log("ale1:" + this.Aleatorio);

                  if (Number(this.Aleatorio) > 0) {
                    if (Number(this.MIni) + Number(this.Aleatorio) > 59) {
                      this.HIni = Number(this.HIni) + 1;
                      this.MIni =
                        Number(this.Aleatorio) + Number(this.MIni) - 59;
                    } else {
                      this.MIni = Number(this.Aleatorio) + Number(this.MIni);
                    }
                  } else {
                    if (Number(this.MIni) + Number(this.Aleatorio) < 0) {
                      this.HIni = Number(this.HIni) - 1;
                      this.MIni =
                        Number(this.MIni) + Number(this.Aleatorio) + 59;
                    } else {
                      this.MIni = Number(this.MIni) + Number(this.Aleatorio);
                    }
                  }

                  //subeeee
                  this.informetrabajadorespdf[_i].PICADA_INICIAL =
                    (this.HIni < 10 ? "0" + this.HIni : this.HIni) +
                    ":" +
                    (this.MIni < 10 ? "0" + this.MIni : this.MIni);
                  /************** */





                  if (
                    Number(this.informetrabajadorespdf[_i].HORAS_PREVISTAS) < 0
                  ) {
                    

     
                    this.informetrabajadorespdf[_i].HORAS_PREVISTAS =
                    this.informetrabajadorespdf[_i].HORAS_PREVISTAS.substr(1);
                
  
                    this.HIni = Number(this.informetrabajadorespdf[_i].PICADA_INICIAL.substr(0, 2));
                    this.MIni = Number(this.informetrabajadorespdf[_i].PICADA_INICIAL.substr(3, 2));
                    
                    // Convertir horas y minutos de PICADA_INICIAL a minutos totales
                    let totalMinutosInicial = this.HIni * 60 + this.MIni;
                    
                    // Convertir HORAS_PREVISTAS a minutos totales
                    let minutosPrevistos = Math.round(Number(this.informetrabajadorespdf[_i].HORAS_PREVISTAS) * 60);
                    
                    // Sumar los minutos de PICADA_INICIAL y los minutos de HORAS_PREVISTAS
                    let totalMinutosFinal = totalMinutosInicial + minutosPrevistos;
                    
                    // Calcular las horas y los minutos del resultado
                    this.HIni = Math.floor(totalMinutosFinal / 60);
                    this.MIni = totalMinutosFinal % 60;
                    
                    this.Aleatorio = this.variables.numeroAleatorio(-7, 7);
                    // ... (código para ajustar this.HIni y this.MIni con el valor aleatorio)
                    
                    this.informetrabajadorespdf[_i].PICADA_FINAL =
                        (this.HIni < 10 ? "0" + this.HIni : this.HIni) +
                        ":" +
                        (this.MIni < 10 ? "0" + this.MIni : this.MIni);
  

                  } else {
                    this.HIni = Number(
                      this.informetrabajadorespdf[_i].HORA_SALIDA.substr(0, 2)
                    );
                    this.MIni = Number(
                      this.informetrabajadorespdf[_i].HORA_SALIDA.substr(3, 2)
                    );
                    //BUSCO UN ICAJE ALEATORIO
                    this.Aleatorio = this.variables.numeroAleatorio(-7, 7);
                    //console.log("ale2:" + this.Aleatorio);

                    if (Number(this.Aleatorio) > 0) {
                      if (Number(this.MIni) + Number(this.Aleatorio) > 59) {
                        this.HIni = Number(this.HIni) + 1;
                        this.MIni =
                          Number(this.Aleatorio) + Number(this.MIni) - 59;
                      } else {
                        this.MIni = Number(this.Aleatorio) + Number(this.MIni);
                      }
                    } else {
                      if (Number(this.MIni) + Number(this.Aleatorio) < 0) {
                        this.HIni = Number(this.HIni) - 1;
                        this.MIni =
                          Number(this.MIni) + Number(this.Aleatorio) + 59;
                      } else {
                        this.MIni = Number(this.MIni) + Number(this.Aleatorio);
                      }
                    }

                    /*mODIFICA LA PICADA FINAL*/
                    this.informetrabajadorespdf[_i].PICADA_FINAL =
                      (this.HIni < 10 ? "0" + this.HIni : this.HIni) +
                      ":" +
                      (this.MIni < 10 ? "0" + this.MIni : this.MIni);
                  }
                }

                // En el PDF también se conserva la salida pendiente como
                // "no" para mostrarla vacía, pero se calcula como 24:00.
                const picadaFinalParaCalculo = this.horaValida(this.informetrabajadorespdf[_i].PICADA_FINAL) ?
                  this.informetrabajadorespdf[_i].PICADA_FINAL : "24:00";
                var MM1 = 0;



                  //************************************************************************
                  // Busca los minutos de cortesia
                  //************************************************************************

                  /*
                  var start_actual_time1 = +new Date(
                    Date.UTC(
                      this.informetrabajadorespdf[_i].FECHA.substr(0, 4),
                      this.informetrabajadorespdf[_i].FECHA.substr(5, 2),
                      this.informetrabajadorespdf[_i].FECHA.substr(8, 2),
                      this.informetrabajadorespdf[_i].PICADA_INICIAL.substr(0, 2) -
                        2,
                      this.informetrabajadorespdf[_i].PICADA_INICIAL.substr(3, 2),
                      0
                    )
                  );
                  var end_actual_time1 = +new Date(
                    Date.UTC(
                      this.informetrabajadorespdf[_i].FECHA.substr(0, 4),
                      this.informetrabajadorespdf[_i].FECHA.substr(5, 2),
                      this.informetrabajadorespdf[_i].FECHA.substr(8, 2),
                      this.informetrabajadorespdf[_i].HORA_ENTRADA.substr(0, 2) -
                        2,
                      this.informetrabajadorespdf[_i].HORA_ENTRADA.substr(3, 2),
                      0
                    )
                  );

                  var diff1 = end_actual_time1 - start_actual_time1;

                  var diffSeconds1 = diff1 / 1000;
                  var HH1 = Math.floor(diffSeconds1 / 3600);

                  MM1 = Math.floor(diffSeconds1 % 3600) / 60;

                  if (
                    MM1 >= -Math.floor(this.informetrabajadorespdf[_i].CORTESIA) &&
                    MM1 <= Math.floor(this.informetrabajadorespdf[_i].CORTESIA)
                  ) {
                    if (MM1 > 0) {
                      this.informetrabajadorespdf[_i].HORAS_AJUSTE = "-" + MM1;
                    } else {
                      //this.informetrabajadorespdf[_i].HORAS_AJUSTE =  String(MM1).substr(1);
                    }
                  } 

                  */

                  var start_actual_time = +new Date(
                    Date.UTC(
                      this.informetrabajadorespdf[_i].FECHA.substr(0, 4),
                      this.informetrabajadorespdf[_i].FECHA.substr(5, 2),
                      this.informetrabajadorespdf[_i].FECHA.substr(8, 2),
                      this.informetrabajadorespdf[_i].PICADA_INICIAL.substr(0, 2) -
                        2,
                      this.informetrabajadorespdf[_i].PICADA_INICIAL.substr(3, 2),
                      0
                    )
                  );


                  var end_actual_time = +new Date(
                    Date.UTC(
                      this.informetrabajadorespdf[_i].FECHA.substr(0, 4),
                      this.informetrabajadorespdf[_i].FECHA.substr(5, 2),
                      this.informetrabajadorespdf[_i].FECHA.substr(8, 2),
                      picadaFinalParaCalculo.substr(0, 2) -
                        2,
                      picadaFinalParaCalculo.substr(3, 2),
                      0
                    )
                  );


             

                  var diff = end_actual_time - start_actual_time;

                  var diffSeconds = diff / 1000;
                  var HH = Math.floor(diffSeconds / 3600);
                  var MM = Math.floor(diffSeconds % 3600) / 60;
                  var formatted =
                    (HH < 10 ? "0" + HH : HH) + ":" + (MM < 10 ? "0" + MM : MM);

                  //console.log("HORAS TRANSC:" +  formatted);

                  
                  
                  this.informetrabajadorespdf[_i].HORAS_TRANSCURRIDAS =
                    (HH < 10 ? "0" + HH : HH) +
                    ":" +
                    (MM < 10 ? "0" + MM : MM) +
                    "";


                    
                  this.informetrabajadorespdf[_i].COLOR = "#FFFFFF";

                  lug = _i;


                  this.informetrabajadorespdf[lug].HORAS_AJUSTE = this.informetrabajadorespdf[_i].HORAS_AJUSTE;

                  

                  sumahorasparadas = 0;
                  sumaminutosparadas = 0;
                  sumahorasalmuerzo = 0;
                  sumaminutosalmuerzos = 0;
                  sumahorassintrabajar = 0;
                  sumaminutossintrabajar = 0;
                  horas = 0;
                  minutos = 0;

                } else {

                /*  suma las paradas */



                const picadaFinalParaCalculoParada = this.horaValida(this.informetrabajadorespdf[_i].PICADA_FINAL) ?
                  this.informetrabajadorespdf[_i].PICADA_FINAL : "24:00";

                start_actual_time = +new Date(
                  Date.UTC(
                    this.informetrabajadorespdf[_i].FECHA.substr(0, 4),
                    this.informetrabajadorespdf[_i].FECHA.substr(5, 2),
                    this.informetrabajadorespdf[_i].FECHA.substr(8, 2),
                    this.informetrabajadorespdf[_i].PICADA_INICIAL.substr(
                      0,
                      2
                    ) - 2,
                    this.informetrabajadorespdf[_i].PICADA_INICIAL.substr(3, 2),
                    0
                  )
                );

                end_actual_time = +new Date(
                  Date.UTC(
                    this.informetrabajadorespdf[_i].FECHA.substr(0, 4),
                    this.informetrabajadorespdf[_i].FECHA.substr(5, 2),
                    this.informetrabajadorespdf[_i].FECHA.substr(8, 2),
                    picadaFinalParaCalculoParada.substr(0, 2) -
                      2,
                    picadaFinalParaCalculoParada.substr(3, 2),
                    0
                  )
                );

                diff = end_actual_time - start_actual_time;



                diffSeconds = diff / 1000;
                HH = Math.floor(diffSeconds / 3600);
                MM = Math.floor(diffSeconds % 3600) / 60;

                

                if (this.variables.MODO == "real") {


                  switch (this.informetrabajadorespdf[_i].TIPO) {
                    case "Almorzando":
                      //console.log(HH);
                      if (HH > 1) {
                        HH = 1;
                      }
                      sumahorasalmuerzo = sumahorasalmuerzo + HH;
                      sumaminutosalmuerzos = sumaminutosalmuerzos + MM;

                      //SI EXISTE ALMUERZO COMO MIN UNA HORA
                      if (HH < 1) {
                        this.informetrabajadorespdf[lug].HORAS_ALMORZANDO =
                          "01:00";
                      } else {
                        this.informetrabajadorespdf[lug].HORAS_ALMORZANDO =
                          sumahorasalmuerzo + ":" + sumaminutosalmuerzos + "";
                        this.informetrabajadorespdf[lug].HORAS_ALMORZANDO =
                          (sumahorasalmuerzo < 10
                            ? "0" + sumahorasalmuerzo
                            : sumahorasalmuerzo) +
                          ":" +
                          (sumaminutosalmuerzos < 10
                            ? "0" + sumaminutosalmuerzos
                            : sumaminutosalmuerzos) +
                          "";
                      }
                      /*REDONDEA PICADA IICIAL Y PICADA FINAL PARA EL INFORME*/

                      this.hp = this.informetrabajadorespdf[
                        lug
                      ].HORAS_ALMORZANDO.substr(0, 2);
                      this.mp = this.informetrabajadorespdf[
                        lug
                      ].HORAS_ALMORZANDO.substr(3, 2);
                      //console.log("MP inicio" + this.mp);

                      if (Number(this.mp) < 30) {
                        this.mp = "00";
                      } else {
                      }

                      //console.log("resultado mp" + this.mp);
                      this.hp = Number(this.hp);
                      this.informetrabajadorespdf[lug].HORAS_ALMORZANDO =
                        (this.hp < 10 ? "0" + this.hp : this.hp) +
                        ":" +
                        this.mp;

                      /*             CAMBIO LAS PICADAS PARA EL INFORME DE PRUEBAS             */
                      if (this.variables.MODO != "real") {
                        this.informetrabajadorespdf[lug].PICADA_FINAL =
                          this.variables.SumaRestaFechaMin(
                            this.informetrabajadorespdf[lug].HORAS_ALMORZANDO,
                            this.informetrabajadorespdf[lug].PICADA_FINAL
                          );
                        this.informetrabajadorespdf[lug].HORAS_TRABAJADAS =
                          this.variables.SumaRestaFechaMin(
                            this.informetrabajadorespdf[lug].HORAS_ALMORZANDO,
                            this.informetrabajadorespdf[lug].HORAS_TRABAJADAS
                          );
                        this.informetrabajadorespdf[lug].HORAS_TRANSCURRIDAS =
                          this.variables.SumaRestaFechaMin(
                            this.informetrabajadorespdf[lug].HORAS_ALMORZANDO,
                            this.informetrabajadorespdf[lug]
                              .HORAS_TRANSCURRIDAS
                          );
                      }

                      break;

                    case "Desayunando":
                    case "Comprando":
                    case "Descansando":
                    case "Viajando":
                    case "Otros":
                      sumahorasparadas = sumahorasparadas + HH;
                      sumaminutosparadas = sumaminutosparadas + MM;
                      if (sumaminutosparadas >= 60) {
                        sumaminutosparadas = sumaminutosparadas - 60;
                        sumahorasparadas = sumahorasparadas + 1;
                      }
                      this.informetrabajadorespdf[lug].HORAS_PARADAS =
                        (sumahorasparadas < 10
                          ? "0" + sumahorasparadas
                          : sumahorasparadas) +
                        ":" +
                        (sumaminutosparadas < 10
                          ? "0" + sumaminutosparadas
                          : sumaminutosparadas) +
                        "";

                      break;

                    default:
                      
                      this.informetrabajadorespdf[_i].TIPO = "";


                      sumahorassintrabajar = sumahorassintrabajar + HH;
                      sumaminutossintrabajar = sumaminutossintrabajar + MM;
                      if (sumaminutossintrabajar >= 60) {
                        sumaminutossintrabajar = sumaminutossintrabajar - 60;
                        sumahorassintrabajar = sumahorassintrabajar + 1;
                      }



                      this.informetrabajadorespdf[lug].HORAS_SIN_TRABAJAR =
                        (sumahorassintrabajar < 10
                          ? "0" + sumahorassintrabajar
                          : sumahorassintrabajar) +
                        ":" +
                        (sumaminutossintrabajar < 10
                          ? "0" + sumaminutossintrabajar
                          : sumaminutossintrabajar) +
                        "";


                        


                      break;
                  }



                }else{


                  // alert(this.informetrabajadores[lug].HORAS_TRABAJADAS);    
                   
                   sumahorassintrabajar = sumahorassintrabajar + HH;
                   sumaminutossintrabajar = sumaminutossintrabajar + MM;
                   if (sumaminutossintrabajar >= 60) {
                     sumaminutossintrabajar = sumaminutossintrabajar - 60;
                     sumahorassintrabajar = sumahorassintrabajar + 1;
                   }

                   this.informetrabajadorespdf[lug].HORAS_SIN_TRABAJAR =
                     (sumahorassintrabajar < 10
                       ? "0" + sumahorassintrabajar
                       : sumahorassintrabajar) +
                     ":" +
                     (sumaminutossintrabajar < 10
                       ? "0" + sumaminutossintrabajar
                       : sumaminutossintrabajar) +
                     "";



                 }
               }




              if (this.informetrabajadorespdf[_i].NOMBRE != "SAL") {
                //this.totalizatrabajadorinformepdf(lug, "no");

                //this.cuenta = this.cuenta + 1;
              }
            }
          }

          //totaliza los camnpo de extras
          for (var _i = 0; _i < this.informetrabajadorespdf.length; _i++) {
            if (this.informetrabajadorespdf[_i].PICADA_INICIAL != "no") {
              if (this.informetrabajadorespdf[_i].NOMBRE != "SAL") {
                lug = _i;


                this.aplicarAlmuerzoConfigurado(this.informetrabajadorespdf[_i]);


                this.totalizatrabajadorinformepdf(lug, "SI");

                //*****************************************************************************
                //  SUMA HORAS EXTRAS Y EXTRAORDINARIAS PARA EL TOTAL DEL INFORME
                if (
                  Number(
                    this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE
                  ) < 0
                ) {
                  this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE =
                    "00:00";
                }
                
                
                //console.log(this.informetrabajadorespdf[_i].DIA);
                
                
                
                if (this.informetrabajadorespdf[_i].DIA == "Fiesta") {
                  this.informetrabajadorespdf[_i].COLOR = "#FF0000";


                  if (
                    this.informetrabajadorespdf[
                      _i
                    ].HORAS_EXTRAS_CON_AJUSTE.substr(0, 1) == "-"
                  ) {
                    this.hp = this.informetrabajadorespdf[
                      _i
                    ].HORAS_EXTRAS_CON_AJUSTE.substr(0, 3);
                    this.mp = this.informetrabajadorespdf[
                      _i
                    ].HORAS_EXTRAS_CON_AJUSTE.substr(4, 2);
                  } else {
                    this.hp = this.informetrabajadorespdf[
                      _i
                    ].HORAS_EXTRAS_CON_AJUSTE.substr(0, 2);
                    this.mp = this.informetrabajadorespdf[
                      _i
                    ].HORAS_EXTRAS_CON_AJUSTE.substr(3, 2);
                  }

                  if (Number(this.hp) >= 0) {
                    this.SUMAMINUTOSFIESTASPDF =
                      Number(this.SUMAMINUTOSFIESTASPDF) + Number(this.mp);

                    if (this.SUMAMINUTOSFIESTASPDF >= 60) {
                      this.SUMAEXTRASFIESTASPDF =
                        Number(this.SUMAEXTRASFIESTASPDF) + 1;
                      this.SUMAMINUTOSFIESTASPDF =
                        Number(this.SUMAMINUTOSFIESTASPDF) - 60;
                    }
                  } else {
                    this.SUMAMINUTOSFIESTASPDF =
                      Number(this.SUMAMINUTOSFIESTASPDF) - Number(this.mp);

                    if (this.SUMAEXTRASFIESTASPDF >= 1) {
                      if (this.SUMAMINUTOSEXTRASPDF < 0) {
                        this.SUMAEXTRASFIESTASPDF =
                          Number(this.SUMAEXTRASFIESTASPDF) - 1;
                        this.SUMAMINUTOSFIESTASPDF =
                          Number(this.SUMAMINUTOSFIESTASPDF) + 60;
                      }
                    }
                  }

                  this.SUMAEXTRASFIESTASPDF =
                    Number(this.SUMAEXTRASFIESTASPDF) + Number(this.hp);
                }
              }
            }
          }

          if (Number(this.SUMAMINUTOSEXTRASPDF) < 0) {
            this.SUMAMINUTOSEXTRASPDF = -Number(this.SUMAMINUTOSEXTRASPDF);
          }

          if (this.SUMAEXTRASPDF < 0) {
            this.SUMAEXTRASPDF = -this.SUMAEXTRASPDF;
            this.hp =
              (this.SUMAEXTRASPDF < 10
                ? "0" + this.SUMAEXTRASPDF
                : this.SUMAEXTRASPDF) +
              ":" +
              (this.SUMAMINUTOSEXTRASPDF < 10
                ? "0" + this.SUMAMINUTOSEXTRASPDF
                : this.SUMAMINUTOSEXTRASPDF);
            this.hp = "-" + this.hp;
          } else {
            this.hp =
              (this.SUMAEXTRASPDF < 10
                ? "0" + this.SUMAEXTRASPDF
                : this.SUMAEXTRASPDF) +
              ":" +
              (this.SUMAMINUTOSEXTRASPDF < 10
                ? "0" + this.SUMAMINUTOSEXTRASPDF
                : this.SUMAMINUTOSEXTRASPDF);
          }

          /*

          // 1. Nombre del turno del trabajador
          const nombreTurno = (this.informetrabajadorespdf[lug].TURNO || "").toLowerCase();
          console.log("1º_ turno trabajador:", nombreTurno);
          
          // 2. Buscar el objeto turno dentro de this.turnos
          let turnoObj: any = null;
          
          if (this.turnos && this.turnos.length) {
            turnoObj = this.turnos.find(
              (t: any) => ((t.NOMBRE || t.TURNO || "").toLowerCase() === nombreTurno)
            );
          }
          
          if (turnoObj) {
            const modo = (turnoObj.MODO || "").toLowerCase();  // modo en minúsculas
          
            // Si el modo es guardia
            if (modo === "guardia") {
          
          
              let hcontra: any = null;
          
              // OJO: la propiedad es CODIGO, no Codigo
              if (this.trabajadores && this.trabajadores.length) {
                hcontra = this.trabajadores.find(
                  (h: any) => ((h.CODIGO || "").toLowerCase() === (codigo_trabajador || "").toLowerCase())
                );
              }
          
              if (hcontra) {
          
                const fechaSel = new Date(this.variables.DIA);
                const anio = fechaSel.getFullYear();      // año del día señalado
                const mes  = fechaSel.getMonth() + 1;     // mes 1-12
          
                // Pasar de string a número
                const horasContratoStr = hcontra.HORAS_CONTRATO || "0";
                const horasContratoNum = Number(horasContratoStr);  // o parseFloat si llevase decimales
          
                this.totalhorasextras = this.calcularHorasMes(horasContratoNum, anio, mes).toString();
          
              } 
            }
          } 
          
          */

          this.informetrabajadorespdf.push({
            FECHA: "--",
            CODIGO: "--",
            NOMBRE: "",
            OBRA: "TOTALES HORAS EXTRAS",
            PICADA_INICIAL: "",
            PICADA_FINAL: "",
            HORAS_TRANSCURRIDAS: "",
            HORAS_TRABAJADAS: this.totalhorasordinarias,
            HORAS_PARADAS: "",
            HORAS_ALMORZANDO: "",
            HORAS_EXTRAS: this.totalhorasextras,
            COLOR: "ROJO",
          });

          this.informetrabajadoressindetallespdf.push({
            FECHA: "--",
            CODIGO: "--",
            NOMBRE: "",
            OBRA: "TOTALES HORAS EXTRAS",
            PICADA_INICIAL: "",
            PICADA_FINAL: "",
            HORAS_TRANSCURRIDAS: "",
            HORAS_TRABAJADAS: this.totalhorasordinarias,
            HORAS_PARADAS: "",
            HORAS_ALMORZANDO: "",
            HORAS_SIN_TRABAJAR: "",
            HORAS_EXTRAS: this.totalhorasextras,
          });

          //console.log ("Total HORAS EXTRAS2:" + this.totalhorasextras);

          this.hp = "";

          if (Number(this.SUMAMINUTOSFIESTASPDF) < 0) {
            this.SUMAMINUTOSFIESTASPDF = -Number(this.SUMAMINUTOSFIESTASPDF);
          }

          if (this.SUMAEXTRASFIESTAS < 0) {
            this.SUMAEXTRASFIESTASPDF = -this.SUMAEXTRASFIESTASPDF;
            this.hp =
              (this.SUMAEXTRASFIESTASPDF < 10
                ? "0" + this.SUMAEXTRASFIESTASPDF
                : this.SUMAEXTRASFIESTASPDF) +
              ":" +
              (this.SUMAMINUTOSFIESTASPDF < 10
                ? "0" + this.SUMAMINUTOSFIESTASPDF
                : this.SUMAMINUTOSFIESTASPDF);
            this.hp = "-" + this.hp1;
          } else {
            this.hp =
              (this.SUMAEXTRASFIESTASPDF < 10
                ? "0" + this.SUMAEXTRASFIESTASPDF
                : this.SUMAEXTRASFIESTASPDF) +
              ":" +
              (this.SUMAMINUTOSFIESTASPDF < 10
                ? "0" + this.SUMAMINUTOSFIESTASPDF
                : this.SUMAMINUTOSFIESTASPDF);
          }

          this.informetrabajadorespdf.push({
            FECHA: "--",
            CODIGO: "--",
            NOMBRE: "",
            OBRA: "TOTALES HORAS FIESTA",
            PICADA_INICIAL: "",
            PICADA_FINAL: "",
            HORAS_TRANSCURRIDAS: "",
            HORAS_TRABAJADAS: "",
            HORAS_PARADAS: "",
            HORAS_ALMORZANDO: "",
            HORAS_EXTRAS: this.hp,
            COLOR: "FIESTA",
          });

          this.informetrabajadoressindetallespdf.push({
            FECHA: "--",
            CODIGO: "--",
            NOMBRE: "",
            OBRA: "TOTALES HORAS FIESTA",
            PICADA_INICIAL: "",
            PICADA_FINAL: "",
            HORAS_TRANSCURRIDAS: "",
            HORAS_TRABAJADAS: "",
            HORAS_PARADAS: "",
            HORAS_ALMORZANDO: "",
            HORAS_SIN_TRABAJAR: "",
            HORAS_EXTRAS: this.hp,
          });

          this.variables.muestragif = "no";
          this.variables.muestraerror = "no";
          this.totalizatrabajadorinformepdf(lug, "no");
       
      }
    
    );

    

    //console.log("dentro c **********" + this.variables.CODIGOTRABAJADOR);

    return this.informetrabajadoressindetallespdf;
  }

  totalizatrabajadorinformepdf(lug, hacerlo) {
    var horascompletas = 0;
    var horascomida;
    var horasPrevistas =0;
    var minutosPrevistos=0;
    var diferenciaMinutos =0;
    var minutosFinal=0;
    var minutosInicial=0;

    const filaInformePdf = this.informetrabajadorespdf[lug];
    const transcurridasVirtualesPdfValidas = !!filaInformePdf &&
      !!filaInformePdf._PICADA_VIRTUAL_MEDIANOCHE &&
      String(filaInformePdf.HORAS_TRANSCURRIDAS || '').trim() === '24:00';
    if (!filaInformePdf ||
        !this.horaValida(filaInformePdf.PICADA_INICIAL) ||
        (!this.horaValida(filaInformePdf.HORAS_TRANSCURRIDAS) &&
          !transcurridasVirtualesPdfValidas && this.variables.MODO == "real")) {
      if (this.informetrabajadorespdf[lug]) {
        this.informetrabajadorespdf[lug].HORAS_TRABAJADAS = "";
        this.informetrabajadorespdf[lug].HORAS_EXTRAS = "";
        this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE = "";
      }
      return;
    }

    const minutosSinTrabajarReales = Number(this.informetrabajadorespdf[lug]._MINUTOS_SIN_TRABAJAR_REAL);
    const tienePausaRealMedianoche = !!this.informetrabajadorespdf[lug]._PICADA_VIRTUAL_MEDIANOCHE &&
      isFinite(minutosSinTrabajarReales) && minutosSinTrabajarReales >= 0;
    if (tienePausaRealMedianoche && this.variables.MODO == "real") {
      this.informetrabajadorespdf[lug].HORAS_SIN_TRABAJAR = this.minToHHMM24(minutosSinTrabajarReales);
    }
    


    if (this.variables.MODO == "real") {

     

      this.hg = this.informetrabajadorespdf[lug].HORAS_TRANSCURRIDAS.substr(0, 2);
      this.mg = this.informetrabajadorespdf[lug].HORAS_TRANSCURRIDAS.substr(3, 2);

      
      
      

      /* si no existen horas sin trabajar*/

      if (this.informetrabajadorespdf[lug].HORAS_SIN_TRABAJAR) {


        this.hp = this.informetrabajadorespdf[lug].HORAS_SIN_TRABAJAR.substr(0, 2);
        this.mp = this.informetrabajadorespdf[lug].HORAS_SIN_TRABAJAR.substr(3, 2);
        this.hg1 = Number(this.hg) - Number(this.hp);
        this.mg1 = Number(this.mg) - Number(this.mp);
        if (this.mg1 < 0) {
          this.mg1 = 60 + Number(this.mg1);
          this.hg1 = Number(this.hg1) - 1;
        }
        this.informetrabajadorespdf[lug].HORAS_TRABAJADAS =
          (this.hg1 < 10 ? "0" + this.hg1 : this.hg1) +
          ":" +
          (this.mg1 < 10 ? "0" + this.mg1 : this.mg1);
      } else {

        this.informetrabajadorespdf[lug].HORAS_TRABAJADAS =
          this.informetrabajadorespdf[lug].HORAS_TRANSCURRIDAS;
      }

      /*RESTAMOS LAS HORAS TRABAJADAS MENOS LAS HORAS DE COMER      */
      this.hg = this.informetrabajadorespdf[lug].HORAS_TRABAJADAS.substr(0, 2);
      horascompletas = this.hg;
      this.mg = this.informetrabajadorespdf[lug].HORAS_TRABAJADAS.substr(3, 2);

  


      if (this.informetrabajadorespdf[lug].HORAS_ALMORZANDO) {
        // Obtener horas y minutos de HORAS_ALMORZANDO
        this.hp = this.informetrabajadorespdf[lug].HORAS_ALMORZANDO.substr(0, 2);
        this.mp = this.informetrabajadorespdf[lug].HORAS_ALMORZANDO.substr(3, 2);
    
        // Convertir horas a minutos y sumar los minutos
        let totalMinutosAlmuerzo = Number(this.hp) * 60 + Number(this.mp); 
        let totalMinutosTrabajados = Number(this.hg) * 60 + Number(this.mg);
    
        
        
        let totalMinutosResultantes = totalMinutosTrabajados - totalMinutosAlmuerzo;



        // Calcular horas y minutos a partir de la diferencia
        this.hg1 = Math.floor(Math.abs(totalMinutosResultantes) / 60);
        this.mg1 = Math.abs(totalMinutosResultantes) % 60;
    


        // Determinar si la diferencia es negativa (menos horas trabajadas)
        let signo = totalMinutosResultantes < 0 ? "-" : "";

        this.informetrabajadorespdf[lug].HORAS_TRABAJADAS = 
        signo +
        (this.hg1 < 10 ? "0" + this.hg1 : this.hg1) +
        ":" +
        (this.mg1 < 10 ? "0" + this.mg1 : this.mg1);
        
    }
   

    if (this.informetrabajadorespdf[lug].DIA == "Fiesta") {
      this.informetrabajadorespdf[lug].HORAS_PREVISTAS = "0";
    }

  //if (this.informetrabajadorespdf[lug].HORAS_TRABAJADAS != "00:00") {
    this.informetrabajadorespdf[lug].COLOR = "NORMAL";

    // Convertir HORAS_PREVISTAS a minutos
    if (Number(this.informetrabajadorespdf[lug].HORAS_PREVISTAS)<0){
      this.informetrabajadorespdf[lug].HORAS_PREVISTAS = this.informetrabajadorespdf[lug].HORAS_PREVISTAS.substr(1);
    }
  
  
    horasPrevistas = Number(this.informetrabajadorespdf[lug].HORAS_PREVISTAS);


    if (horasPrevistas < 12){
      minutosPrevistos = Math.round(horasPrevistas * 60); // Redondear a minutos
    }else{
      minutosPrevistos = horasPrevistas ; // Redondear a minutos
    }

    
        // Extraer horas y minutos trabajados, considerando el signo
  let signoHorasTrabajadas = 1; 
  if (this.informetrabajadorespdf[lug].HORAS_TRABAJADAS.startsWith("-")) {
    signoHorasTrabajadas = -1;
    this.informetrabajadorespdf[lug].HORAS_TRABAJADAS = this.informetrabajadorespdf[lug].HORAS_TRABAJADAS.substring(1); // Eliminar el signo "-"

    this.hg = Number(this.informetrabajadorespdf[lug].HORAS_TRABAJADAS.substr(0, 2)) * signoHorasTrabajadas;
    this.mg = Number(this.informetrabajadorespdf[lug].HORAS_TRABAJADAS.substr(3, 2));

    this.informetrabajadorespdf[lug].HORAS_TRABAJADAS = "-" + this.informetrabajadorespdf[lug].HORAS_TRABAJADAS;

  }else{

    this.hg = Number(this.informetrabajadorespdf[lug].HORAS_TRABAJADAS.substr(0, 2)) * signoHorasTrabajadas;
    this.mg = Number(this.informetrabajadorespdf[lug].HORAS_TRABAJADAS.substr(3, 2));

  }



// Calcular total de minutos trabajados
let minutosTrabajados = this.hg * 60 + this.mg;

// Calcular la diferencia en minutos
diferenciaMinutos = minutosTrabajados - minutosPrevistos;

// Calcular horas y minutos a partir de la diferencia
this.hg1 = Math.floor(Math.abs(diferenciaMinutos) / 60);
this.mg1 = Math.abs(diferenciaMinutos) % 60;

// Determinar si la diferencia es negativa (menos horas trabajadas)
let signo = diferenciaMinutos < 0 ? "-" : "";

// Formatear el resultado
this.informetrabajadorespdf[lug].HORAS_EXTRAS =   signo +  (this.hg1 < 10 ? "0" + this.hg1 : this.hg1) +  ":" +  (this.mg1 < 10 ? "0" + this.mg1 : this.mg1);

      this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE =  this.informetrabajadorespdf[lug].HORAS_EXTRAS;


// Asegúrate de que `CORTESIA` sea el valor en minutos que defines como el umbral de cortesía
// por ejemplo: this.informetrabajadores[lug].CORTESIA

// Obtenemos el valor de la cortesía en minutos
const cortesíaMinutos = Number(this.informetrabajadorespdf[lug].CORTESIA);

// Verificamos si las HORAS_EXTRAS_CON_AJUSTE son negativas
if (this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE.substr(0, 1) === "-") {
  // Si es negativo, procesamos de la siguiente forma
  
  // Extraemos las horas y los minutos de HORAS_EXTRAS_CON_AJUSTE (el valor es negativo, pero lo tomamos en positivo)
  this.hg1 = Number(this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE.substr(1, 2)); // horas (sin el signo negativo)
  this.mg1 = Number(this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE.substr(4, 2)); // minutos

  // Calculamos el total de minutos de las horas extras (en valor absoluto)
  const totalMinutos = this.hg1 * 60 + this.mg1;

  // Comprobamos si el total de minutos es menor o igual a la cortesía
  if (totalMinutos <= cortesíaMinutos) {
    // Si los minutos están dentro del valor de cortesía, redondeamos a :00
    this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE = 
      "-" + this.hg1.toString().padStart(2, '0') + ":00"; // Redondeamos a la hora exacta con el signo negativo
  } else {
    // Si no están dentro del valor de cortesía, mantenemos el valor original
    this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE = 
      "-" + this.hg1.toString().padStart(2, '0') + ":" + this.mg1.toString().padStart(2, '0');
  }



} else {
  // Si es positivo o igual a cero, no hacemos nada
  // Extraemos las horas y los minutos de HORAS_EXTRAS_CON_AJUSTE
  this.hg1 = Number(this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE.substr(0, 2)); // horas
  this.mg1 = Number(this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE.substr(3, 2)); // minutos

  // Calculamos el total de minutos de las horas extras
  const totalMinutos = this.hg1 * 60 + this.mg1;

  // Comprobamos si el total de minutos es menor o igual a la cortesía
  if (totalMinutos <= cortesíaMinutos) {
    // Si los minutos están dentro del valor de cortesía, redondeamos a :00
    this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE = 
      this.hg1.toString().padStart(2, '0') + ":00"; // Redondeamos a la hora exacta
  }
  // Si no están dentro del valor de cortesía, mantenemos el valor original (no hay más lógica aquí)
}



// Nombre del turno del trabajador
const nombreTurno = (this.informetrabajadorespdf[lug].TURNO || "").toLowerCase();
// Buscar el objeto turno dentro de this.turnos
let turnoObj: any = null;
if (this.turnos && this.turnos.length) {
  turnoObj = this.turnos.find(
    (t: any) => ((t.NOMBRE || t.TURNO || "").toLowerCase() === nombreTurno)
  );
}
if (turnoObj) {
  const modo = turnoObj.MODO;  // ← aquí tienes el MODO del turno
  // Ejemplo: si es guardia y cierto modo, ajustar horas
  if (modo === "guardia") {
    //console.log("Turno:", nombreTurno, " - MODO:", modo);
    this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE = "00:00";
  }
} else {
  console.warn("No se encontró el turno en this.turnos para:", nombreTurno);
}

this.informetrabajadorespdf[lug].HORAS_EXTRAS = this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE;

  if (this.hg1 == 0) {
    if (this.mg1 >= -10 && this.mg1 <= 10) {
    } else {
      this.informetrabajadorespdf[lug].COLOR = "ROJO";
    }
  } else {
    this.informetrabajadorespdf[lug].COLOR = "ROJO";
  }
    



    } else {


      /*
          /////////////////
          |  modo pruebas |
          \\\\\\\\\\\\\\\\\
      */

      // Extraer horas y minutos de PICADA_FINAL y PICADA_INICIAL
      const picadaFinalParaCalculo = this.horaValida(this.informetrabajadorespdf[lug].PICADA_FINAL) ?
        this.informetrabajadorespdf[lug].PICADA_FINAL : "24:00";
      this.hg = picadaFinalParaCalculo.substr(0, 2);
      this.mg = picadaFinalParaCalculo.substr(3, 2);

      this.hp = this.informetrabajadorespdf[lug].PICADA_INICIAL.substr(0, 2);
      this.mp = this.informetrabajadorespdf[lug].PICADA_INICIAL.substr(3, 2);

      // Calcular la diferencia en minutos entre PICADA_FINAL y PICADA_INICIAL
      minutosFinal = Number(this.hg) * 60 + Number(this.mg);
      minutosInicial = Number(this.hp) * 60 + Number(this.mp);

      var diferenciaMinutos2 = minutosFinal - minutosInicial;

      // Calcular horas y minutos a partir de la diferencia
      this.hg1 = Math.floor(diferenciaMinutos2 / 60);
      this.mg1 = diferenciaMinutos2 % 60;

      // Formatear HORAS_TRANSCURRIDAS
      this.informetrabajadorespdf[lug].HORAS_TRANSCURRIDAS =
        (this.hg1 < 10 ? "0" + this.hg1 : this.hg1) +
        ":" +
        (this.mg1 < 10 ? "0" + this.mg1 : this.mg1);

        if (this.informetrabajadorespdf[lug].DIA == "Fiesta") {
          this.informetrabajadorespdf[lug].HORAS_PREVISTAS = "0";
        }

    
      // Convertir HORAS_PREVISTAS a minutos
    let horasPrevistas2 = Number(this.informetrabajadorespdf[lug].HORAS_PREVISTAS);
    let minutosPrevistos2 = 0;

    if (horasPrevistas2 < 24){
      minutosPrevistos2 = Math.round(horasPrevistas2 * 60); // Redondear a minutos
    }else{
      minutosPrevistos2 = horasPrevistas2 ; // Redondear a minutos
    }

    
    this.hg = this.informetrabajadorespdf[lug].HORAS_TRANSCURRIDAS.substr(0, 2);
    this.mg = this.informetrabajadorespdf[lug].HORAS_TRANSCURRIDAS.substr(3, 2);
    
    let totalminutostrabajados = Number(this.hg) * 60 + Number(this.mg); 

    // Calcular la diferencia en minutos entre HORAS_TRANSCURRIDAS y HORAS_PREVISTAS
    let diferenciaMinutos3 = totalminutostrabajados - minutosPrevistos2;



    // Calcular horas y minutos a partir de la diferencia
    this.hg1 = Math.floor(Math.abs(diferenciaMinutos3) / 60);
    this.mg1 = Math.abs(diferenciaMinutos3) % 60;

    this.informetrabajadorespdf[lug].HORAS_SIN_TRABAJAR =
    (this.hg1 < 10 ? "0" + this.hg1 : this.hg1) +
    ":" +
    (this.mg1 < 10 ? "0" + this.mg1 : this.mg1);


    if (diferenciaMinutos3 < Number(10)){
      this.informetrabajadorespdf[lug].HORAS_SIN_TRABAJAR = "00:00";
    }else{

      //BUSCO UN ICAJE ALEATORIO

      this.HIni = this.informetrabajadorespdf[lug].HORAS_SIN_TRABAJAR.substr(0, 2);
      this.MIni = this.informetrabajadorespdf[lug].HORAS_SIN_TRABAJAR.substr(3, 2);

      var minutosale = Number(this.HIni) * 60 + Number(this.MIni); 
      
      
      
      this.Aleatorio = this.variables.numeroAleatorio(-7, 7);

      if (Number(this.Aleatorio) > 0) {
        minutosale = Number(this.Aleatorio) + minutosale;
      }
      
      // Calcular horas y minutos a partir de la diferencia
      this.HIni = Math.floor(Math.abs(minutosale) / 60);
      this.MIni = Math.abs(minutosale) % 60;

      this.informetrabajadorespdf[lug].HORAS_SIN_TRABAJAR =
      (Math.abs(this.HIni) < 10 ? "0" + Number(this.HIni) : Number(this.HIni)) +
      ":" +
      (Math.abs((this.MIni)) < 10 ? "0" + this.MIni : this.MIni);
    }

    // En modo pruebas, separar el almuerzo del descanso adicional.
    const minutosAlmuerzoPruebaPdf = this.hhmmToMin(this.informetrabajadorespdf[lug].HORAS_ALMORZANDO);
    if (minutosAlmuerzoPruebaPdf > 0) {
      const minutosSinTrabajarTotalPdf = this.hhmmToMin(this.informetrabajadorespdf[lug].HORAS_SIN_TRABAJAR);
      const minutosSinTrabajarAdicionalPdf = Math.max(0, minutosSinTrabajarTotalPdf - minutosAlmuerzoPruebaPdf);
      this.informetrabajadorespdf[lug].HORAS_SIN_TRABAJAR = this.minToHHMM24(minutosSinTrabajarAdicionalPdf);
    }
    if (tienePausaRealMedianoche) {
      this.informetrabajadorespdf[lug].HORAS_SIN_TRABAJAR = this.minToHHMM24(minutosSinTrabajarReales);
    }

    this.hg = Number(this.informetrabajadorespdf[lug].HORAS_TRANSCURRIDAS.substr(0, 2));
    this.mg = Number(this.informetrabajadorespdf[lug].HORAS_TRANSCURRIDAS.substr(3, 2));
    
    this.hp = Number(this.informetrabajadorespdf[lug].HORAS_SIN_TRABAJAR.substr(0, 2));
    this.mp = Number(this.informetrabajadorespdf[lug].HORAS_SIN_TRABAJAR.substr(3, 2));




    
    // Calcular la diferencia en minutos
    minutosFinal = this.hg * 60 + this.mg;
    minutosInicial = this.hp * 60 + this.mp ;
    
    let diferenciaMinutos4 = (minutosFinal - minutosInicial - minutosAlmuerzoPruebaPdf);

    // Calcular horas y minutos a partir de la diferencia
    this.hg1 = Math.floor(diferenciaMinutos4 / 60);
    this.mg1 = diferenciaMinutos4 % 60;


    // Formatear HORAS_TRABAJADAS
    this.informetrabajadorespdf[lug].HORAS_TRABAJADAS =
      (this.hg1 < 10 ? "0" + this.hg1 : this.hg1) +
      ":" +
      (this.mg1 < 10 ? "0" + this.mg1 : this.mg1);

    this.informetrabajadorespdf[lug].COLOR = "NORMAL";
        
      // Convertir HORAS_PREVISTAS a minutos
      let horasPrevistas = Number(this.informetrabajadorespdf[lug].HORAS_PREVISTAS);
  
      let minutosPrevistos=0;

      if (horasPrevistas < 24){
        minutosPrevistos = Math.round(horasPrevistas * 60); // Redondear a minutos
      }else{
        minutosPrevistos = horasPrevistas ; // Redondear a minutos
      }
      
      
      // Calcular total de minutos trabajados (asumiendo que hg1 y mg1 ya contienen las horas y minutos trabajados)
      let minutosTrabajados = this.hg1 * 60 + this.mg1;
      
      // Calcular la diferencia en minutos
      let diferenciaMinutos = minutosTrabajados - minutosPrevistos;
      



      // Calcular horas y minutos a partir de la diferencia
      this.hg1 = Math.floor(Math.abs(diferenciaMinutos) / 60);
      this.mg1 = Math.abs(diferenciaMinutos) % 60;
      

      
      // Determinar si la diferencia es negativa (menos horas trabajadas)
      let signo = diferenciaMinutos < 0 ? "-" : "";
      
      // Asignar color según la diferencia de horas
      if (this.hg1 > 0) {
        this.informetrabajadorespdf[lug].COLOR = "ROJO";
      } else {
        if (this.mg1 > 30) {
          this.informetrabajadorespdf[lug].COLOR = "ROJO";
        }
      }



      
      // Formatear el resultado de HORAS_EXTRAS
      this.informetrabajadorespdf[lug].HORAS_EXTRAS =
        signo +
        (this.hg1 < 10 ? this.hg1 : this.hg1) +
        ":" +
        (this.mg1 < 10 ? "0" + this.mg1 : this.mg1);

        if (Number(this.informetrabajadorespdf[lug].CORTESIA!=0)){
          if (Math.abs(this.hg1)==0){
              if (Math.abs(this.mg1)<=Number(this.informetrabajadorespdf[lug].CORTESIA)){
              this.informetrabajadorespdf[lug].HORAS_EXTRAS = "0:00";
              }
          }
        } 

        this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE =
        this.informetrabajadorespdf[lug].HORAS_EXTRAS;

        const minFinal = this.hhmmToMin(this.informetrabajadorespdf[lug].PICADA_FINAL); 
        if(minFinal >= 1440){
           this.informetrabajadorespdf[lug].PICADA_FINAL = this.minToHHMM24(minFinal); 
        }

        this.informetrabajadorespdf[lug].COLOR = "NORMAL";



      if (this.hg1 - Number(this.informetrabajadorespdf[lug].HORAS_PREVISTAS) < 0) {

        this.hg1 = Number(this.informetrabajadorespdf[lug].HORAS_PREVISTAS) - this.hg1;
        if (this.mg1 > 0) {
          this.hg1 = Number(this.hg1) - 1;
          this.mg1 = 60 - this.mg1;
        }

        if (this.hg1 > 0) {
          this.informetrabajadorespdf[lug].COLOR = "ROJO";
        } else {
          if (this.mg1 > 30) {
            this.informetrabajadorespdf[lug].COLOR = "ROJO";
          }
        }

      
        // las horas extras negativas no se cuentan
        //this.informetrabajadorespdf[lug].HORAS_EXTRAS = "00:00";
        this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE =
          this.informetrabajadorespdf[lug].HORAS_EXTRAS;
      } else {

        if (Number(this.informetrabajadorespdf[lug].HORAS_PREVISTAS) != 0) {
          
          this.hg1 =  this.hg1 - Number(this.informetrabajadorespdf[lug].HORAS_PREVISTAS);

          if (this.hg1 > 0) {
            this.informetrabajadorespdf[lug].COLOR = "ROJO";
          } else {
            if (this.mg1 > 30) {
              this.informetrabajadorespdf[lug].COLOR = "ROJO";
            }
          }

          //this.informetrabajadorespdf[lug].HORAS_EXTRAS =            (this.hg1 < 10 ? "0" + this.hg1 : this.hg1) +            ":" +            (this.mg1 < 10 ? "0" + this.mg1 : this.mg1);
          //this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE =            this.informetrabajadorespdf[lug].HORAS_EXTRAS;
        } else {
          this.informetrabajadorespdf[lug].HORAS_TRABAJADAS = "00:00";
          this.informetrabajadorespdf[lug].HORAS_PARADAS =
            this.informetrabajadorespdf[lug].HORAS_TRANSCURRIDAS;
          this.informetrabajadorespdf[lug].HORAS_EXTRAS = "00:00";
          this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE =
            this.informetrabajadorespdf[lug].HORAS_EXTRAS;
        }
      }




 

    }

    if (hacerlo == "SI") {
        this.informetrabajadoressindetallespdf.push({
        PICO: "" + this.informetrabajadorespdf[lug].PICO,         
        INCIDENCIA: "" + this.informetrabajadorespdf[lug].INCIDENCIA,         
        FECHA: "" + this.informetrabajadorespdf[lug].FECHA,
        TURNO: "" + this.informetrabajadorespdf[lug].TURNO ,
        MODO: "" + (this.informetrabajadorespdf[lug].MODO || ""),
        DIA: "" + this.informetrabajadorespdf[lug].DIA,
        CODIGO: "" + this.informetrabajadorespdf[lug].CODIGO,
        NOMBRE: "" + this.informetrabajadorespdf[lug].NOMBRE,
        EMPRESA: "" + this.informetrabajadorespdf[lug].EMPRESA,
        OBRA: "" + this.informetrabajadorespdf[lug].OBRA,
        PICADA_INICIAL: "" + this.informetrabajadorespdf[lug].PICADA_INICIAL,
        PICADA_FINAL: "" + this.informetrabajadorespdf[lug].PICADA_FINAL,
        _PICADA_VIRTUAL_MEDIANOCHE: !!this.informetrabajadorespdf[lug]._PICADA_VIRTUAL_MEDIANOCHE,
        HORAS_TRANSCURRIDAS:
          "" + this.informetrabajadorespdf[lug].HORAS_TRANSCURRIDAS,
        HORAS_TRABAJADAS:
          "" + this.informetrabajadorespdf[lug].HORAS_TRABAJADAS,
        //N_TRABAJADAS: "" + htrab.toString().replace(".", ","),
        HORAS_PARADAS: "" + this.informetrabajadorespdf[lug].HORAS_PARADAS,
        HORAS_ALMORZANDO:
          "" + this.informetrabajadorespdf[lug].HORAS_ALMORZANDO,
        HORAS_EXTRAS:
          "" + this.informetrabajadorespdf[lug].HORAS_EXTRAS_CON_AJUSTE,
        PUESTO: "" + this.informetrabajadorespdf[lug].PUESTO,
        PRECIOHORA: "" + this.informetrabajadorespdf[lug].PRECIOHORA,
        HORAS_SIN_TRABAJAR:
          "" + this.informetrabajadorespdf[lug].HORAS_SIN_TRABAJAR,
      });
    }
  }

  calcularHorasMes(horasSemanales: number, year: number, month: number): string {
    // month: 1-12
    const dias = new Date(year, month, 0).getDate(); // nº de días del mes
  
    // Horas totales del mes (puede salir con decimales)
    const horasTotales = dias * (horasSemanales / 7);
  
    // Pasamos a minutos y redondeamos al minuto más cercano
    const minutosTotales = Math.round(horasTotales * 60);
  
    // Usamos tu función para devolver "HH:MM"
    return this.minutosAHoras(minutosTotales);
  }
  

}



// WEBPACK FOOTER //
// ./src/pages/list/list.ts